function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollegeProjectBro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M713.57,188S697.55,106.35,583,55.9,415.5,55.65,357.93,76.6,269.12,68.71,173,55.1-6.36,176.82,20.87,282.53,108.16,425.87,239.49,449.9s209-55.26,301.91-40.84S744.8,342.59,713.57,188Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.57,188S697.55,106.35,583,55.9,415.5,55.65,357.93,76.6,269.12,68.71,173,55.1-6.36,176.82,20.87,282.53,108.16,425.87,239.49,449.9s209-55.26,301.91-40.84S744.8,342.59,713.57,188Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M737.61,476.82H8.27a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H737.61a.5.5,0,0,1,.5.5A.5.5,0,0,1,737.61,476.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-475"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 669.6,
    y: 270.26,
    width: 2,
    height: 178.5,
    transform: "translate(-33.69 71.55) rotate(-5.96)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 671.67,
    y: 403.76,
    width: 2,
    height: 12.22,
    transform: "translate(-97.58 574.73) rotate(-43.44)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671,408.09a9.51,9.51,0,0,0-3.35-7.13c-2.15-1.92-13.5-6.7-14.58-2.7C651.93,402.61,663.55,411.14,671,408.09Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.56,409.22c-4.09,0-8.62-2.13-11.68-4.82-2.54-2.25-3.73-4.53-3.26-6.27a2.46,2.46,0,0,1,1.8-1.72c3.68-1.09,11.9,2.67,13.6,4.18a10,10,0,0,1,3.51,7.53l0,.31-.29.12A9.75,9.75,0,0,1,667.56,409.22Zm-11.59-12a4.41,4.41,0,0,0-1.27.16,1.45,1.45,0,0,0-1.11,1c-.36,1.32.78,3.33,2.95,5.26,3.69,3.25,9.62,5.66,14,4.09a9.25,9.25,0,0,0-3.17-6.4C665.83,400,659.55,397.21,656,397.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 665.38,
    y: 398.36,
    width: 0.5,
    height: 12.73,
    transform: "translate(-29.89 755.61) rotate(-58.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 673.78,
    y: 423.95,
    width: 2,
    height: 12.22,
    transform: "translate(-110.89 581.71) rotate(-43.44)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.13,428.28a9.52,9.52,0,0,0-3.34-7.13c-2.16-1.92-13.5-6.69-14.58-2.7C654,422.8,665.65,431.33,673.13,428.28Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.67,429.41c-4.09,0-8.63-2.13-11.68-4.82-2.54-2.25-3.73-4.53-3.26-6.27a2.46,2.46,0,0,1,1.79-1.72c3.68-1.09,11.91,2.67,13.6,4.18a10,10,0,0,1,3.51,7.53l0,.31-.29.12A9.47,9.47,0,0,1,669.67,429.41Zm-11.59-12a4.41,4.41,0,0,0-1.27.16,1.47,1.47,0,0,0-1.12,1c-.35,1.32.78,3.33,3,5.26,3.69,3.25,9.62,5.66,14,4.1a9.25,9.25,0,0,0-3.17-6.41C667.94,420.17,661.66,417.4,658.08,417.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667.48,
    y: 418.55,
    width: 0.5,
    height: 12.73,
    transform: "translate(-46.04 766.88) rotate(-58.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.53,
    y: 354.49,
    width: 2,
    height: 12.22,
    transform: "translate(-65.12 557.7) rotate(-43.44)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.88,358.82a9.52,9.52,0,0,0-3.34-7.13C660.39,349.77,649,345,648,349,646.79,353.34,658.4,361.87,665.88,358.82Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.42,360c-4.09,0-8.62-2.13-11.68-4.82-2.54-2.25-3.73-4.53-3.26-6.27a2.46,2.46,0,0,1,1.79-1.72c3.68-1.09,11.91,2.67,13.6,4.18a10,10,0,0,1,3.51,7.53l0,.31-.29.12A9.47,9.47,0,0,1,662.42,360Zm-11.59-12a4.41,4.41,0,0,0-1.27.16,1.47,1.47,0,0,0-1.12,1c-.35,1.32.78,3.33,3,5.26,3.69,3.25,9.62,5.66,14,4.09a9.25,9.25,0,0,0-3.17-6.4C660.69,350.71,654.41,347.94,650.83,347.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.23,
    y: 349.09,
    width: 0.5,
    height: 12.73,
    transform: "translate(9.47 727.96) rotate(-58.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 668.64,
    y: 374.68,
    width: 2,
    height: 12.22,
    transform: "translate(-78.43 564.64) rotate(-43.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668,379a9.52,9.52,0,0,0-3.34-7.13c-2.16-1.92-13.5-6.69-14.58-2.7C648.9,373.53,660.51,382.06,668,379Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.53,380.14c-4.09,0-8.63-2.13-11.68-4.82-2.54-2.25-3.73-4.53-3.26-6.27a2.43,2.43,0,0,1,1.79-1.72c3.69-1.09,11.91,2.67,13.6,4.18a10,10,0,0,1,3.51,7.53l0,.31-.29.12A9.51,9.51,0,0,1,664.53,380.14Zm-11.59-12a4.53,4.53,0,0,0-1.28.16,1.47,1.47,0,0,0-1.11,1c-.35,1.32.78,3.33,3,5.26,3.69,3.25,9.61,5.65,14,4.1a9.3,9.3,0,0,0-3.17-6.41C662.8,370.9,656.52,368.13,652.94,368.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 662.34,
    y: 369.28,
    width: 0.5,
    height: 12.73,
    transform: "translate(-6.65 739.3) rotate(-58.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 663.11,
    y: 321.69,
    width: 2,
    height: 12.22,
    transform: "translate(-43.52 546.33) rotate(-43.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.46,326a9.52,9.52,0,0,0-3.34-7.13c-2.16-1.92-13.5-6.69-14.58-2.7C643.37,320.54,655,329.07,662.46,326Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,327.15c-4.09,0-8.63-2.13-11.68-4.82-2.54-2.25-3.73-4.53-3.26-6.27a2.43,2.43,0,0,1,1.79-1.72c3.68-1.09,11.91,2.67,13.6,4.18a10,10,0,0,1,3.51,7.53l0,.31-.29.12A9.51,9.51,0,0,1,659,327.15Zm-11.59-12a4.53,4.53,0,0,0-1.28.16,1.47,1.47,0,0,0-1.11,1c-.35,1.32.78,3.33,3,5.26,3.69,3.25,9.61,5.65,14,4.1a9.3,9.3,0,0,0-3.17-6.41C657.27,317.91,651,315.14,647.41,315.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 656.81,
    y: 316.29,
    width: 0.5,
    height: 12.73,
    transform: "translate(35.72 709.65) rotate(-58.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.67,
    y: 288.75,
    width: 2,
    height: 12.22,
    transform: "translate(-21.78 535.02) rotate(-43.44)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,293.08a9.52,9.52,0,0,0-3.34-7.13c-2.16-1.92-13.5-6.7-14.58-2.7C639.93,287.6,651.54,296.13,659,293.08Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.56,294.21c-4.09,0-8.62-2.13-11.68-4.82-2.54-2.25-3.73-4.53-3.26-6.27a2.43,2.43,0,0,1,1.79-1.72c3.68-1.09,11.91,2.67,13.6,4.18a10,10,0,0,1,3.51,7.53l0,.31-.29.12A9.66,9.66,0,0,1,655.56,294.21ZM644,282.2a4.41,4.41,0,0,0-1.27.16,1.47,1.47,0,0,0-1.12,1c-.35,1.32.78,3.33,3,5.26,3.69,3.25,9.62,5.65,14,4.09a9.3,9.3,0,0,0-3.17-6.4C653.83,285,647.55,282.2,644,282.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 653.37,
    y: 283.35,
    width: 0.5,
    height: 12.73,
    transform: "translate(62.04 691.2) rotate(-58.07)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.55,
    y: 396.15,
    width: 12.22,
    height: 2,
    transform: "translate(-14.57 768.27) rotate(-58.5)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M679.9,395.07a9.49,9.49,0,0,1,1.8-7.66c1.71-2.33,11.83-9.35,13.71-5.66C697.45,385.76,687.85,396.51,679.9,395.07Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.37,395.7a9,9,0,0,1-1.56-.14l-.31-.06-.08-.3a9.9,9.9,0,0,1,1.88-8.09c1.34-1.83,8.64-7.17,12.44-6.9a2.43,2.43,0,0,1,2.11,1.32c.82,1.6.13,4.08-1.9,6.8C691.08,392.19,686,395.7,681.37,395.7Zm-1-1.07c4.6.62,9.89-2.95,12.83-6.9,1.74-2.33,2.43-4.53,1.81-5.75a1.44,1.44,0,0,0-1.3-.77c-3.22-.27-10.19,4.64-11.56,6.49A9.29,9.29,0,0,0,680.32,394.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.04,
    y: 390.17,
    width: 13.45,
    height: 0.5,
    transform: "translate(-79.92 581.7) rotate(-43.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 667,
    y: 343.01,
    width: 12.22,
    height: 2,
    transform: "translate(28.08 738.17) rotate(-58.5)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.36,341.93a9.49,9.49,0,0,1,1.8-7.66c1.71-2.33,11.82-9.34,13.7-5.65C691.91,332.63,682.3,343.38,674.36,341.93Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.82,342.56a8.93,8.93,0,0,1-1.55-.13l-.31-.06-.09-.3a10,10,0,0,1,1.88-8.09c1.35-1.83,8.61-7.2,12.45-6.9a2.45,2.45,0,0,1,2.11,1.31c.81,1.61.12,4.09-1.9,6.81C685.54,339.05,680.49,342.56,675.82,342.56Zm-1-1.06c4.59.62,9.89-2.95,12.83-6.9,1.73-2.33,2.43-4.54,1.81-5.76a1.47,1.47,0,0,0-1.3-.76c-3.2-.27-10.2,4.63-11.56,6.49A9.25,9.25,0,0,0,674.78,341.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 672.49,
    y: 337.04,
    width: 13.46,
    height: 0.5,
    transform: "translate(-44.73 563.13) rotate(-43.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 664.56,
    y: 319.66,
    width: 12.22,
    height: 2,
    transform: "translate(46.83 724.95) rotate(-58.5)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.92,318.58a9.49,9.49,0,0,1,1.8-7.66c1.71-2.33,11.83-9.34,13.71-5.65C689.47,309.28,679.87,320,671.92,318.58Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M673.38,319.21a8.93,8.93,0,0,1-1.55-.13l-.31-.06-.08-.3a9.9,9.9,0,0,1,1.88-8.09c1.34-1.83,8.62-7.21,12.44-6.9a2.44,2.44,0,0,1,2.11,1.31c.82,1.61.13,4.09-1.9,6.81C683.1,315.7,678.06,319.21,673.38,319.21Zm-1-1.06c4.6.62,9.89-2.95,12.83-6.9,1.74-2.33,2.43-4.54,1.81-5.75a1.45,1.45,0,0,0-1.3-.77c-3.2-.22-10.19,4.63-11.56,6.49A9.29,9.29,0,0,0,672.34,318.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 670.05,
    y: 313.69,
    width: 13.46,
    height: 0.5,
    transform: "translate(-29.26 554.97) rotate(-43.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 660.99,
    y: 285.43,
    width: 12.22,
    height: 2,
    transform: "translate(74.31 705.56) rotate(-58.5)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M668.35,284.35a9.49,9.49,0,0,1,1.8-7.66c1.71-2.33,11.82-9.34,13.7-5.65C685.9,275.05,676.3,285.8,668.35,284.35Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.81,285a8.93,8.93,0,0,1-1.55-.13l-.31-.06-.09-.3a10,10,0,0,1,1.88-8.09c1.35-1.83,8.62-7.22,12.45-6.9a2.45,2.45,0,0,1,2.11,1.31c.82,1.61.12,4.09-1.9,6.81C679.53,281.47,674.48,285,669.81,285Zm-1-1.07c4.6.63,9.89-2.94,12.83-6.89,1.73-2.33,2.43-4.54,1.81-5.76a1.46,1.46,0,0,0-1.3-.76c-3.22-.27-10.19,4.63-11.56,6.49A9.23,9.23,0,0,0,668.77,283.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 666.48,
    y: 279.46,
    width: 13.46,
    height: 0.5,
    transform: "translate(-6.59 543) rotate(-43.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.18,269.75a9.49,9.49,0,0,1,1.8-7.66c1.71-2.33,11.82-9.34,13.7-5.65C678.73,260.45,669.13,271.2,661.18,269.75Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.64,270.38a8.93,8.93,0,0,1-1.55-.13l-.31-.06-.09-.3a10,10,0,0,1,1.88-8.09c1.35-1.83,8.61-7.22,12.45-6.9a2.45,2.45,0,0,1,2.11,1.31c.82,1.61.12,4.09-1.9,6.81C672.36,266.87,667.31,270.38,662.64,270.38Zm-1-1.07c4.6.63,9.89-2.94,12.83-6.89,1.73-2.33,2.43-4.54,1.81-5.75a1.45,1.45,0,0,0-1.3-.77c-3.2-.25-10.2,4.63-11.56,6.49A9.23,9.23,0,0,0,661.6,269.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.31,
    y: 264.86,
    width: 13.45,
    height: 0.5,
    transform: "translate(1.52 533.99) rotate(-43.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.74,270.16a9.51,9.51,0,0,1-7.43-2.6c-2.14-1.94-8-12.74-4.19-14.22C654.33,251.73,664,262.4,661.74,270.16Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.87,270.71a10.27,10.27,0,0,1-6.9-2.78c-1.68-1.53-6.26-9.32-5.55-13.1a2.44,2.44,0,0,1,1.52-2c1.68-.65,4.08.3,6.57,2.6,3.93,3.63,7.16,9.88,5.71,14.83l-.09.3-.31,0A6,6,0,0,1,660.87,270.71Zm-9.82-17a2.27,2.27,0,0,0-.75.13,1.47,1.47,0,0,0-.9,1.22c-.6,3.17,3.54,10.62,5.25,12.17a9.24,9.24,0,0,0,6.7,2.5c1.1-4.5-1.9-10.15-5.52-13.48C654.08,254.59,652.33,253.67,651.05,253.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "661.54 270.31 653.32 259.66 653.71 259.35 661.94 270 661.54 270.31",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 611.74,
    y: 382.96,
    width: 178.5,
    height: 2,
    transform: "translate(246.56 1041.46) rotate(-84.06)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 691.65,
    y: 427.56,
    width: 2,
    height: 12.22,
    transform: "translate(-124.53 426.54) rotate(-31.55)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.41,431.59a9.52,9.52,0,0,0-1.81-7.66c-1.71-2.33-11.83-9.34-13.71-5.65C673.85,422.3,683.46,433,691.41,431.59Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.93,432.22c-4.67,0-9.71-3.51-12.58-7.36-2-2.72-2.72-5.2-1.9-6.8a2.42,2.42,0,0,1,2.1-1.31c3.83-.36,11.11,5.06,12.45,6.88a10,10,0,0,1,1.89,8.09l-.08.31-.31.05A8.26,8.26,0,0,1,689.93,432.22Zm-12-14.49h-.26a1.45,1.45,0,0,0-1.3.77c-.62,1.22.07,3.42,1.81,5.75,2.94,3.95,8.24,7.53,12.84,6.89a9.25,9.25,0,0,0-1.79-6.92C687.87,422.42,681.22,417.73,677.9,417.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "691.23 431.77 682.05 422.96 682.4 422.6 691.58 431.41 691.23 431.77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 696.77,
    y: 378.29,
    width: 2,
    height: 12.22,
    transform: "translate(-97.99 421.98) rotate(-31.55)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.52,382.32a9.53,9.53,0,0,0-1.8-7.66C693,372.33,682.88,365.32,681,369,679,373,688.57,383.77,696.52,382.32Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.05,383c-4.67,0-9.72-3.51-12.59-7.36-2-2.72-2.72-5.2-1.9-6.81a2.46,2.46,0,0,1,2.11-1.31c3.84-.35,11.1,5.06,12.45,6.89a9.9,9.9,0,0,1,1.88,8.09l-.08.3-.31.06A9,9,0,0,1,695.05,383Zm-12-14.49h-.26a1.45,1.45,0,0,0-1.3.77c-.62,1.21.08,3.42,1.81,5.75,2.94,3.95,8.23,7.52,12.84,6.89a9.27,9.27,0,0,0-1.79-6.93C693,373.15,686.33,368.46,683,368.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "696.35 382.5 687.16 373.69 687.51 373.32 696.69 382.14 696.35 382.5",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 694.67,
    y: 398.48,
    width: 2,
    height: 12.22,
    transform: "translate(-108.87 423.85) rotate(-31.55)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.42,402.51a9.49,9.49,0,0,0-1.8-7.66c-1.71-2.33-11.83-9.34-13.71-5.65C676.87,393.22,686.48,404,694.42,402.51Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693,403.14c-4.67,0-9.71-3.51-12.58-7.36-2-2.72-2.72-5.2-1.91-6.8a2.46,2.46,0,0,1,2.11-1.32c3.85-.34,11.11,5.07,12.45,6.89a10,10,0,0,1,1.89,8.09l-.09.31-.31.05A8.08,8.08,0,0,1,693,403.14Zm-12-14.49h-.26a1.46,1.46,0,0,0-1.31.77c-.61,1.22.08,3.42,1.82,5.75,2.94,3.95,8.24,7.52,12.83,6.89a9.27,9.27,0,0,0-1.78-6.92C690.89,393.34,684.24,388.65,680.92,388.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "694.25 402.69 685.07 393.88 685.41 393.52 694.6 402.33 694.25 402.69",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700.17,
    y: 345.49,
    width: 2,
    height: 12.22,
    transform: "translate(-80.32 418.89) rotate(-31.55)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.92,349.52a9.49,9.49,0,0,0-1.8-7.66c-1.71-2.33-11.84-9.34-13.71-5.65C682.37,340.22,692,351,699.92,349.52Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.45,350.15c-4.67,0-9.71-3.51-12.58-7.36-2-2.72-2.72-5.2-1.91-6.81a2.47,2.47,0,0,1,2.11-1.31c3.85-.35,11.11,5.06,12.45,6.89a10,10,0,0,1,1.89,8.09l-.09.3L700,350A9,9,0,0,1,698.45,350.15Zm-12-14.49h-.26a1.46,1.46,0,0,0-1.3.77c-.61,1.21.08,3.42,1.82,5.75,2.94,3.95,8.24,7.52,12.83,6.89a9.29,9.29,0,0,0-1.78-6.93C696.39,340.34,689.73,335.66,686.41,335.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "699.75 349.7 690.57 340.89 690.91 340.52 700.1 349.34 699.75 349.7",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 703.59,
    y: 312.54,
    width: 2,
    height: 12.22,
    transform: "translate(-62.58 415.83) rotate(-31.55)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.34,316.57a9.49,9.49,0,0,0-1.8-7.66c-1.72-2.33-11.84-9.33-13.71-5.64C685.79,307.28,695.39,318,703.34,316.57Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.87,317.2c-4.67,0-9.71-3.5-12.59-7.36-2-2.72-2.71-5.2-1.9-6.8a2.45,2.45,0,0,1,2.11-1.31c3.83-.35,11.1,5.06,12.45,6.89a9.9,9.9,0,0,1,1.88,8.09l-.08.3-.31.05A8.08,8.08,0,0,1,701.87,317.2Zm-12-14.49h-.26a1.49,1.49,0,0,0-1.3.77c-.62,1.22.08,3.42,1.82,5.76,2.94,3.94,8.23,7.52,12.83,6.88a9.25,9.25,0,0,0-1.79-6.92C699.8,307.4,693.15,302.71,689.83,302.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "703.17 316.75 693.98 307.94 694.33 307.58 703.51 316.39 703.17 316.75",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 695.02,
    y: 421.46,
    width: 12.22,
    height: 2,
    transform: "translate(-87.62 641.37) rotate(-46.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.77,420.68a9.52,9.52,0,0,1,3.34-7.13c2.16-1.93,13.5-6.71,14.58-2.71C721.86,415.18,710.25,423.73,702.77,420.68Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.23,421.81a9.7,9.7,0,0,1-3.65-.67l-.29-.12,0-.31a10,10,0,0,1,3.51-7.53c1.93-1.73,10.07-5.24,13.6-4.19a2.46,2.46,0,0,1,1.79,1.72c.47,1.74-.72,4-3.26,6.27C714.86,419.68,710.32,421.81,706.23,421.81Zm-3-1.48c4.37,1.56,10.29-.84,14-4.1,2.18-1.93,3.31-3.94,3-5.26a1.45,1.45,0,0,0-1.12-1c-3.1-.92-10.93,2.44-12.65,4A9.33,9.33,0,0,0,703.27,420.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 701.76,
    y: 416.88,
    width: 13.45,
    height: 0.5,
    transform: "translate(-113.47 435.5) rotate(-31.77)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 700.53,
    y: 368.32,
    width: 12.22,
    height: 2,
    transform: "translate(-47.3 628.76) rotate(-46.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M708.29,367.54a9.5,9.5,0,0,1,3.33-7.13c2.16-1.92,13.5-6.7,14.58-2.71C727.38,362.05,715.77,370.59,708.29,367.54Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.74,368.67a9.61,9.61,0,0,1-3.64-.67l-.29-.12,0-.31a9.93,9.93,0,0,1,3.5-7.53c1.69-1.51,9.91-5.28,13.6-4.19a2.44,2.44,0,0,1,1.79,1.72c.47,1.74-.71,4-3.25,6.27C720.37,366.54,715.84,368.67,711.74,368.67Zm-3-1.47c4.36,1.55,10.29-.85,14-4.11,2.18-1.92,3.32-3.94,3-5.26a1.48,1.48,0,0,0-1.11-1c-3.1-.92-10.93,2.44-12.65,4A9.25,9.25,0,0,0,708.79,367.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.27,
    y: 363.74,
    width: 13.46,
    height: 0.5,
    transform: "translate(-84.67 430.45) rotate(-31.77)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 702.95,
    y: 344.97,
    width: 12.22,
    height: 2,
    transform: "translate(-29.58 623.22) rotate(-46.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.71,344.19a9.52,9.52,0,0,1,3.34-7.13c2.15-1.92,13.5-6.7,14.58-2.71C729.8,338.7,718.19,347.24,710.71,344.19Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.16,345.32a9.65,9.65,0,0,1-3.64-.67l-.29-.12,0-.31a9.93,9.93,0,0,1,3.5-7.53c1.7-1.51,9.92-5.28,13.6-4.19a2.46,2.46,0,0,1,1.8,1.72c.47,1.74-.72,4-3.26,6.27C722.79,343.19,718.26,345.32,714.16,345.32Zm-2.95-1.47c4.36,1.55,10.29-.85,14-4.11,2.18-1.93,3.31-3.94,2.95-5.26a1.45,1.45,0,0,0-1.11-1c-3.1-.92-10.93,2.44-12.65,4A9.25,9.25,0,0,0,711.21,343.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.7,
    y: 340.39,
    width: 13.46,
    height: 0.5,
    transform: "translate(-72.01 428.22) rotate(-31.77)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 706.51,
    y: 310.73,
    width: 12.22,
    height: 2,
    transform: "translate(-3.61 615.09) rotate(-46.58)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.26,310a9.52,9.52,0,0,1,3.34-7.13c2.15-1.93,13.5-6.71,14.58-2.71C733.35,304.46,721.74,313,714.26,310Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M717.72,311.09a9.7,9.7,0,0,1-3.65-.67l-.29-.12,0-.31a10,10,0,0,1,3.51-7.53c1.69-1.52,9.91-5.28,13.6-4.19a2.46,2.46,0,0,1,1.79,1.72c.47,1.74-.72,4-3.26,6.27C726.35,309,721.81,311.09,717.72,311.09Zm-3-1.48c4.37,1.56,10.29-.85,14-4.1,2.18-1.93,3.31-3.94,3-5.26a1.47,1.47,0,0,0-1.12-1c-3.1-.92-10.93,2.44-12.65,4A9.26,9.26,0,0,0,714.76,309.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "714.39 310.17 714.13 309.74 725.56 302.65 725.83 303.07 714.39 310.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.25,294.19a9.51,9.51,0,0,1,3.34-7.12c2.15-1.93,13.5-6.71,14.58-2.71C729.34,288.7,717.73,297.24,710.25,294.19Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M713.71,295.33a9.7,9.7,0,0,1-3.65-.67l-.29-.12,0-.32a10,10,0,0,1,3.51-7.53c1.69-1.51,9.92-5.27,13.59-4.18a2.44,2.44,0,0,1,1.8,1.72c.47,1.73-.72,4-3.26,6.26C722.34,293.19,717.8,295.33,713.71,295.33Zm-3-1.48c4.37,1.55,10.29-.85,14-4.11,2.18-1.92,3.31-3.94,2.95-5.25a1.44,1.44,0,0,0-1.11-1c-3.09-.93-10.93,2.43-12.65,4A9.22,9.22,0,0,0,710.75,293.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.24,
    y: 290.4,
    width: 13.46,
    height: 0.5,
    transform: "translate(-45.76 420.49) rotate(-31.77)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.72,294.7a9.51,9.51,0,0,1-6.74-4.07c-1.69-2.34-5.25-14.12-1.17-14.78C707.26,275.14,714.54,287.58,710.72,294.7Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711,295.22l-.31,0a10,10,0,0,1-7.12-4.27c-1.33-1.85-4.21-10.42-2.74-14a2.44,2.44,0,0,1,1.9-1.6c1.78-.28,3.92,1.14,5.89,3.9,3.1,4.35,5,11.14,2.53,15.68Zm-7.82-18.9a1.53,1.53,0,0,0-.3,0,1.47,1.47,0,0,0-1.13,1c-1.24,3,1.28,11.12,2.63,13a9.23,9.23,0,0,0,6,3.83c2-4.18.24-10.32-2.62-14.33C706.24,277.63,704.5,276.32,703.19,276.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.54,
    y: 281.92,
    width: 0.5,
    height: 13.46,
    transform: "translate(-55.07 336.88) rotate(-25.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 688.09,
    y: 222.89,
    width: 2,
    height: 224.52,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.55,
    y: 402.7,
    width: 2,
    height: 12.22,
    transform: "translate(-107.24 501.46) rotate(-37.47)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.1,406.87a9.55,9.55,0,0,0-2.59-7.44c-1.94-2.13-12.73-8.06-14.22-4.2C665.67,399.43,676.34,409.13,684.1,406.87Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.68,407.7c-4.39,0-9.24-2.79-12.26-6.07-2.3-2.5-3.24-4.9-2.6-6.58a2.45,2.45,0,0,1,2-1.52c3.6-.69,11.35,3.65,13.09,5.57a9.92,9.92,0,0,1,2.71,7.85l-.05.31-.31.09A9,9,0,0,1,681.68,407.7Zm-12-13.24a3.69,3.69,0,0,0-.68.05,1.44,1.44,0,0,0-1.21.9c-.49,1.28.43,3.4,2.4,5.54,3.33,3.62,9,6.62,13.47,5.52a9.3,9.3,0,0,0-2.49-6.7C679.69,398.18,673.1,394.46,669.65,394.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.82,
    y: 396.6,
    width: 0.5,
    height: 12.73,
    transform: "translate(-55.98 691.43) rotate(-52.11)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.55,
    y: 360.51,
    width: 2,
    height: 12.22,
    transform: "translate(-81.57 492.75) rotate(-37.47)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.1,364.67a9.53,9.53,0,0,0-2.59-7.43c-1.94-2.14-12.73-8.06-14.22-4.2C665.67,357.24,676.34,366.94,684.1,364.67Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.68,365.5c-4.39,0-9.24-2.79-12.26-6.07-2.3-2.49-3.24-4.89-2.6-6.57a2.44,2.44,0,0,1,2-1.52c3.77-.73,11.56,3.88,13.09,5.56a9.94,9.94,0,0,1,2.71,7.86l-.05.31-.31.08A9,9,0,0,1,681.68,365.5Zm-12-13.24a3.66,3.66,0,0,0-.68.06,1.44,1.44,0,0,0-1.21.9c-.49,1.27.43,3.39,2.4,5.53,3.33,3.63,9,6.63,13.47,5.53a9.23,9.23,0,0,0-2.49-6.7C679.69,356,673.1,352.26,669.65,352.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.82,
    y: 354.4,
    width: 0.5,
    height: 12.73,
    transform: "translate(-22.68 675.14) rotate(-52.11)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.55,
    y: 310.97,
    width: 2,
    height: 12.22,
    transform: "translate(-51.43 482.53) rotate(-37.47)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.1,315.14a9.55,9.55,0,0,0-2.59-7.44c-1.94-2.14-12.73-8.06-14.22-4.2C665.67,307.7,676.34,317.4,684.1,315.14Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.68,316c-4.39,0-9.24-2.79-12.26-6.08-2.3-2.49-3.24-4.89-2.6-6.57a2.45,2.45,0,0,1,2-1.52c3.77-.71,11.56,3.89,13.09,5.57a9.92,9.92,0,0,1,2.71,7.85l-.05.31-.31.09A9,9,0,0,1,681.68,316Zm-12-13.25a3.66,3.66,0,0,0-.68.06,1.44,1.44,0,0,0-1.21.9c-.49,1.28.42,3.4,2.39,5.54,3.34,3.62,9,6.62,13.48,5.52a9.25,9.25,0,0,0-2.49-6.7C679.69,306.45,673.1,302.72,669.65,302.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.82,
    y: 304.86,
    width: 0.5,
    height: 12.73,
    transform: "translate(16.41 656.03) rotate(-52.11)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.55,
    y: 277.99,
    width: 2,
    height: 12.22,
    transform: "translate(-31.37 475.72) rotate(-37.47)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.1,282.16a9.52,9.52,0,0,0-2.59-7.43c-1.94-2.14-12.73-8.07-14.22-4.21C665.67,274.73,676.34,284.42,684.1,282.16Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.68,283c-4.39,0-9.24-2.79-12.26-6.07-2.3-2.5-3.24-4.89-2.6-6.58a2.45,2.45,0,0,1,2-1.52c3.6-.68,11.35,3.65,13.09,5.57a9.92,9.92,0,0,1,2.71,7.85l-.05.31-.31.09A9,9,0,0,1,681.68,283Zm-12-13.24a4.83,4.83,0,0,0-.68.05,1.46,1.46,0,0,0-1.21.9c-.49,1.28.43,3.4,2.4,5.54,3.33,3.62,9,6.62,13.47,5.53a9.31,9.31,0,0,0-2.49-6.71C679.69,273.47,673.1,269.75,669.65,269.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.82,
    y: 271.89,
    width: 0.5,
    height: 12.73,
    transform: "translate(42.44 643.3) rotate(-52.11)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 684.55,
    y: 244.87,
    width: 2,
    height: 12.22,
    transform: "translate(-11.22 468.87) rotate(-37.47)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.1,249a9.55,9.55,0,0,0-2.59-7.44c-1.94-2.13-12.73-8.06-14.22-4.2C665.67,241.6,676.34,251.3,684.1,249Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.68,249.87c-4.39,0-9.24-2.79-12.26-6.07-2.3-2.5-3.24-4.9-2.6-6.58a2.45,2.45,0,0,1,2-1.52c3.77-.71,11.56,3.89,13.09,5.57a9.92,9.92,0,0,1,2.71,7.85l-.05.31-.31.09A9,9,0,0,1,681.68,249.87Zm-12-13.24a3.69,3.69,0,0,0-.68.05,1.46,1.46,0,0,0-1.21.9c-.49,1.28.43,3.4,2.4,5.54,3.33,3.62,9,6.62,13.47,5.52a9.25,9.25,0,0,0-2.49-6.7C679.69,240.35,673.1,236.63,669.65,236.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 678.82,
    y: 238.77,
    width: 0.5,
    height: 12.73,
    transform: "translate(68.58 630.52) rotate(-52.11)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.71,
    y: 420.69,
    width: 12.22,
    height: 2,
    transform: "translate(-63.3 715.12) rotate(-52.54)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.27,419.75a9.52,9.52,0,0,1,2.59-7.43c1.94-2.14,12.73-8.07,14.22-4.2C712.69,412.32,702,422,694.27,419.75Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.69,420.58a9.09,9.09,0,0,1-2.56-.35l-.3-.09-.05-.31a9.92,9.92,0,0,1,2.71-7.85c1.52-1.68,9.32-6.27,13.09-5.57a2.48,2.48,0,0,1,2,1.53c.64,1.68-.3,4.07-2.6,6.57C705.93,417.79,701.08,420.58,696.69,420.58Zm-2-1.22c4.5,1.1,10.14-1.91,13.47-5.53,2-2.14,2.89-4.26,2.4-5.53a1.44,1.44,0,0,0-1.21-.9c-3.17-.61-10.62,3.55-12.17,5.25A9.26,9.26,0,0,0,694.74,419.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "694.43 419.95 694.12 419.56 704.76 411.32 705.07 411.71 694.43 419.95",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.71,
    y: 353.58,
    width: 12.22,
    height: 2,
    transform: "translate(-10.04 688.83) rotate(-52.54)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.27,352.65a9.55,9.55,0,0,1,2.59-7.44c1.94-2.14,12.73-8.06,14.22-4.2C712.69,345.21,702,354.91,694.27,352.65Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.69,353.48a9.09,9.09,0,0,1-2.56-.35l-.3-.09-.05-.31a9.92,9.92,0,0,1,2.71-7.85c1.52-1.68,9.32-6.28,13.09-5.57a2.47,2.47,0,0,1,2,1.52c.64,1.68-.3,4.08-2.6,6.57C705.93,350.68,701.08,353.48,696.69,353.48Zm-2-1.23c4.5,1.1,10.14-1.9,13.47-5.53,2-2.14,2.89-4.26,2.4-5.53a1.45,1.45,0,0,0-1.21-.9c-3.17-.61-10.62,3.55-12.17,5.26A9.23,9.23,0,0,0,694.74,352.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "694.43 352.84 694.12 352.45 704.76 344.21 705.07 344.61 694.43 352.84",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.71,
    y: 320.46,
    width: 12.22,
    height: 2,
    transform: "translate(16.25 675.86) rotate(-52.54)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.27,319.52a9.53,9.53,0,0,1,2.59-7.43c1.94-2.14,12.73-8.06,14.22-4.2C712.69,312.09,702,321.79,694.27,319.52Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.69,320.35a9.09,9.09,0,0,1-2.56-.35l-.3-.08-.05-.31a9.94,9.94,0,0,1,2.71-7.86c1.52-1.67,9.32-6.27,13.09-5.56a2.47,2.47,0,0,1,2,1.52c.64,1.68-.3,4.08-2.6,6.57C705.93,317.56,701.08,320.35,696.69,320.35Zm-2-1.22c4.49,1.1,10.14-1.9,13.47-5.52,2-2.15,2.89-4.27,2.4-5.54a1.45,1.45,0,0,0-1.21-.9c-3.17-.61-10.62,3.55-12.17,5.26A9.23,9.23,0,0,0,694.74,319.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "694.43 319.72 694.12 319.33 704.76 311.09 705.07 311.48 694.43 319.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.71,
    y: 276.69,
    width: 12.22,
    height: 2,
    transform: "translate(51 658.71) rotate(-52.54)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.27,275.75a9.55,9.55,0,0,1,2.59-7.44c1.94-2.14,12.73-8.06,14.22-4.2C712.69,268.31,702,278,694.27,275.75Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.69,276.58a9.09,9.09,0,0,1-2.56-.35l-.3-.09-.05-.31a9.92,9.92,0,0,1,2.71-7.85c1.52-1.68,9.32-6.28,13.09-5.57a2.47,2.47,0,0,1,2,1.52c.64,1.68-.3,4.08-2.6,6.57C705.93,273.79,701.08,276.58,696.69,276.58Zm-2-1.23c4.49,1.1,10.14-1.9,13.47-5.52,2-2.14,2.89-4.26,2.4-5.54a1.45,1.45,0,0,0-1.21-.9c-3.17-.6-10.62,3.55-12.17,5.26A9.25,9.25,0,0,0,694.74,275.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "694.43 275.94 694.12 275.55 704.76 267.31 705.07 267.71 694.43 275.94",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 686.71,
    y: 242.27,
    width: 12.22,
    height: 2,
    transform: "translate(78.32 645.22) rotate(-52.54)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M694.27,241.33a9.52,9.52,0,0,1,2.59-7.43c1.94-2.14,12.73-8.07,14.22-4.2C712.69,233.9,702,243.59,694.27,241.33Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M696.69,242.16a9.09,9.09,0,0,1-2.56-.35l-.3-.09-.05-.31a9.92,9.92,0,0,1,2.71-7.85c1.52-1.68,9.32-6.27,13.09-5.57a2.46,2.46,0,0,1,2,1.53c.64,1.68-.3,4.07-2.6,6.57C705.93,239.37,701.08,242.16,696.69,242.16Zm-2-1.22c4.49,1.09,10.14-1.91,13.47-5.53,2-2.14,2.89-4.26,2.4-5.54a1.45,1.45,0,0,0-1.21-.89c-3.17-.6-10.62,3.55-12.17,5.25A9.26,9.26,0,0,0,694.74,240.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 692.86,
    y: 236.96,
    width: 13.46,
    height: 0.5,
    transform: "translate(1.36 478.4) rotate(-37.79)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.66,226.07a9.52,9.52,0,0,1,2.58-7.44c2-2.14,12.74-8.06,14.22-4.2C707.08,218.63,696.41,228.33,688.66,226.07Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.07,226.9a9.45,9.45,0,0,1-2.55-.35l-.3-.09-.06-.31a10,10,0,0,1,2.71-7.85c1.53-1.68,9.32-6.29,13.1-5.57a2.44,2.44,0,0,1,2,1.52c.65,1.68-.3,4.08-2.6,6.57C700.31,224.1,695.46,226.9,691.07,226.9Zm-2-1.23c4.5,1.1,10.15-1.9,13.48-5.52,2-2.14,2.89-4.27,2.4-5.54a1.47,1.47,0,0,0-1.22-.9c-3.16-.6-10.62,3.55-12.17,5.26A9.22,9.22,0,0,0,689.12,225.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 687.25,
    y: 221.7,
    width: 13.45,
    height: 0.5,
    transform: "translate(9.54 471.76) rotate(-37.79)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.18,226.52a9.51,9.51,0,0,1-7.13-3.35c-1.92-2.16-6.68-13.51-2.68-14.58C683.72,207.42,692.24,219.05,689.18,226.52Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689,227a10.06,10.06,0,0,1-7.33-3.53c-1.51-1.69-5.26-9.92-4.16-13.6a2.43,2.43,0,0,1,1.72-1.79c1.74-.47,4,.72,6.26,3.27,3.54,4,6.09,10.57,4.14,15.33l-.12.29-.31,0Zm-9-18a2.07,2.07,0,0,0-.5.06,1.45,1.45,0,0,0-1,1.12c-.93,3.09,2.41,10.93,3.95,12.65a9.28,9.28,0,0,0,6.4,3.18c1.57-4.36-.83-10.29-4.08-14C683.06,210.12,681.3,209,680,209Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.39,
    y: 214.07,
    width: 0.5,
    height: 13.46,
    transform: "translate(-13.65 393.58) rotate(-31.73)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "698.32 475.73 674.55 475.73 671.57 445.59 701.3 445.59 698.32 475.73",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M698.78,476.23H674.09L671,445.09h30.83Zm-23.78-1h22.87l2.87-29.14H672.13Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M734.15,115.12H603.77a.5.5,0,0,1-.49-.37.51.51,0,0,1,.23-.56l4-2.37c3.53-2.12,7.53.35,8.84,1.3a32.35,32.35,0,0,1,7.73-7.61c3-2,5.69-.8,7.85.18,1.53.69,2.5,1.09,3.22.61a10.6,10.6,0,0,0,2.28-3.1c1.61-2.7,3.82-6.41,8.09-8,3.09-1.16,5.87-.34,8.09.33,2.56.75,4.4,1.3,5.89-.93l.45-.67c3.45-5.23,10.62-16.11,24.52-14.57,13.44,1.5,21.83,23.06,23.16,26.71,2.32-.89,12.13-4.51,17.16-3.79,5.76.82,9.72,11.72,9.88,12.18a.5.5,0,0,1-.47.67Zm-117.33-1h116.6c-.95-2.37-4.41-10.23-8.82-10.86-5.34-.76-17,3.87-17.13,3.92a.51.51,0,0,1-.66-.3c-.09-.25-8.75-25-22.5-26.53-13.28-1.48-20.24,9.06-23.58,14.12l-.44.67c-1.91,2.85-4.38,2.11-7,1.33-2.19-.65-4.68-1.39-7.46-.35-3.94,1.48-6,4.87-7.58,7.59a10.62,10.62,0,0,1-2.59,3.42c-1.21.81-2.66.16-4.19-.53-2-.92-4.33-1.95-6.87-.26a32.28,32.28,0,0,0-7.77,7.77Zm-11.25,0H616c-.74-.56-4.73-3.41-8-1.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.26,55.85H529.49a.51.51,0,0,1-.49-.36.52.52,0,0,1,.23-.57l2.23-1.34c2-1.18,4.15,0,5.07.62a18.52,18.52,0,0,1,4.3-4.18c1.8-1.2,3.45-.46,4.65.08.8.36,1.31.57,1.61.37a5.91,5.91,0,0,0,1.23-1.69c.93-1.56,2.2-3.69,4.69-4.63a7,7,0,0,1,4.72.19c1.57.46,2.36.64,3.09-.44l.25-.38c2-3,6.08-9.22,14.08-8.34,7.5.84,12.24,12.46,13.21,15,1.62-.61,6.84-2.48,9.61-2.08,3.39.49,5.67,6.77,5.76,7a.48.48,0,0,1-.06.45A.49.49,0,0,1,603.26,55.85Zm-66-1h65.24c-.81-1.94-2.65-5.41-4.7-5.71-3-.43-9.52,2.18-9.58,2.21a.55.55,0,0,1-.4,0,.51.51,0,0,1-.26-.3c-.05-.14-4.91-14-12.55-14.86-7.37-.83-11.27,5.06-13.14,7.89l-.25.38c-1.17,1.75-2.71,1.29-4.21.84a6.09,6.09,0,0,0-4.08-.2c-2.16.81-3.28,2.69-4.18,4.2a6.34,6.34,0,0,1-1.53,2c-.79.52-1.7.11-2.58-.29-1.15-.51-2.34-1-3.68-.16A18,18,0,0,0,537.29,54.85Zm-6,0h4.39c-.85-.51-2.39-1.19-3.7-.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.12,45.58H40.34a.5.5,0,0,1-.48-.37.5.5,0,0,1,.23-.56l2.23-1.34c2-1.18,4.15,0,5.07.62a18.12,18.12,0,0,1,4.3-4.18c1.8-1.2,3.45-.46,4.65.08.8.36,1.31.56,1.61.36a5.84,5.84,0,0,0,1.23-1.68c.93-1.56,2.2-3.7,4.69-4.63a7,7,0,0,1,4.71.18c1.58.47,2.37.65,3.09-.44l.25-.37c2-3,6.09-9.23,14.09-8.34,7.5.83,12.24,12.46,13.2,15.05,1.63-.61,6.86-2.47,9.62-2.08,3.39.48,5.67,6.77,5.76,7a.5.5,0,0,1-.06.46A.51.51,0,0,1,114.12,45.58Zm-66-1h65.24c-.81-1.95-2.65-5.42-4.71-5.71-3-.42-9.51,2.18-9.58,2.2a.48.48,0,0,1-.39,0,.47.47,0,0,1-.26-.29c0-.14-4.91-14-12.55-14.87-7.4-.82-11.27,5.07-13.14,7.9l-.25.38c-1.17,1.74-2.71,1.29-4.21.84a6,6,0,0,0-4.08-.2c-2.16.81-3.28,2.69-4.18,4.2a6.34,6.34,0,0,1-1.53,2c-.79.52-1.7.11-2.58-.29-1.15-.52-2.34-1.05-3.68-.16A17.56,17.56,0,0,0,48.15,44.58Zm-6,0h4.39c-.85-.51-2.4-1.19-3.7-.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Globe--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M291.73,476.82H47.83a.5.5,0,0,1-.5-.5V363.4a.5.5,0,0,1,.5-.5h243.9a.5.5,0,0,1,.5.5V476.32A.51.51,0,0,1,291.73,476.82Zm-243.4-1h242.9V363.9H48.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.11,352.44H174.75a.5.5,0,0,1-.5-.5V325.6a150.51,150.51,0,0,1-22.51-1.76,5.34,5.34,0,0,1-4.44-6.16L150.65,298a.52.52,0,0,1,.21-.33.54.54,0,0,1,.37-.08c3.18.62,6.38,1.11,9.53,1.46a.47.47,0,0,1,.34.19.49.49,0,0,1,.09.39L158.74,314A138.62,138.62,0,0,0,205.17,41.08l-2.45,14.39a.52.52,0,0,1-.21.33.5.5,0,0,1-.39.07c-3.13-.71-6.31-1.3-9.46-1.75a.5.5,0,0,1-.33-.2.48.48,0,0,1-.09-.38l3.35-19.69a5.35,5.35,0,0,1,2.19-3.48,5.46,5.46,0,0,1,4-.87,149.16,149.16,0,0,1,66.79,30.73h0A148.77,148.77,0,0,1,324,176.33a152.6,152.6,0,0,1-1,17.34A149,149,0,0,1,195.61,324.15v27.79A.5.5,0,0,1,195.11,352.44Zm-19.86-1h19.36V323.71a.49.49,0,0,1,.43-.49A148,148,0,0,0,322,193.56a150.69,150.69,0,0,0,1-17.23A147.77,147.77,0,0,0,268,61h0a148.2,148.2,0,0,0-66.35-30.52,4.37,4.37,0,0,0-3.27.71A4.31,4.31,0,0,0,196.57,34L193.31,53.2c2.84.42,5.69.95,8.52,1.58l2.45-14.39a.49.49,0,0,1,.21-.33.48.48,0,0,1,.39-.07A139.63,139.63,0,0,1,158.1,315a.5.5,0,0,1-.34-.2.48.48,0,0,1-.09-.38L160.12,300c-2.84-.33-5.71-.77-8.57-1.31l-3.27,19.18a4.34,4.34,0,0,0,3.62,5,149.8,149.8,0,0,0,22.85,1.75.5.5,0,0,1,.5.5Zm-14-54.55a.48.48,0,0,1-.2,0l-3.59-1.53-5.43-3.6a.5.5,0,0,1-.21-.5l.7-4.11a.47.47,0,0,1,.34-.39.49.49,0,0,1,.5.12l1,1a.64.64,0,0,1,.1.13l1.1,2.2c.35.24,1.46,1,2.08,1.53l2.82,2.24,1.17.37a.48.48,0,0,1,.34.56l-.27,1.57a.48.48,0,0,1-.25.35A.5.5,0,0,1,161.23,296.89Zm-8.39-5.82,5.08,3.38,2.92,1.24.09-.52-.84-.26a.51.51,0,0,1-.16-.09s-2.17-1.73-2.89-2.29S154.92,291,154.9,291a.46.46,0,0,1-.16-.18l-1.12-2.24-.3-.3Zm.85-7.47a.45.45,0,0,1-.3-.1.5.5,0,0,1-.19-.48l.67-3.93a.51.51,0,0,1,.39-.41.53.53,0,0,1,.52.22l1.12,1.71a.49.49,0,0,1,0,.47l-.72,1.73a.53.53,0,0,1-.25.26l-1.07.49A.52.52,0,0,1,153.69,283.6Zm.95-3.09-.3,1.74h0l.55-1.3ZM196,92.71a.57.57,0,0,1-.18,0l-1.14-.45a.5.5,0,0,1-.31-.35.52.52,0,0,1,.12-.45l1.29-1.4-3.31-1.72a.52.52,0,0,1-.23-.65l1.15-2.59a.5.5,0,0,1,.54-.29l3.24.54a.54.54,0,0,1,.33.2.51.51,0,0,1,.08.38l-.68,4a.49.49,0,0,1-.06.17.54.54,0,0,1,0,.18l-.35,2.07a.49.49,0,0,1-.24.35A.54.54,0,0,1,196,92.71Zm-2.65-5.07L196,89l.48-2.81-2.36-.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,298.54a.41.41,0,0,1-.19,0l-7.5-3.18-5.43-3.6a.5.5,0,0,1-.21-.5l.66-3.87a.25.25,0,0,1,0-.07l-1.29-3a.5.5,0,0,1,.25-.65l1.86-.84.59-3.48-1.23-1.87a.49.49,0,0,1,0-.51.5.5,0,0,1,.44-.27h1.68a.49.49,0,0,1,.38.18.47.47,0,0,1,.11.41l-.3,1.84,1,1.55a.49.49,0,0,1,0,.47l-.72,1.73a.53.53,0,0,1-.25.26l-.83.38-.61,3.57.85.86a.64.64,0,0,1,.1.13l1.1,2.2c.35.24,1.46,1,2.08,1.53l2.82,2.24,5.09,1.56a.52.52,0,0,1,.35.55l-.3,2a.5.5,0,0,1-.24.36A.57.57,0,0,1,165.13,298.54Zm-12.29-7.47,5.08,3.38,6.81,2.88.13-.95-3.51-1.08h0l-1.26-.39a.51.51,0,0,1-.16-.09s-2.17-1.73-2.89-2.29S154.92,291,154.9,291a.46.46,0,0,1-.16-.18l-1.12-2.24-.3-.3Zm-.6-6.76.53,1.23L153,284Zm2.4-3.8-.3,1.74h0l.55-1.3Zm-.69-2.88.13.2,0-.2Zm70.72,1a.5.5,0,0,1-.44-.25.51.51,0,0,1,0-.53L233.11,265v-1c0-.45,1-4.18,1.46-5.76a.44.44,0,0,1,.1-.19c5.38-6.22,10.88-13.32,10.89-14.56-1.06-1.53-3-10.36-3.22-11.38a.54.54,0,0,1,0-.28l2.83-7.82-2.17-.46a.39.39,0,0,1-.14,0l-3.62-2-19.77.28a.48.48,0,0,1-.41-.19L210.15,210a.54.54,0,0,1-.1-.3l-.15-15.57a.48.48,0,0,1,.07-.26l2.59-4.46,4.63-7.23a.49.49,0,0,1,.12-.13l6.15-4.61.28-6.4a.5.5,0,0,1,.41-.47l2.29-.4,5.36-5.65a.49.49,0,0,1,.55-.12l2.32,1,17.58-3.28,3.74-.86a.49.49,0,0,1,.39.07.48.48,0,0,1,.21.34l.72,4.9a.48.48,0,0,1-.09.37l-1.37,1.84,6.24,3.19a.51.51,0,0,1,.24.26,21.06,21.06,0,0,0,1.59,3.46,20.51,20.51,0,0,1,3.88,2.54l.22-.64.85-4.69a.51.51,0,0,1,.35-.39l2-.58a.49.49,0,0,1,.49.13l5.52,5.37a19.64,19.64,0,0,1,3.65-1.49c.29,0,1.94-.07,3-.12l1.48-8.66-.56-1c-1.42,1.8-1.87,1.65-2.1,1.58l-2.17-.73a.62.62,0,0,1-.19-.12l-1.29-1.3h-2a.5.5,0,0,1-.5-.5v-1.07l-1.13-3.83a.52.52,0,0,1,0-.18l.14-1.73a.52.52,0,0,1,.1-.26,6.48,6.48,0,0,1,1.63-1.59c.49-.24,1.52-.81,1.79-1l1.53-1.54a.54.54,0,0,1,.27-.14l2.74-.43a.52.52,0,0,1,.43.14l1.23,1.23c.54.22,1.72.7,2,.81.05,0,.3-.33.45-.5a4.4,4.4,0,0,1,.35-.39,4.88,4.88,0,0,0-.39-1.71l-4.72-7a.48.48,0,0,1,0-.5l1.46-2.89-.63-.9-1.91.64-.13,3.82a.53.53,0,0,1-.17.36.51.51,0,0,1-.38.12l-1.44-.14a.5.5,0,0,1-.45-.46l-.26-3.21-1.69-.28-.93,7.3,1.26,3.48a.5.5,0,0,1-.06.46l-2,2.88a.48.48,0,0,1-.45.21.47.47,0,0,1-.41-.29l-.74-1.58h-1.33l-.68,2.14c1.06,1.48,2.25,3.27,2.25,3.85,0,.77-1.08,1.33-1.65,1.57l-1.79,1.94a.5.5,0,0,1-.85-.2l-.72-2.6-.59-4.4-.84-5.73L260,143.51l-2-.84-1.08,1.27,3,3.42,4,5,2.38,1.53a.53.53,0,0,1,.23.37l.15,1.44a.5.5,0,0,1-.3.51l-1.63.7.76,3.05a.5.5,0,0,1-.23.55l-1.87,1.15a.49.49,0,0,1-.47,0,.53.53,0,0,1-.25-.26l.34,3a.51.51,0,0,1-.75.49l-.92-.53a.48.48,0,0,1-.19-.21l-.64-1.22L258,162a.51.51,0,0,1-.3-.31.55.55,0,0,1,.06-.43l.85-1.32a.53.53,0,0,1,.44-.23l3.1.14a.52.52,0,0,1,.41.24l-.13-.9-1.4-3-1.4-2.51L256,150.06a55.18,55.18,0,0,0-5.21-3.72c-.38.22-1.45,1-2.33,1.74a.44.44,0,0,1-.29.11l-3.29.13-.13,3.14a.49.49,0,0,1-.26.42l-4.77,2.66,1.24,2.75a.48.48,0,0,1,0,.49L238.06,162a.51.51,0,0,1-.41.21h-2.28l-1.31,1.05a.46.46,0,0,1-.33.11c-3.28-.1-5.14-.34-5.52-.72a3,3,0,0,1-.57-1.72l-4.71-1.48a.5.5,0,0,1-.35-.53l.43-4,.58-7.76a.49.49,0,0,1,.52-.47l11,.41-.93-9-3.29-2.6a.53.53,0,0,1-.19-.4.51.51,0,0,1,.2-.4l6.21-4.58-4-.27L228.72,133a.52.52,0,0,1-.45.07.49.49,0,0,1-.32-.31l-1.15-3.31a.5.5,0,0,1,.22-.6l2-1.17-1.65-.52a.5.5,0,0,1-.35-.53l.44-4.46a.51.51,0,0,1,.19-.34.52.52,0,0,1,.38-.1l1.36.2.21-1.84-3.72-4-1.19.12a.53.53,0,0,1-.52-.32l-1.73-4.46a.46.46,0,0,1,0-.38l1.58-3.46a.49.49,0,0,1,.39-.29l3.47-.44a.51.51,0,0,1,.47.21.49.49,0,0,1,0,.52l-1.26,2.29,3.21.59a.54.54,0,0,1,.33.22.52.52,0,0,1,.07.39l-.78,3.37,3.27,1.84a.47.47,0,0,1,.23.25l2.36,6.14,3,1.07a.49.49,0,0,1,.31.6l-1.41,5.21,2.93-2.17,1.1-4.57a.54.54,0,0,1,.36-.37l2.27-.59-2-8.19a.49.49,0,0,1,.31-.58l2.89-1.15a.49.49,0,0,1,.66.32l2.91,9.42,10.25-.93.13-4.9a.47.47,0,0,1,.22-.4,11.55,11.55,0,0,0,1.91-1.58c-.3-.64-1.65-3.22-2.5-4.83a.49.49,0,0,1,0-.41.53.53,0,0,1,.28-.29l2.05-.85-.62-2.93-4.43,2.79a.51.51,0,0,1-.66-.12l-4.47-5.62a.56.56,0,0,1-.09-.17l-3.37-12.09L245.83,89l.94,10.86,5.21,5a.49.49,0,0,1,.13.49l-1.11,4.3,2.66,5.44a.48.48,0,0,1,0,.39.5.5,0,0,1-.26.29l-2.74,1.3a.51.51,0,0,1-.63-.19l-6.16-9.63-1.62,3.25a.51.51,0,0,1-.56.26l-3.16-.72a.47.47,0,0,1-.35-.29L233.87,99.6a.5.5,0,0,1,0-.43l2.93-5.58-5.13-14.78a.47.47,0,0,1,0-.31L233,74a.5.5,0,0,1,.25-.3.56.56,0,0,1,.4,0l11.53,4.18a.51.51,0,0,1,.16.09c8.33,7.15,8.21,7.51,8.07,7.9a8.09,8.09,0,0,1-1.47,1.83l1.27,3.43L260,95l-2.45-7.71-5.37-4.38a.52.52,0,0,1-.18-.43l.22-2.65a.53.53,0,0,1,.3-.42.5.5,0,0,1,.51.08,124,124,0,0,1,46.24,96.83,126.27,126.27,0,0,1-.83,14.46.51.51,0,0,1-.39.43.5.5,0,0,1-.54-.23l-2.91-4.85a.51.51,0,0,1-.07-.24l-.13-5.7-.62.17-.27,6.91,2.14,7.84a.44.44,0,0,1,0,.32l-7.06,17.74a.48.48,0,0,1-.39.31.52.52,0,0,1-.47-.19l-2.31-3a.53.53,0,0,1-.1-.32l.29-10.67-1-16.7-1.24-.79-1.45.1-.5,3.42,2.28,12.75v17.68l4.39-1.5a.5.5,0,0,1,.51.11.54.54,0,0,1,.13.51l-2.31,7.51a.45.45,0,0,1-.06.12l-3.89,6a.86.86,0,0,1-.07.1l-12.62,12-4.87,10.15L262,255.21a.46.46,0,0,1-.21.18l-4.54,2.13c-5,4.5-7.76,7-8.38,7.36h0c-.4.32-2.9,3.81-5,6.93a.41.41,0,0,1-.17.15l-4,2.16L227,278.48l-.13,0-2.16.14Zm10.83-20c-.66,2.38-1.36,5.06-1.39,5.4v1.13a.5.5,0,0,1-.09.29l-8.35,12.12,1.06-.07,12.49-4.31,3.85-2.06c4.79-7,5.18-7.1,5.37-7.16.43-.26,5.26-4.59,8.18-7.25a.57.57,0,0,1,.13-.08l4.48-2.11,2.8-4.2,4.88-10.17a.56.56,0,0,1,.1-.15L281.65,228l3.82-5.94,2-6.51-4.12,1.42a.52.52,0,0,1-.45-.07.51.51,0,0,1-.21-.41v-18.3L280.4,185.4a.43.43,0,0,1,0-.16l.57-3.89a.5.5,0,0,1,.46-.43l2-.14a.54.54,0,0,1,.3.08l1.59,1a.52.52,0,0,1,.23.39l1,17-.29,10.54L288,212l6.67-16.77-2.11-7.76a.34.34,0,0,1,0-.15l.28-7.35a.51.51,0,0,1,.37-.46l1.59-.44a.51.51,0,0,1,.43.08.5.5,0,0,1,.2.39l.15,6.21,2.08,3.46a125,125,0,0,0,.66-12.87,123.1,123.1,0,0,0-45.13-95.46L253,82.31l5.28,4.31a.53.53,0,0,1,.16.23l2.88,9.08a.51.51,0,0,1-.17.54.5.5,0,0,1-.56,0l-8.07-4.61a.51.51,0,0,1-.22-.26l-1.44-3.9a.5.5,0,0,1,.12-.53,15.44,15.44,0,0,0,1.36-1.52c-.72-.86-4.32-4.09-7.62-6.91l-10.94-4-1.11,3.8,5.15,14.84a.47.47,0,0,1,0,.4l-2.92,5.56L239,109.2l2.53.58,1.84-3.69a.5.5,0,0,1,.42-.28.53.53,0,0,1,.45.23l6.39,10,1.89-.89L250,110a.5.5,0,0,1,0-.34l1.08-4.2-5.13-5a.51.51,0,0,1-.15-.31l-1-11.68a.51.51,0,0,1,.16-.41.48.48,0,0,1,.41-.13l2.89.43a.49.49,0,0,1,.41.36l3.43,12.3,4.13,5.19,4.66-2.93a.5.5,0,0,1,.46,0,.49.49,0,0,1,.3.36l.86,4a.51.51,0,0,1-.3.57l-1.93.8c.69,1.3,2.23,4.24,2.36,4.62s.25.77-2.14,2.45l-.13,5.09a.5.5,0,0,1-.45.48l-11.1,1a.5.5,0,0,1-.53-.35L245.4,113l-2,.79,2.06,8.23a.51.51,0,0,1-.36.61l-2.45.64-1.08,4.46a.53.53,0,0,1-.19.29L232,135l3,2.33a.53.53,0,0,1,.19.34l1,9.8a.53.53,0,0,1-.14.4.47.47,0,0,1-.38.15l-11.06-.41-.54,7.3-.39,3.65,4.66,1.47a.49.49,0,0,1,.35.47,2.88,2.88,0,0,0,.28,1.38,27.75,27.75,0,0,0,4.67.43l1.3-1.05a.51.51,0,0,1,.31-.11h2.2l2.57-3.73-1.33-2.91a.5.5,0,0,1,.22-.64l4.93-2.75.14-3.33a.5.5,0,0,1,.48-.48l3.59-.13a18.37,18.37,0,0,1,2.61-1.86c.28-.09.69-.22,6.09,4l3.66,3.79a.39.39,0,0,1,.08.1l1.44,2.59,1.45,3.06a.88.88,0,0,1,.05.15l.18,1.4.91-.55-.78-3.12a.52.52,0,0,1,.29-.58l1.68-.71-.08-.84-2.25-1.45a.4.4,0,0,1-.12-.1l-4-5.05-3.3-3.74a.49.49,0,0,1,0-.65l1.59-1.87a.49.49,0,0,1,.57-.14l2.45,1a.46.46,0,0,1,.16.11l8.07,8.07a.44.44,0,0,1,.14.28l.87,5.9.58,4.34.46,1.67,1.26-1.37a.57.57,0,0,1,.18-.12,2.94,2.94,0,0,0,1.14-.72,26.81,26.81,0,0,0-2.22-3.43.55.55,0,0,1-.07-.45l.86-2.73a.52.52,0,0,1,.48-.35h2a.51.51,0,0,1,.45.29l.51,1.09,1.37-2-1.21-3.36a.45.45,0,0,1,0-.23l1-7.93a.52.52,0,0,1,.2-.34.52.52,0,0,1,.38-.09l2.59.43a.5.5,0,0,1,.42.45l.25,3.19.5,0,.12-3.63a.51.51,0,0,1,.34-.46l2.6-.87a.51.51,0,0,1,.57.19l1,1.45a.52.52,0,0,1,0,.51l-1.46,2.9,4.59,6.82s0,.07.06.1c.31.82.75,2.26.17,2.84l-.29.33c-.39.45-.86,1-1.51.8-.45-.15-2.13-.85-2.2-.88a.44.44,0,0,1-.16-.1l-1.12-1.12-2.33.36-1.47,1.48-.11.08s-1.31.73-1.88,1a5,5,0,0,0-1.19,1.18l-.12,1.49,1.12,3.8a.78.78,0,0,1,0,.14v.65h1.67a.55.55,0,0,1,.36.15L281,166l1.92.65a10.77,10.77,0,0,0,1.59-1.8.5.5,0,0,1,.43-.21.54.54,0,0,1,.41.27l1,1.87a.5.5,0,0,1,.05.32l-1.58,9.23a.49.49,0,0,1-.47.41c-.12,0-3,.14-3.48.14a38.4,38.4,0,0,0-3.53,1.54.5.5,0,0,1-.57-.09l-5.56-5.42-1.43.42-.82,4.44-.45,1.37a.51.51,0,0,1-.32.32.52.52,0,0,1-.45-.07,38.71,38.71,0,0,0-4.11-2.81c-.23,0-.68,0-2.19-3.87l-6.6-3.37a.54.54,0,0,1-.26-.33.52.52,0,0,1,.09-.42l1.6-2.14-.61-4.16-3.23.75-17.74,3.32a.67.67,0,0,1-.28,0l-2.14-.88L227.05,171a.49.49,0,0,1-.27.15l-2.06.36-.27,6.23a.49.49,0,0,1-.2.37L218,182.78l-4.57,7.13-2.51,4.33.15,15.26,8.67,11.35,19.65-.29a.57.57,0,0,1,.25.06l3.67,2,2.67.55a.51.51,0,0,1,.34.25.49.49,0,0,1,0,.41l-3,8.24c.83,3.82,2.37,10,3,10.9C247.23,244,243.56,249.3,235.5,258.64Zm23.38-97.33,2.2.84a.45.45,0,0,1,.26.23l.58,1.12-.29-2.64-2.39-.1Zm-31-31.84.79,2.28,3.91-2.91a.56.56,0,0,1,.33-.1l3.92.26,1.23-4.49-2.75-1a.5.5,0,0,1-.3-.29L232.63,117l-3.44-1.93a.5.5,0,0,1-.25-.55l.75-3.23-3.38-.62a.51.51,0,0,1-.36-.28.5.5,0,0,1,0-.46l1.12-2-2.22.28-1.38,3,1.52,3.91,1.06-.1a.51.51,0,0,1,.42.15l4,4.33a.53.53,0,0,1,.13.4l-.29,2.59a.52.52,0,0,1-.2.34.49.49,0,0,1-.37.1l-1.35-.2-.35,3.53,2.35.74a.49.49,0,0,1,.35.42.51.51,0,0,1-.25.49ZM111.35,200.74a.51.51,0,0,1-.4-.19.5.5,0,0,1-.08-.46l.76-2.35a.52.52,0,0,1,.51-.35l2.61.18-.77-2.71a.48.48,0,0,1,0-.39.51.51,0,0,1,.32-.24l3.52-.76a.53.53,0,0,1,.37.07l4.08,2.49a.5.5,0,0,1,.23.52l-.49,2.41a.49.49,0,0,1-.57.4l-3-.49-.65,1.32a.5.5,0,0,1-.43.28l-6.08.27Zm1.12-2.32-.42,1.29,5.06-.22.69-1.4a.49.49,0,0,1,.53-.27l2.85.47.32-1.59-3.61-2.21-2.8.61.81,2.88a.49.49,0,0,1-.09.45.51.51,0,0,1-.42.18Zm-.57-2.71h0l-6.63-.42a.48.48,0,0,1-.28-.1l-5.52-4.28-2.53,1.61a.52.52,0,0,1-.56,0l-1-.75a.51.51,0,0,1-.21-.37.54.54,0,0,1,.15-.4l2.22-2.15a.61.61,0,0,1,.34-.14l5-.07a.44.44,0,0,1,.33.12l3.84,3.17,5.9,1.43a.51.51,0,0,1,.34.3.5.5,0,0,1,0,.46l-.9,1.39A.5.5,0,0,1,111.9,195.71Zm-6.45-1.41,6.19.4.36-.56-5.33-1.28a.54.54,0,0,1-.2-.1l-3.79-3.13-4.65.06-1.65,1.6.28.2,2.54-1.61a.51.51,0,0,1,.58,0Zm148.2-34.47a.39.39,0,0,1-.15,0l-1.65-.53a.49.49,0,0,1-.32-.32.51.51,0,0,1,.06-.45l.22-.3-.18-1.32-.71-3.46a.48.48,0,0,1,.16-.47.49.49,0,0,1,.49-.1l2.37.79a.51.51,0,0,1,.32.32l1.12,3.55a.48.48,0,0,1-.08.45l-1.25,1.66A.51.51,0,0,1,253.65,159.83Zm-.86-1.3.67.22.89-1.17-1-3.06-1.3-.44.54,2.64.21,1.56A.43.43,0,0,1,252.79,158.53Zm1.06-5.82h-.11l-1.52-.33a.49.49,0,0,1-.37-.36l-.46-1.78a.49.49,0,0,1,.14-.49l1-.92a.49.49,0,0,1,.81.21l1,3a.51.51,0,0,1-.11.49A.51.51,0,0,1,253.85,152.71Zm-1.11-1.25.36.08-.47-1.46-.2.19ZM146.25,139.83a.32.32,0,0,1-.14,0l-2.45-.73a.48.48,0,0,1-.35-.56l.36-2.1-3.18,2.31a.5.5,0,0,1-.67-.08l-2.45-2.89a.5.5,0,0,1-.06-.57l3.6-6.48a.56.56,0,0,1,.24-.22l4-1.73a.53.53,0,0,1,.5.06.51.51,0,0,1,.2.46l-.27,2.5,1.35,1.35,4.62-1.36a.51.51,0,0,1,.6.29l1.73,4.17a.49.49,0,0,1-.1.54l-4.61,4.76a.49.49,0,0,1-.43.15.53.53,0,0,1-.37-.25l-.94-1.7-.76,1.8A.49.49,0,0,1,146.25,139.83Zm-1.88-1.58,1.59.48,1-2.34a.49.49,0,0,1,.43-.31.51.51,0,0,1,.47.26l1.11,2,3.91-4-1.43-3.45L147,132.17a.49.49,0,0,1-.49-.12l-1.73-1.73a.53.53,0,0,1-.15-.41l.2-1.89-3.1,1.33-3.35,6,1.93,2.28,3.81-2.76a.49.49,0,0,1,.78.49Zm77.23-11a.71.71,0,0,1-.6-.2l-1.3-1.3a.51.51,0,0,1,0-.64l1.39-2-1.54-2.32a.49.49,0,0,1,0-.47l1.29-3a.5.5,0,0,1,.6-.29l4.47,1.3a.49.49,0,0,1,.36.47l.14,6.63a.51.51,0,0,1-.3.47C223.4,126.92,222.19,127.2,221.6,127.2Zm0-1h0a17.23,17.23,0,0,0,3.67-1.19l-.12-5.93L221.5,118l-1,2.37,1.57,2.38a.5.5,0,0,1,0,.56l-1.34,2ZM136,99.9h-3.9a.5.5,0,0,1-.47-.32l-3-8.17-6.28.27a.48.48,0,0,1-.44-.22.5.5,0,0,1,0-.49l1-2.16a.52.52,0,0,1,.42-.29l4.64-.28c.42-.24,2-1.14,2.45-1.5.25-.18.94-.81,1.61-1.41.91-.82,1.5-1.36,1.79-1.57a47,47,0,0,0,1.26-6.27l-2.26-2.77-3.74.67a.51.51,0,0,1-.44-.14l-1.73-1.73a.51.51,0,0,1,0-.7L133.19,66a.55.55,0,0,1,.19-.12l4.91-1.87a.5.5,0,0,1,.51.09.49.49,0,0,1,.16.48l-.77,3.43,4.87,1.32a.5.5,0,0,1,.35.63L143,71.48l2.08,1.1a.5.5,0,0,1,.27.44v3.31a.5.5,0,0,1-.22.42l-2.45,1.63L147,81.71a.5.5,0,0,1,.17.58l-1.29,3.31a.78.78,0,0,1-.1.15l-3.32,3.61a.5.5,0,0,1-.49.15.49.49,0,0,1-.36-.36l-.93-3.57a4.66,4.66,0,0,0-1.44,0c-.15.62-.52,2.49-.65,3.13l1.45,2a.5.5,0,0,1,0,.54l-2,3.6a.53.53,0,0,1-.37.25l-2.44.34,1.26,3.77a.48.48,0,0,1-.06.45A.51.51,0,0,1,136,99.9Zm-3.55-1h2.86l-1.23-3.67a.52.52,0,0,1,0-.42.49.49,0,0,1,.36-.23l2.79-.4,1.74-3.1-1.39-1.91a.46.46,0,0,1-.09-.39c0-.12.57-2.9.73-3.49s1.12-.89,2.84-.66a.48.48,0,0,1,.42.37l.78,3L145,85.14l1.12-2.87-4.6-3.52a.48.48,0,0,1-.2-.41.53.53,0,0,1,.22-.4l2.81-1.87V73.32l-2.18-1.15a.5.5,0,0,1-.25-.59l.42-1.38-4.83-1.31a.5.5,0,0,1-.36-.6l.67-3-3.93,1.5-5.92,6.34,1.2,1.21,3.77-.68a.52.52,0,0,1,.48.18L136,77a.46.46,0,0,1,.1.39c-1,6.71-1.45,7-1.65,7.12s-1.06.91-1.75,1.53-1.39,1.26-1.68,1.47c-.6.45-2.57,1.58-2.65,1.63a.43.43,0,0,1-.22.06l-4.46.27-.54,1.15,5.82-.26a.51.51,0,0,1,.49.33Zm6.78-13.37h0ZM116.12,98.31h-1.73a.51.51,0,0,1-.44-.26.49.49,0,0,1,0-.51l1.45-2.17a.51.51,0,0,1,.49-.22l3,.44a.49.49,0,0,1,.42.39.52.52,0,0,1-.22.53l-2.75,1.73A.52.52,0,0,1,116.12,98.31Zm-.79-1H116l1.47-.93-1.37-.2ZM114,95.86a.5.5,0,0,1-.31-.1l-2.74-2.16a.52.52,0,0,1-.19-.36.53.53,0,0,1,.13-.38l3.75-4a.53.53,0,0,1,.33-.15l3.61-.29a.48.48,0,0,1,.5.3l1.73,4a.49.49,0,0,1-.16.59l-1.88,1.44a.5.5,0,0,1-.67-.06l-1-1.1-2.8,2.17A.5.5,0,0,1,114,95.86Zm-2-2.71,2,1.58,2.86-2.21a.5.5,0,0,1,.68.06l1,1.1,1.21-.93-1.44-3.35-3.06.25ZM201.75,95a.57.57,0,0,1-.18,0l-6.92-2.73a.5.5,0,0,1-.31-.35.52.52,0,0,1,.12-.45l1.29-1.4-3.31-1.72a.52.52,0,0,1-.23-.65l1.15-2.59a.5.5,0,0,1,.54-.29l5.6.93.32-1.42a.5.5,0,0,1,.49-.39h4.61a.5.5,0,0,1,.5.5v3.08l2.7,2.16a.53.53,0,0,1,.19.4.52.52,0,0,1-.2.4l-6.06,4.46A.55.55,0,0,1,201.75,95Zm-6.06-3.42,6,2.36L207,90l-2.38-1.91a.48.48,0,0,1-.19-.39V84.9h-3.71l-.34,1.5a.51.51,0,0,1-.57.38l-5.68-1-.8,1.81,3.29,1.71a.5.5,0,0,1,.26.53l-.06.35a.49.49,0,0,1-.12.25Zm-92.25-8-.17,0-2.45-.86a.5.5,0,0,1-.3-.3.5.5,0,0,1,0-.43l4-7-.39-.77a.52.52,0,0,1,.16-.64l1.16-.78.45-.31,6.94-4.28c3.47-2,7.06-3.83,10.7-5.47a.5.5,0,0,1,.44.9l-8,4.15.44,2.91,6.86-.94a.49.49,0,0,1,.55.35.51.51,0,0,1-.26.6l-5.23,2.48-.54,3.9a.57.57,0,0,1-.14.28L115.33,80l-.08.07-2.6,1.73a.49.49,0,0,1-.35.08l-6.49-1-2,2.51A.47.47,0,0,1,103.44,83.61ZM101.73,82l1.54.54,1.94-2.46a.49.49,0,0,1,.46-.18l6.58,1,2.4-1.59,2.3-2.44.55-4a.51.51,0,0,1,.29-.38l2.55-1.21-4.15.57a.5.5,0,0,1-.56-.42l-.5-3.23c-.57.31-1.14.63-1.7,1l-7.34,4.56-.79.53.32.62a.49.49,0,0,1,0,.47Zm42.21-13.37a.52.52,0,0,1-.29-.09l-3-2.16a.5.5,0,0,1-.14-.66l.86-1.44a.49.49,0,0,1,.48-.24l4.47.43a.48.48,0,0,1,.41.29.5.5,0,0,1-.06.5l-2.31,3.17A.49.49,0,0,1,143.94,68.61Zm-2.35-2.8,2.24,1.61,1.5-2.06L142.05,65ZM128,63.14a.5.5,0,0,1-.49-.39l-.24-1.08a.49.49,0,0,1,.3-.57,124,124,0,0,1,31.71-8.32.49.49,0,0,1,.5.25.5.5,0,0,1-.06.57c-1.17,1.39-3.29,3.8-4.31,4.17s-5.55,2.29-5.6,2.3l-1.15.79-1.25,1.52a.53.53,0,0,1-.23.16l-1.3.44a.55.55,0,0,1-.22,0,28.49,28.49,0,0,0-3-.15h-2.88a.5.5,0,0,1-.31-.89l2.8-2.18a16.94,16.94,0,0,0-2.21,0,2.42,2.42,0,0,0-.45.31.58.58,0,0,1,.21.4c0,.54-.45.79-2.24,1.18-3.31.72-9.5,1.44-9.56,1.45Zm.34-1.27.05.22c1.48-.18,6.27-.78,9-1.38l.8-.18v0a.5.5,0,0,1,.12-.53,5.58,5.58,0,0,1,1.49-1.13,26.14,26.14,0,0,1,3.92,0,.52.52,0,0,1,.46.35.52.52,0,0,1-.17.55l-2.74,2.13h1.43c1.47,0,2.61.11,3,.14l1.06-.35,1.21-1.47.11-.1,1.3-.87c.27-.12,4.57-1.93,5.72-2.36a14.18,14.18,0,0,0,3.05-2.9A122.54,122.54,0,0,0,128.29,61.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.7,300h-.06c-3.16-.35-6.39-.85-9.6-1.46A124.55,124.55,0,0,1,70.37,108.44a.5.5,0,0,1,.63-.18.5.5,0,0,1,.27.59l-1.51,5.25-.73,2-3.59,7.61-.57,9.55a.4.4,0,0,1,0,.15L60,146.65l-1.72,17,1,4.24s0,.07,0,.1l.15,5.26,5.66,15.44,1,.5-5.89-15.53a.5.5,0,0,1,0-.43.49.49,0,0,1,.35-.24l1.73-.29a.51.51,0,0,1,.53.28l2,4.18,1.91,6.13c3,6.08,8.11,16.11,8.78,16.78A19.26,19.26,0,0,1,78,203.62l5.68-1.34a.51.51,0,0,1,.55.22l2.19,3.55,7.41,1.26a.49.49,0,0,1,.35.24l4.08,6.89,7.8,2.15.67-1.12a.51.51,0,0,1,.63-.21l3,1.3a.54.54,0,0,1,.29.34l1.58,6.35a.57.57,0,0,1,0,.29l-2.66,7.55,2.75,4.41a.5.5,0,0,1,.08.26v4.39l1.7,1.44,7.2,7.76,9,4.85a.56.56,0,0,1,.21.22L145.07,284l6.86,6.43,6,4,3.51,1.48a.5.5,0,0,1,.29.55l-.53,3.15A.49.49,0,0,1,160.7,300ZM69.34,111.94a123.55,123.55,0,0,0,81.89,185.65c3,.59,6.06,1.06,9.06,1.4l.38-2.29-3.23-1.38-6.13-4.07-7-6.54a.42.42,0,0,1-.11-.15L129.73,255l-8.94-4.82a.41.41,0,0,1-.13-.1l-7.21-7.78-1.83-1.54a.5.5,0,0,1-.18-.39v-4.47l-2.8-4.49a.5.5,0,0,1,0-.43l2.69-7.64-1.49-6-2.4-1-.64,1.07a.51.51,0,0,1-.56.23l-8.36-2.31a.53.53,0,0,1-.3-.23l-4.06-6.86L86.06,207a.54.54,0,0,1-.35-.23l-2.12-3.44-5.7,1.35a.5.5,0,0,1-.54-.24,20.29,20.29,0,0,0-2.49-3.6c-.87-.73-7.15-13.33-9.06-17.17l-1.91-6.14-1.82-3.77-.76.13L67.44,190a.49.49,0,0,1-.13.54.51.51,0,0,1-.56.08l-2.31-1.15a.47.47,0,0,1-.25-.27l-5.76-15.71a.45.45,0,0,1,0-.16l-.15-5.29-1-4.27a1,1,0,0,1,0-.17L59,146.48l0-.12,4.87-13.19.57-9.58a.61.61,0,0,1,0-.18l3.61-7.65.7-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295,185.88l-.15-6.34-1.59.44-.28,7.35,2.16,7.92L288.1,213l-2.31-3,.29-10.67-1-17-1.59-1-2,.14-.57,3.89,2.3,12.83v18.3l5.05-1.73-2.31,7.51L282,228.27l-12.68,12.11-4.91,10.23-2.88,4.32L257,257.1s-7.93,7.2-8.36,7.35-5.19,7.07-5.19,7.07l-4,2.15L226.83,278l-2.16.14,8.94-13V264c0-.44,1.44-5.63,1.44-5.63s12-13.84,10.95-15.13S242.83,232,242.83,232l3-8.37-2.74-.57-3.74-2-19.9.29-8.93-11.68-.15-15.57,2.59-4.46,4.62-7.21,6.34-4.76.29-6.63,2.45-.43,5.47-5.77,2.46,1,17.72-3.31,3.76-.87.72,4.9-1.73,2.31,6.77,3.46s1.44,3.74,1.87,3.74,4.33,2.89,4.33,2.89l.43-1.3.87-4.75,2-.58,5.77,5.62a32.8,32.8,0,0,1,3.75-1.59c.43,0,3.46-.14,3.46-.14l1.58-9.23-1-1.87s-1.58,2.16-2,2l-2.16-.73L279.31,165h-2.17v-1.15L276,159.94l.14-1.73a6.34,6.34,0,0,1,1.45-1.44c.57-.29,1.87-1,1.87-1l1.58-1.59,2.74-.43,1.3,1.3s1.73.72,2.16.86.87-.58,1.3-1-.29-2.3-.29-2.3l-4.76-7.07,1.59-3.16-1-1.45-2.6.87-.14,4.17-1.44-.14-.29-3.6-2.59-.43-1,7.93,1.3,3.6-2,2.88-.87-1.87h-2l-.86,2.73s2.3,3.18,2.3,3.76-1.44,1.15-1.44,1.15l-1.87,2-.72-2.6-.57-4.33-.87-5.9-8.07-8.07-2.45-1-1.59,1.87,3.32,3.75,4,5.05,2.45,1.58.15,1.44-2,.86.86,3.47-1.87,1.15-.29-2.17-1.44-3L260,153.45l-3.61-3.74s-5.19-4-5.62-3.9a24.29,24.29,0,0,0-2.59,1.88l-3.75.14-.15,3.61-5.18,2.88,1.44,3.17-2.88,4.18h-2.46l-1.44,1.16s-4.75-.15-5.19-.58-.43-1.73-.43-1.73l-5-1.59.43-4,.58-7.78,11.54.43-1-9.8L231.16,135l9.94-7.35,1.15-4.75,2.74-.72-2.16-8.66,2.89-1.15,3,9.81,11.1-1,.14-5.34s2.3-1.59,2.16-2-2.59-5-2.59-5l2.44-1-.86-4-5,3.17-4.47-5.62-3.46-12.4-2.89-.43,1,11.68,5.34,5.18-1.16,4.48,2.74,5.61-2.74,1.3-6.63-10.38-2,4-3.16-.72L234.33,99.4l3-5.77-5.2-15,1.3-4.47L245,78.35s8.08,6.92,7.93,7.35a11.55,11.55,0,0,1-1.58,1.87l1.44,3.9,8.07,4.61L258,87l-5.48-4.47.22-2.65a123.42,123.42,0,0,0-50.48-24.5q-4.68-1.07-9.5-1.76a124,124,0,0,0-18-1.3,127.2,127.2,0,0,0-15.46,1c-.89,1.06-3.18,3.69-4.1,4-1.16.44-5.62,2.31-5.62,2.31l-1.3.87L147,62.06l-1.3.44a29,29,0,0,0-3-.15h-2.88l3.88-3a33.07,33.07,0,0,0-3.74,0,6,6,0,0,0-1.3,1s2.17.15-1.15.87S128,62.64,128,62.64l-.24-1.08-1.85.77.79,1.32-7.06,5.19,7.64-.87-1.3,3.46L119.3,75l.86,4.33-1,2.16L124.92,76l4.18,2.74-3.46,4.62-3.89,2.44-5.34.44S107,96.37,106.47,96.51s-8.36,8.07-8.8,8.07-.57,5.63-.57,5.63,7.78,6.91,9.08,7.06-.15,7.93-.15,7.93l3.9,1.15.86-9.37s6.06-1.44,6.06-2.31-1-7.35-.29-7.92S119,105,119,105s1.59-7.79,2.16-7.93,2.59-1,3.6-.87,4.62,3.9,4.76,4.33-1.73,7.21-1.73,7.21a9.22,9.22,0,0,0,2.45,1.44c.58,0,6.78-6.63,6.78-6.63s2.88,8.65,2.74,9.66a17.36,17.36,0,0,1-1.16,3.16l6,3.18,1,5.19-5.18,3.74a7.25,7.25,0,0,1-4.76,1.88,81.75,81.75,0,0,0-9.8,1.3l-8.65,5.9,2.74,1.59,7.49-5.62h2l-1.44,3L130,139.9l4.46-3.17,2.31,2.16-6.49,3.18L127.51,146l-2.31-1,2.31-3.31-2-1-2.59,1.29L121,143.51l-2.74,2-.72,3.46v1.16L114.39,152l-4.46,1.88s-1.73,6.92-1.59,7.35.44,3.89.44,3.89l-10,7.93,3.31,12.1-2,.58-1.73-3.89.14-3.46-2.16-2.89-2,.58-1.73-1.15-4.61.72v2.88l-2.89-1.15L83,176.51l-5.33,4.62.86,12.11,2.74,5.91,4.47-.43,2-2,.58-4,4.89-.29L92.05,203l6.63-.43,1.16,7.93,2.88,3.17,3.75-1.15,3.32,1.72,1.58-3.31s2.73.29,2.88-.14a10,10,0,0,1,1.3-1.73l2.16-.15-.29,5.62,2.17.43-.29-3.6,2.45-1,2.3,1.3a15.38,15.38,0,0,1,2.31.15A14.33,14.33,0,0,1,129,214l2.45-1.3,5.91,3.74,3.17,2.6,5.47-.43s9.66,6.48,9.08,6.63-1,3.75-1,3.75l8.31,3.27,9.19,3.61.81.32,5.34,2.6.14,2.16-7.06,9.52-.58,9.8-3.1,1.76-6.55,3.71-3.18,11.39H154.7l-.34,2,1.12,1.71-.72,1.73-1.07.49-.7,4.09,1,1,1.16,2.31s1.44,1,2.16,1.59l2.89,2.3,1.26.39,3.92,1.2-.29,2-3.9-1.65-.53,3.15a125.34,125.34,0,0,0,14.05.79,124,124,0,0,0,123.18-109.6Zm-36-25.64,3.1.14.46,4.15-.92-.53-.72-1.39-2.77-1.05Zm-6.12-11.06,1,3-1.52-.33-.46-1.78Zm.92,4.94,1.12,3.55-1.25,1.66L252,158.8l.33-.46-.2-1.52-.72-3.49Zm-29.26-46.36,3.47-.44-1.59,2.89,3.89.72-.86,3.74,3.6,2,2.45,6.35,3.18,1.15-1.45,5.33-4.33-.28-4.46,3.31-1.15-3.31,3-1.74-2.74-.86.44-4.46,1.87.28.29-2.59-4-4.33-1.44.14-1.73-4.46Zm-3.31,9.65,4.47,1.3.14,6.63s-4,1.73-4.47,1.3l-1.29-1.3,1.58-2.3-1.72-2.6ZM116.12,97.81h-1.73l1.45-2.17,3,.44Zm2.31-3.46-1.3-1.44L114,95.36l-2.74-2.16,3.75-4,3.61-.29,1.73,4ZM105.27,194.79l-5.8-4.49-2.83,1.79-1-.75,2.22-2.15,5-.07,3.93,3.25,6,1.45-.9,1.39Zm16.3,4.07-3.32-.55-.82,1.66-6.08.27.76-2.35,3.31.22-1-3.39L118,194l4.08,2.49ZM141.78,64.51l4.47.43-2.31,3.17-3-2.16Zm3.61,20.9L142.07,89l-1-3.9s-2.16-.28-2.3.29-.72,3.46-.72,3.46L139.62,91l-2,3.6-3,.43L136,99.4h-3.9L129,90.89l-6.64.29,1-2.16,4.76-.29s2-1.16,2.6-1.59,3-2.74,3.45-3,1.44-6.78,1.44-6.78L133,74.17l-4,.72-1.73-1.73,6.33-6.78,4.91-1.87-.87,3.89,5.33,1.45-.57,1.87,2.45,1.3v3.31l-3,2,4.9,3.75Zm3.46,53.77-1.44-2.6-1.16,2.75-2.45-.73.58-3.31-4.18,3-2.45-2.89,3.6-6.48,4-1.73L145.1,130l1.73,1.73,4.9-1.44,1.73,4.17Zm43.24-62.56A11.56,11.56,0,0,1,188.58,78c-2.57.77-5.7,1.55-6.29,1.64-1,.14-1.3,5-1.58,5.62s-6.21,2-6.93,2-5.47,6.77-5.47,6.77a31.29,31.29,0,0,1,.14,4.62c-.14,1.87-3,4.61-4.18,5.62s-5-2.74-5-2.74l-1.88-4.18-1.73-12a11.4,11.4,0,0,1,2-3.16c1-.87,1.88-1.45,2.89-2.17s.57-1.87.71-2.6S160,75.75,160,75.75s-2.16-.28-2.16-1.44,2.45-2.3,2.45-2.3a2.18,2.18,0,0,0-1.59-1.44c-1.15-.15,3.17-8.79,2.88-9.52s-2.88-1.44-3.31-2.59,3.31-2.31,3.31-2.31.72-.58.43-1.15,5-2.31,5-2.31,7.78-.28,9.37.15,3.46.43,4.61,1.29a81.34,81.34,0,0,1,7.93,5.77c.84.76,1.49,2.43,2,4.44C192.12,69.23,192.39,76.11,192.09,76.62Zm9.66,17.87L196,92.21l-1.14-.45,1.49-1.62.06-.35-3.71-1.93,1.15-2.59,3.24.54,2.82.47.43-1.88h4.61v3.32L207.81,90Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.13,298.54a.41.41,0,0,1-.19,0l-7.5-3.18-5.43-3.6a.5.5,0,0,1-.21-.5l.7-4.11a.47.47,0,0,1,.34-.39.49.49,0,0,1,.5.12l1,1a.64.64,0,0,1,.1.13l1.1,2.2c.35.24,1.46,1,2.08,1.53l2.82,2.24,5.09,1.56a.52.52,0,0,1,.35.55l-.3,2a.5.5,0,0,1-.24.36A.57.57,0,0,1,165.13,298.54Zm-12.29-7.47,5.08,3.38,6.81,2.88.13-.95-3.51-1.08h0l-1.26-.39a.51.51,0,0,1-.16-.09s-2.17-1.73-2.89-2.29S154.92,291,154.9,291a.46.46,0,0,1-.16-.18l-1.12-2.24-.3-.3Zm.85-7.47a.45.45,0,0,1-.3-.1.49.49,0,0,1-.2-.4.25.25,0,0,1,0-.08l.67-3.93a.51.51,0,0,1,.39-.41.53.53,0,0,1,.52.22l1.12,1.71a.53.53,0,0,1,.08.27.48.48,0,0,1,0,.2l-.72,1.73a.53.53,0,0,1-.25.26l-1.07.49A.52.52,0,0,1,153.69,283.6Zm.95-3.09-.3,1.74h0l.55-1.3Zm70-1.87a.5.5,0,0,1-.44-.25.51.51,0,0,1,0-.53L233.11,265v-1c0-.45,1-4.18,1.46-5.76a.44.44,0,0,1,.1-.19c5.38-6.22,10.88-13.32,10.89-14.56-1.06-1.53-3-10.36-3.22-11.38a.54.54,0,0,1,0-.28l2.83-7.82-2.17-.46a.39.39,0,0,1-.14,0l-3.62-2-19.77.28a.48.48,0,0,1-.41-.19L210.15,210a.54.54,0,0,1-.1-.3l-.15-15.57a.48.48,0,0,1,.07-.26l2.59-4.46,4.63-7.23a.49.49,0,0,1,.12-.13l6.15-4.61.28-6.4a.5.5,0,0,1,.41-.47l2.29-.4,5.36-5.65a.49.49,0,0,1,.55-.12l2.32,1,17.58-3.28,3.74-.86a.49.49,0,0,1,.39.07.48.48,0,0,1,.21.34l.72,4.9a.48.48,0,0,1-.09.37l-1.37,1.84,6.24,3.19a.51.51,0,0,1,.24.26,21.06,21.06,0,0,0,1.59,3.46,20.51,20.51,0,0,1,3.88,2.54l.22-.64.85-4.69a.51.51,0,0,1,.35-.39l2-.58a.49.49,0,0,1,.49.13l5.52,5.37a19.64,19.64,0,0,1,3.65-1.49c.29,0,1.94-.07,3-.12l1.48-8.66-.56-1c-1.42,1.8-1.87,1.65-2.1,1.58l-2.17-.73a.62.62,0,0,1-.19-.12l-1.29-1.3h-2a.5.5,0,0,1-.5-.5v-1.07l-1.13-3.83a.52.52,0,0,1,0-.18l.14-1.73a.52.52,0,0,1,.1-.26,6.48,6.48,0,0,1,1.63-1.59c.49-.24,1.52-.81,1.79-1l1.53-1.54a.54.54,0,0,1,.27-.14l2.74-.43a.52.52,0,0,1,.43.14l1.23,1.23c.54.22,1.72.7,2,.81.05,0,.3-.33.45-.5a4.4,4.4,0,0,1,.35-.39,4.88,4.88,0,0,0-.39-1.71l-4.72-7a.48.48,0,0,1,0-.5l1.46-2.89-.63-.9-1.91.64-.13,3.82a.53.53,0,0,1-.17.36.51.51,0,0,1-.38.12l-1.44-.14a.5.5,0,0,1-.45-.46l-.26-3.21-1.69-.28-.93,7.3,1.26,3.48a.5.5,0,0,1-.06.46l-2,2.88a.48.48,0,0,1-.45.21.47.47,0,0,1-.41-.29l-.74-1.58h-1.33l-.68,2.14c1.06,1.48,2.25,3.27,2.25,3.85,0,.77-1.08,1.33-1.65,1.57l-1.79,1.94a.5.5,0,0,1-.85-.2l-.72-2.6-.59-4.4-.84-5.73L260,143.51l-2-.84-1.08,1.27,3,3.42,4,5,2.38,1.53a.53.53,0,0,1,.23.37l.15,1.44a.5.5,0,0,1-.3.51l-1.63.7.76,3.05a.5.5,0,0,1-.23.55l-1.87,1.15a.49.49,0,0,1-.47,0,.53.53,0,0,1-.25-.26l.34,3a.51.51,0,0,1-.75.49l-.92-.53a.48.48,0,0,1-.19-.21l-.64-1.22L258,162a.51.51,0,0,1-.3-.31.55.55,0,0,1,.06-.43l.85-1.32a.53.53,0,0,1,.44-.23l3.1.14a.52.52,0,0,1,.41.24l-.13-.9-1.4-3-1.4-2.51L256,150.06a55.18,55.18,0,0,0-5.21-3.72c-.38.22-1.45,1-2.33,1.74a.44.44,0,0,1-.29.11l-3.29.13-.13,3.14a.49.49,0,0,1-.26.42l-4.77,2.66,1.24,2.75a.48.48,0,0,1,0,.49L238.06,162a.51.51,0,0,1-.41.21h-2.28l-1.31,1.05a.46.46,0,0,1-.33.11c-3.28-.1-5.14-.34-5.52-.72a3,3,0,0,1-.57-1.72l-4.71-1.48a.5.5,0,0,1-.35-.53l.43-4,.58-7.76a.49.49,0,0,1,.52-.47l11,.41-.93-9-3.29-2.6a.53.53,0,0,1-.19-.4.51.51,0,0,1,.2-.4l6.21-4.58-4-.27L228.72,133a.52.52,0,0,1-.45.07.49.49,0,0,1-.32-.31l-1.15-3.31a.5.5,0,0,1,.22-.6l2-1.17-1.65-.52a.5.5,0,0,1-.35-.53l.44-4.46a.51.51,0,0,1,.19-.34.52.52,0,0,1,.38-.1l1.36.2.21-1.84-3.72-4-1.19.12a.53.53,0,0,1-.52-.32l-1.73-4.46a.46.46,0,0,1,0-.38l1.58-3.46a.49.49,0,0,1,.39-.29l3.47-.44a.51.51,0,0,1,.47.21.49.49,0,0,1,0,.52l-1.26,2.29,3.21.59a.54.54,0,0,1,.33.22.52.52,0,0,1,.07.39l-.78,3.37,3.27,1.84a.47.47,0,0,1,.23.25l2.36,6.14,3,1.07a.49.49,0,0,1,.31.6l-1.41,5.21,2.93-2.17,1.1-4.57a.54.54,0,0,1,.36-.37l2.27-.59-2-8.19a.49.49,0,0,1,.31-.58l2.89-1.15a.49.49,0,0,1,.66.32l2.91,9.42,10.25-.93.13-4.9a.47.47,0,0,1,.22-.4,11.55,11.55,0,0,0,1.91-1.58c-.3-.64-1.65-3.22-2.5-4.83a.49.49,0,0,1,0-.41.53.53,0,0,1,.28-.29l2.05-.85-.62-2.93-4.43,2.79a.51.51,0,0,1-.66-.12l-4.47-5.62a.56.56,0,0,1-.09-.17l-3.37-12.09L245.83,89l.94,10.86,5.21,5a.49.49,0,0,1,.13.49l-1.11,4.3,2.66,5.44a.48.48,0,0,1,0,.39.5.5,0,0,1-.26.29l-2.74,1.3a.51.51,0,0,1-.63-.19l-6.16-9.63-1.62,3.25a.51.51,0,0,1-.56.26l-3.16-.72a.47.47,0,0,1-.35-.29L233.87,99.6a.5.5,0,0,1,0-.43l2.93-5.58-5.13-14.78a.47.47,0,0,1,0-.31L233,74a.5.5,0,0,1,.25-.3.56.56,0,0,1,.4,0l11.53,4.18a.51.51,0,0,1,.16.09c8.33,7.15,8.21,7.51,8.07,7.9a8.09,8.09,0,0,1-1.47,1.83l1.27,3.43L260,95l-2.45-7.71-5.37-4.38a.52.52,0,0,1-.18-.43l.22-2.65a.53.53,0,0,1,.3-.42.5.5,0,0,1,.51.08,124,124,0,0,1,46.24,96.83,126.27,126.27,0,0,1-.83,14.46.51.51,0,0,1-.39.43.5.5,0,0,1-.54-.23l-2.91-4.85a.51.51,0,0,1-.07-.24l-.13-5.7-.62.17-.27,6.91,2.14,7.84a.44.44,0,0,1,0,.32l-7.06,17.74a.48.48,0,0,1-.39.31.52.52,0,0,1-.47-.19l-2.31-3a.53.53,0,0,1-.1-.32l.29-10.67-1-16.7-1.24-.79-1.45.1-.5,3.42,2.28,12.75v17.68l4.39-1.5a.5.5,0,0,1,.51.11.54.54,0,0,1,.13.51l-2.31,7.51a.45.45,0,0,1-.06.12l-3.89,6a.86.86,0,0,1-.07.1l-12.62,12-4.87,10.15L262,255.21a.46.46,0,0,1-.21.18l-4.54,2.13c-5,4.5-7.76,7-8.38,7.36h0c-.4.32-2.9,3.81-5,6.93a.41.41,0,0,1-.17.15l-4,2.16L227,278.48l-.13,0-2.16.14Zm10.83-20c-.66,2.38-1.36,5.06-1.39,5.4v1.13a.5.5,0,0,1-.09.29l-8.35,12.12,1.06-.07,12.49-4.31,3.85-2.06c4.79-7,5.18-7.1,5.37-7.16.43-.26,5.26-4.59,8.18-7.25a.57.57,0,0,1,.13-.08l4.48-2.11,2.8-4.2,4.88-10.17a.56.56,0,0,1,.1-.15L281.65,228l3.82-5.94,2-6.51-4.12,1.42a.52.52,0,0,1-.45-.07.51.51,0,0,1-.21-.41v-18.3L280.4,185.4a.43.43,0,0,1,0-.16l.57-3.89a.5.5,0,0,1,.46-.43l2-.14a.54.54,0,0,1,.3.08l1.59,1a.52.52,0,0,1,.23.39l1,17-.29,10.54L288,212l6.67-16.77-2.11-7.76a.34.34,0,0,1,0-.15l.28-7.35a.51.51,0,0,1,.37-.46l1.59-.44a.51.51,0,0,1,.43.08.5.5,0,0,1,.2.39l.15,6.21,2.08,3.46a125,125,0,0,0,.66-12.87,123.1,123.1,0,0,0-45.13-95.46L253,82.31l5.28,4.31a.53.53,0,0,1,.16.23l2.88,9.08a.51.51,0,0,1-.17.54.5.5,0,0,1-.56,0l-8.07-4.61a.51.51,0,0,1-.22-.26l-1.44-3.9a.5.5,0,0,1,.12-.53,15.44,15.44,0,0,0,1.36-1.52c-.72-.86-4.32-4.09-7.62-6.91l-10.94-4-1.11,3.8,5.15,14.84a.47.47,0,0,1,0,.4l-2.92,5.56L239,109.2l2.53.58,1.84-3.69a.5.5,0,0,1,.42-.28.53.53,0,0,1,.45.23l6.39,10,1.89-.89L250,110a.5.5,0,0,1,0-.34l1.08-4.2-5.13-5a.51.51,0,0,1-.15-.31l-1-11.68a.51.51,0,0,1,.16-.41.48.48,0,0,1,.41-.13l2.89.43a.49.49,0,0,1,.41.36l3.43,12.3,4.13,5.19,4.66-2.93a.5.5,0,0,1,.46,0,.49.49,0,0,1,.3.36l.86,4a.51.51,0,0,1-.3.57l-1.93.8c.69,1.3,2.23,4.24,2.36,4.62s.25.77-2.14,2.45l-.13,5.09a.5.5,0,0,1-.45.48l-11.1,1a.5.5,0,0,1-.53-.35L245.4,113l-2,.79,2.06,8.23a.51.51,0,0,1-.36.61l-2.45.64-1.08,4.46a.53.53,0,0,1-.19.29L232,135l3,2.33a.53.53,0,0,1,.19.34l1,9.8a.53.53,0,0,1-.14.4.47.47,0,0,1-.38.15l-11.06-.41-.54,7.3-.39,3.65,4.66,1.47a.49.49,0,0,1,.35.47,2.88,2.88,0,0,0,.28,1.38,27.75,27.75,0,0,0,4.67.43l1.3-1.05a.51.51,0,0,1,.31-.11h2.2l2.57-3.73-1.33-2.91a.5.5,0,0,1,.22-.64l4.93-2.75.14-3.33a.5.5,0,0,1,.48-.48l3.59-.13a18.37,18.37,0,0,1,2.61-1.86c.28-.09.69-.22,6.09,4l3.66,3.79a.39.39,0,0,1,.08.1l1.44,2.59,1.45,3.06a.88.88,0,0,1,.05.15l.18,1.4.91-.55-.78-3.12a.52.52,0,0,1,.29-.58l1.68-.71-.08-.84-2.25-1.45a.4.4,0,0,1-.12-.1l-4-5.05-3.3-3.74a.49.49,0,0,1,0-.65l1.59-1.87a.49.49,0,0,1,.57-.14l2.45,1a.46.46,0,0,1,.16.11l8.07,8.07a.44.44,0,0,1,.14.28l.87,5.9.58,4.34.46,1.67,1.26-1.37a.57.57,0,0,1,.18-.12,2.94,2.94,0,0,0,1.14-.72,26.81,26.81,0,0,0-2.22-3.43.55.55,0,0,1-.07-.45l.86-2.73a.52.52,0,0,1,.48-.35h2a.51.51,0,0,1,.45.29l.51,1.09,1.37-2-1.21-3.36a.45.45,0,0,1,0-.23l1-7.93a.52.52,0,0,1,.2-.34.52.52,0,0,1,.38-.09l2.59.43a.5.5,0,0,1,.42.45l.25,3.19.5,0,.12-3.63a.51.51,0,0,1,.34-.46l2.6-.87a.51.51,0,0,1,.57.19l1,1.45a.52.52,0,0,1,0,.51l-1.46,2.9,4.59,6.82s0,.07.06.1c.31.82.75,2.26.17,2.84l-.29.33c-.39.45-.86,1-1.51.8-.45-.15-2.13-.85-2.2-.88a.44.44,0,0,1-.16-.1l-1.12-1.12-2.33.36-1.47,1.48-.11.08s-1.31.73-1.88,1a5,5,0,0,0-1.19,1.18l-.12,1.49,1.12,3.8a.78.78,0,0,1,0,.14v.65h1.67a.55.55,0,0,1,.36.15L281,166l1.92.65a10.77,10.77,0,0,0,1.59-1.8.5.5,0,0,1,.43-.21.54.54,0,0,1,.41.27l1,1.87a.5.5,0,0,1,.05.32l-1.58,9.23a.49.49,0,0,1-.47.41c-.12,0-3,.14-3.48.14a38.4,38.4,0,0,0-3.53,1.54.5.5,0,0,1-.57-.09l-5.56-5.42-1.43.42-.82,4.44-.45,1.37a.51.51,0,0,1-.32.32.52.52,0,0,1-.45-.07,38.71,38.71,0,0,0-4.11-2.81c-.23,0-.68,0-2.19-3.87l-6.6-3.37a.54.54,0,0,1-.26-.33.52.52,0,0,1,.09-.42l1.6-2.14-.61-4.16-3.23.75-17.74,3.32a.67.67,0,0,1-.28,0l-2.14-.88L227.05,171a.49.49,0,0,1-.27.15l-2.06.36-.27,6.23a.49.49,0,0,1-.2.37L218,182.78l-4.57,7.13-2.51,4.33.15,15.26,8.67,11.35,19.65-.29a.57.57,0,0,1,.25.06l3.67,2,2.67.55a.51.51,0,0,1,.34.25.49.49,0,0,1,0,.41l-3,8.24c.83,3.82,2.37,10,3,10.9C247.23,244,243.56,249.3,235.5,258.64Zm23.38-97.33,2.2.84a.45.45,0,0,1,.26.23l.58,1.12-.29-2.64-2.39-.1Zm-31-31.84.79,2.28,3.91-2.91a.56.56,0,0,1,.33-.1l3.92.26,1.23-4.49-2.75-1a.5.5,0,0,1-.3-.29L232.63,117l-3.44-1.93a.5.5,0,0,1-.25-.55l.75-3.23-3.38-.62a.51.51,0,0,1-.36-.28.5.5,0,0,1,0-.46l1.12-2-2.22.28-1.38,3,1.52,3.91,1.06-.1a.51.51,0,0,1,.42.15l4,4.33a.53.53,0,0,1,.13.4l-.29,2.59a.52.52,0,0,1-.2.34.49.49,0,0,1-.37.1l-1.35-.2-.35,3.53,2.35.74a.49.49,0,0,1,.35.42.51.51,0,0,1-.25.49ZM111.35,200.74a.51.51,0,0,1-.4-.19.5.5,0,0,1-.08-.46l.76-2.35a.52.52,0,0,1,.51-.35l2.61.18-.77-2.71a.48.48,0,0,1,0-.39.51.51,0,0,1,.32-.24l3.52-.76a.53.53,0,0,1,.37.07l4.08,2.49a.5.5,0,0,1,.23.52l-.49,2.41a.49.49,0,0,1-.57.4l-3-.49-.65,1.32a.5.5,0,0,1-.43.28l-6.08.27Zm1.12-2.32-.42,1.29,5.06-.22.69-1.4a.49.49,0,0,1,.53-.27l2.85.47.32-1.59-3.61-2.21-2.8.61.81,2.88a.49.49,0,0,1-.09.45.51.51,0,0,1-.42.18Zm-.57-2.71h0l-6.63-.42a.48.48,0,0,1-.28-.1l-5.52-4.28-2.53,1.61a.52.52,0,0,1-.56,0l-1-.75a.51.51,0,0,1-.21-.37.54.54,0,0,1,.15-.4l2.22-2.15a.61.61,0,0,1,.34-.14l5-.07a.44.44,0,0,1,.33.12l3.84,3.17,5.9,1.43a.51.51,0,0,1,.34.3.5.5,0,0,1,0,.46l-.9,1.39A.5.5,0,0,1,111.9,195.71Zm-6.45-1.41,6.19.4.36-.56-5.33-1.28a.54.54,0,0,1-.2-.1l-3.79-3.13-4.65.06-1.65,1.6.28.2,2.54-1.61a.51.51,0,0,1,.58,0Zm148.2-34.47a.39.39,0,0,1-.15,0l-1.65-.53a.49.49,0,0,1-.32-.32.51.51,0,0,1,.06-.45l.22-.3-.18-1.32-.71-3.46a.48.48,0,0,1,.16-.47.49.49,0,0,1,.49-.1l2.37.79a.51.51,0,0,1,.32.32l1.12,3.55a.48.48,0,0,1-.08.45l-1.25,1.66A.51.51,0,0,1,253.65,159.83Zm-.86-1.3.67.22.89-1.17-1-3.06-1.3-.44.54,2.64.21,1.56A.43.43,0,0,1,252.79,158.53Zm1.06-5.82h-.11l-1.52-.33a.49.49,0,0,1-.37-.36l-.46-1.78a.49.49,0,0,1,.14-.49l1-.92a.49.49,0,0,1,.81.21l1,3a.51.51,0,0,1-.11.49A.51.51,0,0,1,253.85,152.71Zm-1.11-1.25.36.08-.47-1.46-.2.19ZM146.25,139.83a.32.32,0,0,1-.14,0l-2.45-.73a.48.48,0,0,1-.35-.56l.36-2.1-3.18,2.31a.5.5,0,0,1-.67-.08l-2.45-2.89a.5.5,0,0,1-.06-.57l3.6-6.48a.56.56,0,0,1,.24-.22l4-1.73a.53.53,0,0,1,.5.06.51.51,0,0,1,.2.46l-.27,2.5,1.35,1.35,4.62-1.36a.51.51,0,0,1,.6.29l1.73,4.17a.49.49,0,0,1-.1.54l-4.61,4.76a.49.49,0,0,1-.43.15.53.53,0,0,1-.37-.25l-.94-1.7-.76,1.8A.49.49,0,0,1,146.25,139.83Zm-1.88-1.58,1.59.48,1-2.34a.49.49,0,0,1,.43-.31.51.51,0,0,1,.47.26l1.11,2,3.91-4-1.43-3.45L147,132.17a.49.49,0,0,1-.49-.12l-1.73-1.73a.53.53,0,0,1-.15-.41l.2-1.89-3.1,1.33-3.35,6,1.93,2.28,3.81-2.76a.49.49,0,0,1,.78.49Zm77.23-11a.71.71,0,0,1-.6-.2l-1.3-1.3a.51.51,0,0,1,0-.64l1.39-2-1.54-2.32a.49.49,0,0,1,0-.47l1.29-3a.5.5,0,0,1,.6-.29l4.47,1.3a.49.49,0,0,1,.36.47l.14,6.63a.51.51,0,0,1-.3.47C223.4,126.92,222.19,127.2,221.6,127.2Zm0-1h0a17.23,17.23,0,0,0,3.67-1.19l-.12-5.93L221.5,118l-1,2.37,1.57,2.38a.5.5,0,0,1,0,.56l-1.34,2ZM136,99.9h-3.9a.5.5,0,0,1-.47-.32l-3-8.17-6.28.27a.48.48,0,0,1-.44-.22.5.5,0,0,1,0-.49l1-2.16a.52.52,0,0,1,.42-.29l4.64-.28c.42-.24,2-1.14,2.45-1.5.25-.18.94-.81,1.61-1.41.91-.82,1.5-1.36,1.79-1.57a47,47,0,0,0,1.26-6.27l-2.26-2.77-3.74.67a.51.51,0,0,1-.44-.14l-1.73-1.73a.51.51,0,0,1,0-.7L133.19,66a.55.55,0,0,1,.19-.12l4.91-1.87a.5.5,0,0,1,.51.09.49.49,0,0,1,.16.48l-.77,3.43,4.87,1.32a.5.5,0,0,1,.35.63L143,71.48l2.08,1.1a.5.5,0,0,1,.27.44v3.31a.5.5,0,0,1-.22.42l-2.45,1.63L147,81.71a.5.5,0,0,1,.17.58l-1.29,3.31a.78.78,0,0,1-.1.15l-3.32,3.61a.5.5,0,0,1-.49.15.49.49,0,0,1-.36-.36l-.93-3.57a4.66,4.66,0,0,0-1.44,0c-.15.62-.52,2.49-.65,3.13l1.45,2a.5.5,0,0,1,0,.54l-2,3.6a.53.53,0,0,1-.37.25l-2.44.34,1.26,3.77a.48.48,0,0,1-.06.45A.51.51,0,0,1,136,99.9Zm-3.55-1h2.86l-1.23-3.67a.52.52,0,0,1,0-.42.49.49,0,0,1,.36-.23l2.79-.4,1.74-3.1-1.39-1.91a.46.46,0,0,1-.09-.39c0-.12.57-2.9.73-3.49s1.12-.89,2.84-.66a.48.48,0,0,1,.42.37l.78,3L145,85.14l1.12-2.87-4.6-3.52a.48.48,0,0,1-.2-.41.53.53,0,0,1,.22-.4l2.81-1.87V73.32l-2.18-1.15a.5.5,0,0,1-.25-.59l.42-1.38-4.83-1.31a.5.5,0,0,1-.36-.6l.67-3-3.93,1.5-5.92,6.34,1.2,1.21,3.77-.68a.52.52,0,0,1,.48.18L136,77a.46.46,0,0,1,.1.39c-1,6.71-1.45,7-1.65,7.12s-1.06.91-1.75,1.53-1.39,1.26-1.68,1.47c-.6.45-2.57,1.58-2.65,1.63a.43.43,0,0,1-.22.06l-4.46.27-.54,1.15,5.82-.26a.51.51,0,0,1,.49.33Zm6.78-13.37h0ZM116.12,98.31h-1.73a.51.51,0,0,1-.44-.26.49.49,0,0,1,0-.51l1.45-2.17a.51.51,0,0,1,.49-.22l3,.44a.49.49,0,0,1,.42.39.52.52,0,0,1-.22.53l-2.75,1.73A.52.52,0,0,1,116.12,98.31Zm-.79-1H116l1.47-.93-1.37-.2ZM114,95.86a.5.5,0,0,1-.31-.1l-2.74-2.16a.52.52,0,0,1-.19-.36.53.53,0,0,1,.13-.38l3.75-4a.53.53,0,0,1,.33-.15l3.61-.29a.48.48,0,0,1,.5.3l1.73,4a.49.49,0,0,1-.16.59l-1.88,1.44a.5.5,0,0,1-.67-.06l-1-1.1-2.8,2.17A.5.5,0,0,1,114,95.86Zm-2-2.71,2,1.58,2.86-2.21a.5.5,0,0,1,.68.06l1,1.1,1.21-.93-1.44-3.35-3.06.25ZM201.75,95a.57.57,0,0,1-.18,0l-6.92-2.73a.5.5,0,0,1-.31-.35.52.52,0,0,1,.12-.45l1.29-1.4-3.31-1.72a.52.52,0,0,1-.23-.65l1.15-2.59a.5.5,0,0,1,.54-.29l5.6.93.32-1.42a.5.5,0,0,1,.49-.39h4.61a.5.5,0,0,1,.5.5v3.08l2.7,2.16a.53.53,0,0,1,.19.4.52.52,0,0,1-.2.4l-6.06,4.46A.55.55,0,0,1,201.75,95Zm-6.06-3.42,6,2.36L207,90l-2.38-1.91a.48.48,0,0,1-.19-.39V84.9h-3.71l-.34,1.5a.51.51,0,0,1-.57.38l-5.68-1-.8,1.81,3.46,1.8a.5.5,0,0,1,.15.78ZM105.46,79.72a.5.5,0,0,1-.24-.06.49.49,0,0,1-.26-.4l-.15-2.17a.52.52,0,0,1,.12-.36l1.67-1.92-.79-1.66a.5.5,0,0,1,.19-.64l6.92-4.27a.49.49,0,0,1,.76.45l-.2,3.52,2.62-.12a.52.52,0,0,1,.37.14.55.55,0,0,1,.15.36c0,5.41-.43,5.55-.78,5.66s-3.83.93-4.22,1a.49.49,0,0,1-.29,0l-2.81-1.07-2.83,1.49A.59.59,0,0,1,105.46,79.72Zm.36-2.49.09,1.19,2.35-1.23a.49.49,0,0,1,.41,0l2.88,1.09c1.28-.29,3.2-.74,3.81-.91a28.07,28.07,0,0,0,.26-4.23l-2.65.11a.46.46,0,0,1-.38-.15.5.5,0,0,1-.14-.37l.18-3.12-5.73,3.53.74,1.56a.49.49,0,0,1-.07.54Zm9.7.07h0Zm28.42-8.69a.52.52,0,0,1-.29-.09l-3-2.16a.5.5,0,0,1-.14-.66l.86-1.44a.49.49,0,0,1,.48-.24l4.47.43a.48.48,0,0,1,.41.29.5.5,0,0,1-.06.5l-2.31,3.17A.49.49,0,0,1,143.94,68.61Zm-2.35-2.8,2.24,1.61,1.5-2.06L142.05,65Zm-17.76-2.09a.48.48,0,0,1-.45-.28.49.49,0,0,1,.22-.66l2-1a.5.5,0,0,1,.65.17l.08.12a.51.51,0,0,1,.06.42.47.47,0,0,1-.29.31l-1.19.53-.83.36A.48.48,0,0,1,123.83,63.72Zm4.12-.58a.5.5,0,0,1-.49-.39l-.24-1.08a.49.49,0,0,1,.3-.57,124,124,0,0,1,31.71-8.32.49.49,0,0,1,.5.25.5.5,0,0,1-.06.57c-1.17,1.39-3.29,3.8-4.31,4.17s-5.55,2.29-5.6,2.3l-1.15.79-1.25,1.52a.53.53,0,0,1-.23.16l-1.3.44a.55.55,0,0,1-.22,0,28.49,28.49,0,0,0-3-.15h-2.88a.5.5,0,0,1-.31-.89l2.8-2.18a16.94,16.94,0,0,0-2.21,0,2.42,2.42,0,0,0-.45.31.58.58,0,0,1,.21.4c0,.54-.45.79-2.24,1.18-3.31.72-9.5,1.44-9.56,1.45Zm.34-1.27.05.22c1.48-.18,6.27-.78,9-1.38l.8-.18v0a.5.5,0,0,1,.12-.53,5.58,5.58,0,0,1,1.49-1.13,26.14,26.14,0,0,1,3.92,0,.52.52,0,0,1,.46.35.52.52,0,0,1-.17.55l-2.74,2.13h1.43c1.47,0,2.61.11,3,.14l1.06-.35,1.21-1.47.11-.1,1.3-.87c.27-.12,4.57-1.93,5.72-2.36a14.18,14.18,0,0,0,3.05-2.9A122.54,122.54,0,0,0,128.29,61.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.29,291.8a.48.48,0,0,1-.28-.08l-.7-.47-7-6.54a.42.42,0,0,1-.11-.15L129.73,255l-8.94-4.82a.41.41,0,0,1-.13-.1l-7.21-7.78-1.83-1.54a.5.5,0,0,1-.18-.39v-4.47l-2.8-4.49a.5.5,0,0,1,0-.43l2.69-7.64-1.49-6-2.4-1-.64,1.07a.51.51,0,0,1-.56.23l-8.36-2.31a.53.53,0,0,1-.3-.23l-4.06-6.86L86.06,207a.54.54,0,0,1-.35-.23l-2.12-3.44-5.7,1.35a.5.5,0,0,1-.54-.24,20.29,20.29,0,0,0-2.49-3.6c-.87-.73-7.15-13.33-9.06-17.17l-1.91-6.14-1.82-3.77-.76.13L67.44,190a.49.49,0,0,1-.13.54.51.51,0,0,1-.56.08l-2.31-1.15a.47.47,0,0,1-.25-.27l-5.76-15.71a.45.45,0,0,1,0-.16l-.15-5.29-1-4.27a1,1,0,0,1,0-.17L59,146.48l0-.12,4.87-13.19.57-9.58a.61.61,0,0,1,0-.18l3.61-7.65.7-2,1.5-5.21a.35.35,0,0,1,.06-.14,124.23,124.23,0,0,1,34-34.83.47.47,0,0,1,.4-.07.51.51,0,0,1,.33.26l.51,1a.49.49,0,0,1,0,.47L101.73,82l1.54.54,1.94-2.46a.49.49,0,0,1,.46-.18l6.58,1,2.4-1.59,2.3-2.44.55-4a.51.51,0,0,1,.29-.38l2.55-1.21-4.15.57a.5.5,0,0,1-.56-.42l-.57-3.75a.49.49,0,0,1,.26-.52l8.28-4.32.85-.38,1.22-.53a.5.5,0,0,1,.62.21l.79,1.32a.51.51,0,0,1-.13.66l-5.55,4.07,5.77-.65a.48.48,0,0,1,.45.19.49.49,0,0,1,.08.48l-1.3,3.46a.49.49,0,0,1-.23.26l-6.31,3.43.79,4a.57.57,0,0,1,0,.13l3.92-3.72a.48.48,0,0,1,.61-.05l4.18,2.74a.45.45,0,0,1,.22.33.48.48,0,0,1-.09.38L126,83.7a.8.8,0,0,1-.13.13L122,86.27a.48.48,0,0,1-.23.07l-5.15.43C107.3,96.83,106.77,97,106.59,97s-2.56,2.35-4.21,3.94A46,46,0,0,1,98,105a34.33,34.33,0,0,0-.38,5c3.69,3.28,7.89,6.67,8.63,6.79a.8.8,0,0,1,.59.35c.83,1.11.12,5.74-.23,7.72l2.89.85.8-8.76a.5.5,0,0,1,.38-.44c2.42-.58,5.21-1.47,5.68-1.92,0-.26-.08-.82-.15-1.46-.54-4.78-.53-6.3,0-6.76s1.85-1.33,2.31-1.64c1.62-7.9,2.17-8,2.49-8.11.13,0,.34-.11.6-.2a8.48,8.48,0,0,1,3.19-.68c1.2.18,4.95,4,5.17,4.67.05.14.19.55-1.64,7.17a9.64,9.64,0,0,0,1.82,1.12,84.92,84.92,0,0,0,6.47-6.46.5.5,0,0,1,.48-.14.47.47,0,0,1,.36.33c.69,2,2.91,8.84,2.77,9.88a14.57,14.57,0,0,1-1,2.87l5.63,3a.49.49,0,0,1,.26.35l1,5.19a.49.49,0,0,1-.2.5l-5.18,3.74a7.65,7.65,0,0,1-5.05,2,79.07,79.07,0,0,0-9.61,1.28l-7.9,5.39,1.76,1,7.23-5.43a.54.54,0,0,1,.3-.1h2a.49.49,0,0,1,.42.24.48.48,0,0,1,0,.48l-1.34,2.81,1.54,3.56,4-2.81a.5.5,0,0,1,.63,0l2.31,2.16a.5.5,0,0,1-.12.81l-6.38,3.13-2.66,3.77a.49.49,0,0,1-.61.17l-2.31-1a.5.5,0,0,1-.28-.32.48.48,0,0,1,.07-.42l2-2.84-1.28-.64-2.31,1.15-1.83,1.55-2.61,1.92-.67,3.22v1.11a.48.48,0,0,1-.25.43l-3.18,1.87-4.29,1.82c-.77,3.1-1.53,6.47-1.52,6.91s.38,3.1.45,3.92a.5.5,0,0,1-.19.43l-9.69,7.73L102.62,185a.49.49,0,0,1-.34.61l-2,.58a.51.51,0,0,1-.6-.27l-1.73-3.89a.59.59,0,0,1,0-.23l.13-3.28-1.84-2.47-1.69.48a.52.52,0,0,1-.42-.06l-1.56-1-4,.62v2.45a.51.51,0,0,1-.22.42.52.52,0,0,1-.47.05l-4.76-1.91-4.91,4.26L79,193.12l2.55,5.5,3.94-.38,1.78-1.77.55-3.87a.52.52,0,0,1,.47-.43l4.89-.29a.51.51,0,0,1,.39.16.53.53,0,0,1,.14.4l-1.09,10.07,6-.4a.5.5,0,0,1,.52.43l1.14,7.78,2.57,2.82,3.44-1a.5.5,0,0,1,.38,0l2.86,1.48,1.36-2.84a.48.48,0,0,1,.5-.28,11.09,11.09,0,0,0,2.42,0,10.49,10.49,0,0,1,1.34-1.75.49.49,0,0,1,.34-.17l2.16-.15a.54.54,0,0,1,.38.15.5.5,0,0,1,.15.38l-.27,5.19,1.1.21-.24-2.94a.5.5,0,0,1,.31-.5l2.45-1a.49.49,0,0,1,.44,0l2.18,1.23a14.63,14.63,0,0,1,2.31.17,10.14,10.14,0,0,1,2.56,2l2.13-1.13a.52.52,0,0,1,.5,0l5.91,3.74,3.06,2.51,5.27-.41a.53.53,0,0,1,.32.08c9.45,6.34,9.38,6.73,9.32,7.1a.6.6,0,0,1-.29.39,11.1,11.1,0,0,0-.69,3l17.94,7.06,5.38,2.61a.5.5,0,0,1,.28.42l.14,2.16a.48.48,0,0,1-.1.33l-7,9.4-.57,9.65a.53.53,0,0,1-.25.41L161,266.08l-3.13,11.19a.5.5,0,0,1-.48.36H154l.83,1.27a.49.49,0,0,1,.07.36l-.67,3.93a.51.51,0,0,1-.28.37l-1.66.75,1.1,2.53a.48.48,0,0,1,.14.44l-.7,4.11a.5.5,0,0,1-.29.37A.48.48,0,0,1,152.29,291.8ZM145.07,284l6.86,6.42.53-3.11a.25.25,0,0,1,0-.07l-1.29-3a.5.5,0,0,1,.25-.65l1.86-.84.59-3.48-1.23-1.87a.49.49,0,0,1,0-.51.5.5,0,0,1,.44-.27H157l3.08-11a.47.47,0,0,1,.23-.3L169.7,260l.56-9.53a.49.49,0,0,1,.1-.26l6.95-9.38-.11-1.68-5.08-2.48-18.27-7.18a.5.5,0,0,1-.32-.53,10.76,10.76,0,0,1,.87-3.72c-1-.9-5-3.65-8.57-6.08l-5.3.41a.52.52,0,0,1-.36-.11l-3.17-2.6-5.61-3.55-2.2,1.17a.5.5,0,0,1-.58-.09,14.07,14.07,0,0,0-2.37-2,13.71,13.71,0,0,0-2.19-.14.54.54,0,0,1-.25-.06L121.72,211l-1.89.78.26,3.23a.52.52,0,0,1-.17.42.48.48,0,0,1-.43.11l-2.17-.43a.49.49,0,0,1-.4-.51l.26-5.06-1.39.1a7.43,7.43,0,0,0-1.06,1.4c-.1.28-.27.77-3.06.52l-1.43,3a.5.5,0,0,1-.68.23l-3.14-1.63-3.55,1.09a.5.5,0,0,1-.52-.14l-2.88-3.17a.45.45,0,0,1-.12-.26l-1.1-7.48-6.17.4a.47.47,0,0,1-.39-.15.53.53,0,0,1-.14-.4l1.09-10.07-3.89.23-.52,3.62a.54.54,0,0,1-.15.29l-2,2a.49.49,0,0,1-.3.14l-4.47.43a.48.48,0,0,1-.5-.29l-2.74-5.91a.48.48,0,0,1,0-.17l-.86-12.11a.49.49,0,0,1,.17-.41l5.33-4.62a.49.49,0,0,1,.52-.09l4.36,1.75v-2.15a.5.5,0,0,1,.42-.49l4.61-.72a.51.51,0,0,1,.36.08l1.53,1,1.8-.52a.51.51,0,0,1,.54.18l2.16,2.89a.55.55,0,0,1,.1.32l-.14,3.35,1.51,3.38,1.12-.32L98.35,173.2a.49.49,0,0,1,.17-.53l9.74-7.76c-.14-1.57-.31-3.25-.39-3.5s-.19-.58,1.58-7.64a.47.47,0,0,1,.29-.34l4.46-1.88,2.87-1.69V149a.38.38,0,0,1,0-.1l.72-3.46a.51.51,0,0,1,.19-.3l2.74-2,1.85-1.57a.33.33,0,0,1,.1-.06l2.59-1.29a.49.49,0,0,1,.44,0l2,1a.47.47,0,0,1,.26.32.5.5,0,0,1-.07.41l-2,2.81,1.38.59,2.5-3.54a.52.52,0,0,1,.19-.17l5.84-2.86-1.48-1.38-4.13,2.93a.49.49,0,0,1-.42.08.5.5,0,0,1-.33-.29l-1.88-4.33a.49.49,0,0,1,0-.41l1.1-2.31h-1.06l-7.36,5.52a.5.5,0,0,1-.55,0L117,137a.52.52,0,0,1-.25-.42.5.5,0,0,1,.22-.43l8.65-5.9a.64.64,0,0,1,.19-.08,81.17,81.17,0,0,1,9.89-1.31,6.81,6.81,0,0,0,4.41-1.73l5-3.6-.9-4.65-5.84-3.06a.5.5,0,0,1-.22-.66,16.75,16.75,0,0,0,1.12-3,66.5,66.5,0,0,0-2.46-8.63c-5.81,6.17-6.34,6.17-6.57,6.17a7.35,7.35,0,0,1-2.75-1.54.47.47,0,0,1-.18-.53c.82-3,1.67-6.29,1.72-6.94-.47-.7-3.64-3.86-4.34-4a8.12,8.12,0,0,0-2.72.63l-.55.19a54.21,54.21,0,0,0-1.93,7.58.51.51,0,0,1-.21.32s-1.72,1.14-2.42,1.7c-.28.53.15,4.4.32,5.86.1.91.16,1.43.16,1.67s0,1.23-6.09,2.72l-.83,9a.55.55,0,0,1-.22.37.48.48,0,0,1-.42.06l-3.9-1.15a.49.49,0,0,1-.35-.57c.65-3.48.88-6.8.51-7.35-1.49-.33-7.46-5.56-9.28-7.17a.52.52,0,0,1-.17-.39c.14-5.6.51-6.07,1-6.11.48-.34,2.5-2.29,4.14-3.87,3.57-3.44,4.31-4.11,4.66-4.19.55-.36,6.25-6.38,9.69-10.09a.51.51,0,0,1,.33-.15l5.22-.43L125.3,83l3.08-4.12L125,76.68l-5.49,5.21a.5.5,0,0,1-.79-.58l.94-2-.83-4.17a.52.52,0,0,1,.25-.54l6.47-3.51.94-2.52-6.82.78a.5.5,0,0,1-.53-.31.52.52,0,0,1,.17-.59l6.7-4.92-.34-.56-.79.36-.83.36-7.93,4.14.44,2.91,6.86-.94a.5.5,0,0,1,.29.95l-5.23,2.48-.54,3.9a.57.57,0,0,1-.14.28L115.33,80l-.08.07-2.6,1.73a.49.49,0,0,1-.35.08l-6.49-1-2,2.51a.5.5,0,0,1-.56.17l-2.45-.86a.5.5,0,0,1-.3-.3.5.5,0,0,1,0-.43l4-7-.13-.26a123.34,123.34,0,0,0-33.22,34.16l-1.49,5.18-.73,2-3.59,7.61-.57,9.55a.4.4,0,0,1,0,.15L60,146.65l-1.72,17,1,4.24s0,.07,0,.1l.15,5.26,5.66,15.44,1,.5-5.89-15.53a.5.5,0,0,1,0-.43.49.49,0,0,1,.35-.24l1.73-.29a.51.51,0,0,1,.53.28l2,4.18,1.91,6.13c3,6.08,8.11,16.11,8.78,16.78A19.26,19.26,0,0,1,78,203.62l5.69-1.34a.51.51,0,0,1,.54.22l2.19,3.55,7.41,1.26a.49.49,0,0,1,.35.24l4.08,6.89,7.8,2.15.67-1.12a.51.51,0,0,1,.63-.21l3,1.3a.54.54,0,0,1,.29.34l1.58,6.35a.57.57,0,0,1,0,.29l-2.66,7.55,2.75,4.41a.5.5,0,0,1,.08.26v4.39l1.7,1.44,7.2,7.76,9,4.85a.56.56,0,0,1,.21.22Zm10.12-58.32h0ZM106.12,117.77h0Zm15.19-20.2h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.78,105c-1.6,0-4.07-2.24-4.9-3a.58.58,0,0,1-.11-.15l-1.88-4.18a.61.61,0,0,1,0-.13l-1.73-12a.42.42,0,0,1,0-.27,11.86,11.86,0,0,1,2.16-3.34,27.09,27.09,0,0,1,2.39-1.82l.53-.37c.47-.34.49-.79.47-1.48a4.36,4.36,0,0,1,0-.81c0-.18-.41-.72-1-1.16-.57-.09-2.47-.51-2.47-1.92,0-1.12,1.47-2.08,2.29-2.52a1.46,1.46,0,0,0-1-.72.68.68,0,0,1-.51-.34c-.38-.64.1-2.09,1.71-6.11A22.91,22.91,0,0,0,161,61.15a10.58,10.58,0,0,0-1.09-.64c-.89-.5-1.89-1-2.2-1.87a1.11,1.11,0,0,1,.06-.87c.52-1.05,2.79-1.84,3.47-2.06.12-.13.3-.36.23-.48a.65.65,0,0,1,0-.53c.25-.57,2.05-1.41,5.36-2.48a.61.61,0,0,1,.13,0c.81,0,7.9-.27,9.52.17a15.57,15.57,0,0,0,1.57.32,7.48,7.48,0,0,1,3.21,1c.32.25.86.6,1.54,1.05a55.64,55.64,0,0,1,6.42,4.75c.85.77,1.55,2.3,2.15,4.69,1.13,4.6,1.58,11.82,1.12,12.65h0c-.16.3-.58.65-3.79,1.62-2.53.76-5.71,1.56-6.36,1.66-.37.27-.75,2.77-.88,3.7a7.78,7.78,0,0,1-.33,1.64c-.48.94-6.39,2.17-7.28,2.29-.58.34-3,3.48-5,6.42a30.78,30.78,0,0,1,.12,4.52c-.16,2.07-3.09,4.86-4.35,6A1.2,1.2,0,0,1,163.78,105Zm-4.13-3.69c1.84,1.76,3.87,3,4.29,2.65,1.87-1.64,3.91-3.89,4-5.27a29,29,0,0,0-.14-4.53.52.52,0,0,1,.09-.34c4.9-7,5.61-7,5.88-7a31.4,31.4,0,0,0,6.5-1.79c.06-.21.14-.8.22-1.29.39-2.66.73-4.41,1.72-4.55.54-.08,3.61-.85,6.22-1.63a15.8,15.8,0,0,0,3.21-1.17,47.5,47.5,0,0,0-1.23-11.9c-.66-2.69-1.37-3.76-1.84-4.19a54.83,54.83,0,0,0-6.31-4.66c-.69-.46-1.25-.83-1.58-1.08a6.7,6.7,0,0,0-2.78-.86c-.55-.1-1.12-.2-1.66-.34-1.23-.34-7-.22-9.15-.14a25.39,25.39,0,0,0-4.59,1.86,1.62,1.62,0,0,1-.67,1.49.51.51,0,0,1-.16.09c-1.08.33-2.71,1-3,1.58.15.55,1,1,1.73,1.42s1.36.76,1.55,1.24-.1,1.22-1.27,4.13A29.67,29.67,0,0,0,159,70.12a2.7,2.7,0,0,1,1.76,1.74.5.5,0,0,1-.26.61c-.87.41-2.16,1.28-2.16,1.84s1.18.88,1.73,1a.65.65,0,0,1,.22.08c.4.29,1.69,1.28,1.49,2.25a3.4,3.4,0,0,0,0,.58,2.44,2.44,0,0,1-.89,2.32l-.53.38A27.88,27.88,0,0,0,158,82.63a10.25,10.25,0,0,0-1.83,2.86l1.69,11.75Zm14.19-13.48h0Zm.06,0Zm6.81-2.5h0Zm11-8.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.37,293.9h0c-.83,0-1.66,0-2.48-.1a.48.48,0,0,1-.47-.52.47.47,0,0,1,.52-.47c.82,0,1.63.07,2.46.09a.5.5,0,0,1,0,1Zm-39-7.84a.57.57,0,0,1-.18,0,118.56,118.56,0,0,1-70-75.3.5.5,0,0,1,.34-.62.48.48,0,0,1,.62.33,117.47,117.47,0,0,0,69.38,74.65.5.5,0,0,1-.18,1Zm-71.8-82.9a.5.5,0,0,1-.48-.39,117.85,117.85,0,0,1-2.9-22,.5.5,0,1,1,1,0,116.86,116.86,0,0,0,2.87,21.76.5.5,0,0,1-.37.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,363.88H110.6a.5.5,0,0,1-.5-.5V351.94a.5.5,0,0,1,.5-.5H260.25a.5.5,0,0,1,.5.5v11.44A.5.5,0,0,1,260.25,363.88Zm-149.15-1H259.75V352.44H111.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M610.51,315.63s-1.65,12.15-1.65,12.7,4.28,5.37,6.37,6.47-3.29,2.09-5.6,1.87-5.7-.88-6.36-1.32a2.55,2.55,0,0,1-1.54-2.3,43.23,43.23,0,0,1,.77-6.26l-.19-11.57Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.26,337.19l-.68,0c-2.13-.21-5.77-.86-6.59-1.4l-.19-.13a2.88,2.88,0,0,1-1.57-2.56,41.18,41.18,0,0,1,.77-6.33l-.19-11.52a.48.48,0,0,1,.15-.37.44.44,0,0,1,.37-.14l8.2.41a.5.5,0,0,1,.47.56c-.65,4.83-1.62,12.17-1.64,12.64.22.56,4.18,5,6.1,6,.79.42.78.91.71,1.17C615.8,336.75,612.13,337.19,610.26,337.19Zm-7.45-21.44.19,11a.31.31,0,0,1,0,.1,44,44,0,0,0-.76,6.13,1.92,1.92,0,0,0,1.11,1.79l.2.13a25.19,25.19,0,0,0,6.14,1.24,12.34,12.34,0,0,0,5.43-.86l-.12-.07c-1.85-1-6.63-5.95-6.63-6.91,0-.52,1.19-9.36,1.58-12.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.61,327.06s1.24-1.86,2.94-1.24a4.28,4.28,0,0,1,2.31,2.51s4.5,4.3,6.2,4.92,2.17.77,1.55,2.17-2.48,3.09-6.65,2.78-6.66-1.7-7.12-1.55-2.32,1.4-2.48-.62,1.08-6.34,1.08-6.34-.61-1.55.16-2A6,6,0,0,1,603.61,327.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.92,338.74c-.32,0-.65,0-1,0a24,24,0,0,1-6-1.28,6.45,6.45,0,0,0-1-.28s-.07.05-.17.09a2.42,2.42,0,0,1-2.17.27,1.69,1.69,0,0,1-.73-1.43,25.38,25.38,0,0,1,1.06-6.36c-.17-.5-.53-1.89.42-2.46a6.74,6.74,0,0,1,2-.66,3.09,3.09,0,0,1,3.39-1.24,4.68,4.68,0,0,1,2.57,2.7c1.3,1.23,4.66,4.26,5.94,4.73s1.8.65,2,1.24a2.08,2.08,0,0,1-.21,1.6C616.73,336.38,615.32,338.74,610.92,338.74Zm-8-2.6a4.67,4.67,0,0,1,1.27.33A22.47,22.47,0,0,0,610,337.7c4.54.35,5.87-1.82,6.16-2.49s.24-.73.21-.79-.7-.42-1.42-.68c-1.8-.66-6-4.6-6.42-5.05a.46.46,0,0,1-.13-.21,3.87,3.87,0,0,0-2-2.19c-1.31-.48-2.31,1-2.35,1a.47.47,0,0,1-.36.21,5.88,5.88,0,0,0-1.81.56c-.26.15-.14.92,0,1.39a.47.47,0,0,1,0,.33s-1.21,4.27-1.06,6.17c0,.33.11.56.23.63s.95-.17,1.25-.3l.34-.15A.69.69,0,0,1,602.93,336.14Zm.68-9.08h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.63,336.67c2.31,0,2.65-.94,4.2-2s2.78.78,2.78.78c-.62,1.39-2.48,3.09-6.65,2.78s-6.66-1.7-7.12-1.55-2.32,1.4-2.48-.62a8.69,8.69,0,0,1,.06-1.48,2.91,2.91,0,0,1,1-.37C603.61,333.87,607.33,336.65,609.63,336.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.92,338.74c-.32,0-.65,0-1,0a24,24,0,0,1-6-1.28,6.45,6.45,0,0,0-1-.28s-.07.05-.17.09a2.42,2.42,0,0,1-2.17.27,1.69,1.69,0,0,1-.73-1.43,8.93,8.93,0,0,1,.06-1.57.53.53,0,0,1,.25-.38,3.45,3.45,0,0,1,1.2-.44c1.29-.18,2.89.53,4.58,1.28a11.3,11.3,0,0,0,3.68,1.21h0a3.62,3.62,0,0,0,2.83-1.12,12.79,12.79,0,0,1,1-.82,2.1,2.1,0,0,1,1.65-.39,3.18,3.18,0,0,1,1.84,1.3.51.51,0,0,1,0,.48C616.73,336.38,615.32,338.74,610.92,338.74Zm-8-2.6a4.67,4.67,0,0,1,1.27.33A22.47,22.47,0,0,0,610,337.7c4,.3,5.55-1.38,6-2.23a2,2,0,0,0-1-.65,1.16,1.16,0,0,0-.89.23c-.38.27-.68.52-1,.76a4.69,4.69,0,0,1-3.52,1.36,11.82,11.82,0,0,1-4.09-1.3c-1.49-.66-3-1.35-4-1.2a2.35,2.35,0,0,0-.62.2,7.57,7.57,0,0,0,0,1.13c0,.33.11.56.23.63s.95-.17,1.25-.3l.34-.15A.69.69,0,0,1,602.93,336.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.42,316.13s-3.66,11-3.77,11.57a21.17,21.17,0,0,0-.22,3.4c0,1.53,1,3.18-.76,4.28s-6.59.33-9,.55a59.44,59.44,0,0,1-7.46,0c-3.3-.11-4.5-1.87-3.73-2.2s1.09.55,4.71-1.54,10-5.15,10.21-5.81,1.43-10.32,1.43-10.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.79,336.55c-1,0-2.08,0-3.37-.08l-1.23-.05c-2.62-.08-4.23-1.18-4.42-2.18a.85.85,0,0,1,.51-1,1.77,1.77,0,0,1,.85-.12c.54,0,1.35,0,3.81-1.39,1.3-.75,2.95-1.62,4.53-2.46a43.51,43.51,0,0,0,5.49-3.15c.12-.42.91-6.46,1.37-10.15a.5.5,0,0,1,.5-.44h0l8.6.07a.49.49,0,0,1,.4.21.51.51,0,0,1,.07.45c-1.46,4.38-3.66,11.06-3.76,11.5a21.7,21.7,0,0,0-.21,3.31,7,7,0,0,0,.14,1.16c.19,1.14.43,2.56-1.14,3.54-1.29.81-3.79.72-6.21.63a27.56,27.56,0,0,0-3,0C561.68,336.52,560.75,336.55,559.79,336.55Zm-8-2.39c.2.35,1.2,1.19,3.43,1.26l1.24.05a46.19,46.19,0,0,0,6.16,0,27.24,27.24,0,0,1,3.14,0c2.16.08,4.61.17,5.64-.48s.89-1.31.68-2.53a8.08,8.08,0,0,1-.15-1.32,21.66,21.66,0,0,1,.23-3.5c.1-.5,2.74-8.46,3.57-11l-7.46-.05c-.29,2.3-1.19,9.34-1.4,10s-1.35,1.22-5.93,3.64c-1.58.84-3.21,1.71-4.5,2.45-2.71,1.56-3.7,1.53-4.34,1.52A1,1,0,0,0,551.79,334.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.39,325.05s1.85.93,2,1.39l.93,2,3.25-.15s1.62-1.26,1.23.77.78,5.42.47,6.66-1.7.77-4.8,1.39c-1.67.33-5.88-.62-7-.16s-6.5,0-7.43,0-4-.77-3.87-2.16,6-2.61,6-2.61S563.68,328.45,565.39,325.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.54,337.69a26.75,26.75,0,0,1-2.68-.19,11.07,11.07,0,0,0-3.15-.08c-.86.37-3.49.26-6.34.1-.6,0-1.06-.06-1.28-.06a6.71,6.71,0,0,1-3.94-1.51,1.55,1.55,0,0,1-.43-1.21c.18-1.56,4.42-2.62,6.31-3,.68-.35,7.38-3.83,8.91-6.9a.5.5,0,0,1,.67-.22c.93.47,2.08,1.14,2.26,1.68l.77,1.66,2.76-.14c.33-.22,1-.58,1.52-.26s.44,1.32.39,1.62a12.46,12.46,0,0,0,.25,3.76,8.54,8.54,0,0,1,.2,2.93c-.29,1.16-1.29,1.26-2.67,1.4-.67.07-1.5.16-2.51.36A5.36,5.36,0,0,1,567.54,337.69Zm-5-1.36c.68,0,1.52.09,2.43.18a15.35,15.35,0,0,0,3.42.12c1.06-.21,1.92-.3,2.61-.37,1.39-.14,1.69-.21,1.8-.66a8.92,8.92,0,0,0-.21-2.52,12.93,12.93,0,0,1-.26-4.1,1.84,1.84,0,0,0,0-.55,2,2,0,0,0-.49.26.57.57,0,0,1-.28.11l-3.25.15a.48.48,0,0,1-.48-.29l-.93-2a5.09,5.09,0,0,0-1.36-.94c-2.11,3.38-8.86,6.78-9.16,6.93l-.13,0c-2.85.6-5.51,1.63-5.57,2.17a.49.49,0,0,0,.17.43,5.91,5.91,0,0,0,3.2,1.18c.23,0,.71,0,1.34.06,1.55.09,5.17.29,5.89,0A3.31,3.31,0,0,1,562.53,336.33Zm-6.34-4.14h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.72,335.73c1.51-.2,7.58-.47,10.37-1.4a15.93,15.93,0,0,1,6.14-.29,5.2,5.2,0,0,1,0,1.69c-.31,1.23-1.7.77-4.8,1.39-1.67.33-5.88-.62-7-.16s-6.5,0-7.43,0-4-.77-3.87-2.16C550.22,334.8,555.21,335.93,556.72,335.73Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.54,337.69a26.75,26.75,0,0,1-2.68-.19,11.07,11.07,0,0,0-3.15-.08c-.86.37-3.49.26-6.34.1-.6,0-1.06-.06-1.28-.06a6.71,6.71,0,0,1-3.94-1.51,1.55,1.55,0,0,1-.43-1.21.5.5,0,0,1,.21-.35.51.51,0,0,1,.4-.08c1.36.31,5.15,1.08,6.32.92h0c.39-.05,1.05-.11,1.88-.17a45.94,45.94,0,0,0,8.4-1.2,16.35,16.35,0,0,1,6.36-.32.51.51,0,0,1,.43.43,5.23,5.23,0,0,1,0,1.88c-.29,1.16-1.29,1.26-2.67,1.4-.67.07-1.5.16-2.51.36A5.36,5.36,0,0,1,567.54,337.69Zm-5-1.36c.68,0,1.52.09,2.43.18a15.35,15.35,0,0,0,3.42.12c1.06-.21,1.92-.3,2.61-.37,1.39-.14,1.69-.21,1.8-.66a3.45,3.45,0,0,0,0-1.11,14.62,14.62,0,0,0-5.53.32,45.74,45.74,0,0,1-8.64,1.24c-.81.07-1.45.12-1.82.17h0a24.82,24.82,0,0,1-5.64-.71,6.52,6.52,0,0,0,2.94.95c.23,0,.71,0,1.34.06,1.55.09,5.17.29,5.89,0A3.31,3.31,0,0,1,562.53,336.33Zm-5.81-.6h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606,157.28s8.21,3.27,10.72,14.89c.92,4.29-1,7.09-.68,8.77s6.07.85,7.59,2-.34,6.75-1.68,7.93,2.53,3.2,2.36,6.91-3.21,7.6-3.21,7.6,6.75,5.39,3.54,7.76-11.64,3.2-12.14,4.89-2.87,3.54-6.24,2.36-6.08-4.89-7.43-4.89-3.71-9.79-2.86-11.14.33-9.27.33-9.27-13.83.16-14.17-4.05,1.69-8.94,4.22-10.13,7.59-16.36,6.92-18.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.3,221.3a6.8,6.8,0,0,1-2.24-.41,16.47,16.47,0,0,1-5-3.29c-.91-.77-1.84-1.57-2.27-1.57s-1-.6-1.2-1c-1.28-2.3-3-9.46-2.09-10.86.53-.84.46-5.47.29-8.51-2.75,0-13.86-.29-14.2-4.51-.35-4.37,1.76-9.33,4.51-10.62,2.25-1.05,7.29-15.87,6.65-18a.51.51,0,0,1,.33-.63.5.5,0,0,1,.62.33c.75,2.44-4.51,17.91-7.18,19.16-2.37,1.1-4.24,5.69-3.93,9.63.22,2.73,8.5,3.65,13.67,3.59h0a.49.49,0,0,1,.5.46c.09,1.35.47,8.17-.41,9.58-.26.42-.06,3.07.87,6.44.72,2.63,1.39,3.81,1.64,3.94h0c.72,0,1.61.76,2.83,1.8a16,16,0,0,0,4.67,3.11,4.85,4.85,0,0,0,3.87-.11,3.39,3.39,0,0,0,1.73-1.92c.32-1.07,2.2-1.64,5.5-2.56,2.5-.7,5.32-1.48,6.83-2.6a1.47,1.47,0,0,0,.66-1.19c0-1.93-3-4.82-4.22-5.77a.5.5,0,0,1-.08-.7s2.94-3.8,3.1-7.31a6.87,6.87,0,0,0-1.68-4.29c-.73-1.05-1.49-2.13-.51-3s2.13-4,2.08-6a1.64,1.64,0,0,0-.37-1.18c-.56-.43-2.07-.55-3.41-.67-2.11-.17-4.11-.34-4.37-1.65a6.38,6.38,0,0,1,.33-2.65,12.49,12.49,0,0,0,.35-6.11c-2.42-11.2-10.33-14.5-10.41-14.53a.5.5,0,0,1-.28-.65.49.49,0,0,1,.65-.28c.34.13,8.48,3.5,11,15.25a13.56,13.56,0,0,1-.35,6.56,5.83,5.83,0,0,0-.32,2.22c.12.57,2.14.74,3.47.85,1.62.13,3.15.26,3.94.87a2.45,2.45,0,0,1,.76,1.94c.06,2.16-1.21,5.7-2.43,6.76-.25.23-.06.59.68,1.65a7.84,7.84,0,0,1,1.86,4.92c-.15,3.17-2.24,6.39-3,7.49,1.11.95,4.27,3.88,4.23,6.26a2.46,2.46,0,0,1-1.07,2c-1.66,1.22-4.57,2-7.15,2.75-2,.55-4.64,1.29-4.81,1.88a4.41,4.41,0,0,1-2.24,2.53A5.34,5.34,0,0,1,608.3,221.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M557.5,208c1.88-2.06,15.59-15.35,17.13-17.27,1.77-2.2,2.56-1.67,5.94-2.61a30.39,30.39,0,0,1,7.91-.74l.33-4.6a12.11,12.11,0,0,1-2.72-.26c-1.62-.32-4.67-2.46-5.25-6.61s1.75-5.76,2.72-7.77,1.49-6.68,1.49-6.68,10,1.36,12.66,2.3,1,4.68,1.13,6.74,4.22,5.25,3.09,7.78-4.31,3.56-4.31,3.56l-.37,4.5s9,5.06,11.61,6.93,19.35,16.65,18.69,20.21-3.28,4.69-5.43,3.19-14.75-10.56-14.75-10.56l-5.44,10.78-1,5.9-.08,2.27L579,224.88c.16-2.73.16-2.7.15-2.66.2-2.88.29-5.14.29-5.14s-2.81-5.81-3.09-9.09,1.5-7.87,1.5-7.87c-.05-.57-4.7,6.28-11.69,11-6.42,4.36-7.82,3-8.94,1.91S555.63,210.08,557.5,208Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M600.82,225.57h0L579,225.38a.52.52,0,0,1-.36-.16.5.5,0,0,1-.13-.37c.13-2.17.15-2.59.15-2.66h0c.17-2.48.27-4.5.29-5-.41-.86-2.82-6-3.09-9.15a18.17,18.17,0,0,1,.84-6,54.61,54.61,0,0,1-10.25,9.52c-6.29,4.28-8.06,3.37-9.57,1.86-1.26-1.26-1.85-3.43.26-5.75h0c.8-.88,3.62-3.67,6.89-6.91,4.38-4.34,9.35-9.26,10.23-10.35a5.4,5.4,0,0,1,4-2.26c.61-.12,1.31-.26,2.21-.51a29.13,29.13,0,0,1,7.59-.77l.25-3.59A13,13,0,0,1,586,183c-2-.4-5.06-2.84-5.65-7a8.42,8.42,0,0,1,1.85-6.6,10.93,10.93,0,0,0,.92-1.46c.92-1.91,1.44-6.47,1.44-6.51a.53.53,0,0,1,.19-.34.51.51,0,0,1,.38-.1c.41.05,10.12,1.37,12.76,2.32,2.29.81,1.93,3.3,1.64,5.3a9.86,9.86,0,0,0-.18,1.89,6.94,6.94,0,0,0,1.39,2.68c1.14,1.67,2.44,3.56,1.66,5.32a7.91,7.91,0,0,1-4.3,3.72l-.32,3.86c1.57.89,9,5.1,11.39,6.81,1.9,1.35,19.64,16.6,18.88,20.7a5,5,0,0,1-2.72,4,3.64,3.64,0,0,1-3.49-.48c-1.89-1.32-12-8.56-14.28-10.22l-5.14,10.18-1,5.83-.07,2.21A.5.5,0,0,1,600.82,225.57Zm-21.29-1.18,20.81.18.06-1.79,1-6a.57.57,0,0,1,0-.14l5.44-10.78a.49.49,0,0,1,.33-.26.54.54,0,0,1,.41.08c.12.09,12.62,9.08,14.74,10.56a2.61,2.61,0,0,0,2.54.38,4.1,4.1,0,0,0,2.12-3.25c.56-3-14.89-17.14-18.49-19.71-2.57-1.84-11.48-6.85-11.57-6.91a.48.48,0,0,1-.25-.47l.37-4.5a.51.51,0,0,1,.35-.43s3-1,4-3.29c.56-1.25-.52-2.83-1.57-4.36a7.16,7.16,0,0,1-1.56-3.19,11.39,11.39,0,0,1,.19-2.08c.32-2.22.43-3.72-1-4.22-2.22-.79-10-1.91-12.07-2.2a25.87,25.87,0,0,1-1.47,6.32,11.72,11.72,0,0,1-1,1.6A7.71,7.71,0,0,0,586.18,182a11.25,11.25,0,0,0,2.6.25.54.54,0,0,1,.38.15.51.51,0,0,1,.15.39l-.33,4.6a.51.51,0,0,1-.52.46,30.57,30.57,0,0,0-7.76.72c-.93.26-1.68.41-2.28.53a4.44,4.44,0,0,0-3.4,1.91c-.91,1.13-5.9,6.07-10.3,10.43-3.12,3.09-6.07,6-6.85,6.87h0c-2,2.21-.88,3.79-.3,4.37,1,1,2.18,2.19,8.3-2A55.1,55.1,0,0,0,576.24,201c1.19-1.38,1.34-1.56,1.75-1.42a.56.56,0,0,1,.36.46.53.53,0,0,1,0,.22s-1.74,4.53-1.47,7.65,3,8.86,3,8.91a.42.42,0,0,1,.05.24s-.1,2.27-.29,5.15a.37.37,0,0,1,0,.15C579.62,222.76,579.59,223.35,579.53,224.39ZM557.5,208h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.35,200.73c-3.76-3.57-7.38-6.66-8.49-7.45-2.62-1.87-11.61-6.93-11.61-6.93l-7.51,9.43-1.26-8.39a30.39,30.39,0,0,0-7.91.74c-3.38.94-4.17.41-5.94,2.61-.67.83-3.65,3.83-7,7.11l5.1,7.71c3.16-3.18,5-5.8,5.07-5.44,0,0-1.78,4.59-1.5,7.87s3.09,9.09,3.09,9.09-.09,2.25-.29,5.13c0,0,0,.17-.15,2.67l21.82.19.08-2.27,1-5.9,5.44-10.78,4,2.9Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.31,225.58l-22.84-.2,0-.53c.13-2.3.15-2.63.15-2.66.17-2.48.27-4.5.29-5-.41-.86-2.82-6-3.09-9.15a18.27,18.27,0,0,1,.84-6c-.86,1-2.07,2.38-3.55,3.87l-.44.44L567,197.78l.29-.29c2.86-2.83,6.23-6.2,6.93-7.07a5.4,5.4,0,0,1,4-2.26c.61-.12,1.31-.26,2.21-.51a30.55,30.55,0,0,1,8.07-.76l.42,0,1.14,7.66,7.06-8.87.37.21c.37.21,9,5.1,11.67,7,1.08.77,4.66,3.81,8.53,7.49l.32.3-6.49,9.05-4-2.85-5.14,10.18-1,5.83Zm-21.78-1.19,20.81.18.06-1.79,1.08-6.11,5.7-11.3,4.11,2.95,5.4-7.52c-3.68-3.47-7.11-6.39-8.12-7.11-2.27-1.62-9.48-5.72-11.2-6.7l-8,10-1.37-9.11a29.27,29.27,0,0,0-7.35.73c-.93.26-1.68.41-2.28.53a4.44,4.44,0,0,0-3.4,1.91c-.56.7-2.57,2.76-6.7,6.86l4.54,6.86c1.43-1.48,2.59-2.81,3.37-3.72,1.19-1.39,1.35-1.57,1.76-1.43l.31.1.06.48,0,.1s-1.74,4.53-1.47,7.65,3,8.86,3,8.91l.06.12v.12s-.1,2.26-.29,5.15h0C579.62,222.62,579.59,223.26,579.53,224.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.68,319.48c-1.51,2.8-9.44-.78-9.44-.78s.16-8.82.47-14.55c.2-3.76-.17-18.48,3.49-32.35S577.94,237,577.94,237s.1-3.28.66-8.34c.24-2.13.42-4.53.4-3.82l21.82.19.08-2.27s5.81,8.62,8.15,11.62,5,10.49,5.16,18.92-.57,28.77-.57,28.77L611,318.39l-9.9.16L596.78,290l-3.28-31.67s-5.25,17.8-5.44,18.18-4.88,19.31-4.88,19.31S580.35,312.68,576.68,319.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.17,321.05c-2.83,0-6.55-1.63-7.13-1.89a.52.52,0,0,1-.3-.47c0-.08.16-8.89.47-14.56,0-.61,0-1.52.07-2.66.12-5.89.36-18.14,3.43-29.8,3.61-13.68,6.71-34.49,6.74-34.7h0s.1-3.32.65-8.32c.12-1,.22-2.12.29-2.9.13-1.38.15-1.53.64-1.5a.53.53,0,0,1,.31.13l21,.19.06-1.79a.49.49,0,0,1,.36-.46.51.51,0,0,1,.56.2c0,.08,5.82,8.64,8.13,11.59,2.47,3.16,5.07,10.78,5.26,19.22s-.56,28.59-.57,28.8l-2.6,36.3a.49.49,0,0,1-.49.46l-9.91.16a.54.54,0,0,1-.5-.43l-4.36-28.57-3-29.17c-1.64,5.54-4.59,15.5-4.75,15.83-.19.52-3,11.78-4.84,19.21-.11.65-2.89,17-6.55,23.79h0A3.09,3.09,0,0,1,574.17,321.05Zm-6.42-2.67c2.18.93,7.49,2.72,8.49.86,3.59-6.65,6.42-23.36,6.45-23.53,1.42-5.74,4.73-19.06,4.93-19.45s3.33-11.08,5.4-18.09a.5.5,0,0,1,1,.09l3.27,31.67L601.56,318l9-.14,2.57-35.83c0-.18.75-20.39.57-28.72-.18-8.13-2.74-15.67-5.05-18.63-1.78-2.28-5.6-7.85-7.31-10.37l0,.74a.5.5,0,0,1-.5.48h0l-21.39-.19c0,.14,0,.3,0,.47-.07.77-.18,1.87-.29,2.91-.56,5-.65,8.26-.66,8.29,0,.27-3.14,21.14-6.76,34.88-3,11.54-3.28,23.71-3.4,29.56,0,1.16,0,2.07-.07,2.69C567.94,309.21,567.78,316.72,567.75,318.38Zm8.93,1.1h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600.05,
    y: 314.99,
    width: 12.07,
    height: 4.64,
    transform: "translate(1212.17 634.62) rotate(180)",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.12,320.13H600.05a.5.5,0,0,1-.5-.5V315a.5.5,0,0,1,.5-.5h12.07a.5.5,0,0,1,.5.5v4.64A.5.5,0,0,1,612.12,320.13Zm-11.57-1h11.07v-3.64H600.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 566.15,
    y: 317.07,
    width: 11.75,
    height: 4.49,
    transform: "translate(1073.29 741.12) rotate(-169.09)",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.38,323.13h-.1l-11.54-2.22a.51.51,0,0,1-.4-.59l.85-4.4a.51.51,0,0,1,.59-.4l11.54,2.22a.51.51,0,0,1,.32.21.56.56,0,0,1,.08.38l-.85,4.41A.5.5,0,0,1,577.38,323.13Zm-11-3.12,10.56,2,.66-3.43-10.56-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.55,229.9h0l-6.69-.1a.5.5,0,0,1-.49-.51.49.49,0,0,1,.5-.49h0l6.7.1a.5.5,0,0,1,.49.5A.51.51,0,0,1,586.55,229.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.23,230h0l-8-.12a.5.5,0,0,1,0-1h0l8,.12a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.53,168a3.37,3.37,0,0,0-2.65-.94l-.07-1a4.4,4.4,0,0,1,3.47,1.27l-.75.67.37-.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.57,165.35a2.21,2.21,0,0,0-1.38-.74v-1a3.19,3.19,0,0,1,2.14,1.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.65,171.59a3.83,3.83,0,1,1,3.83-3.82A3.82,3.82,0,0,1,583.65,171.59Zm0-6.65a2.83,2.83,0,1,0,2.83,2.83A2.83,2.83,0,0,0,583.65,164.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.23,176.65a4.64,4.64,0,0,1-1.73-.33.5.5,0,0,1,.38-.93,4.34,4.34,0,0,0,3.58-.33.48.48,0,0,1,.68.16.49.49,0,0,1-.16.69A5.69,5.69,0,0,1,586.23,176.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M591.39,174.39a3.83,3.83,0,1,1,3.83-3.83A3.84,3.84,0,0,1,591.39,174.39Zm0-6.66a2.83,2.83,0,1,0,2.83,2.83A2.83,2.83,0,0,0,591.39,167.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.85,170.37c-.1.58.06,1.1.36,1.16s.64-.38.75-1-.05-1.11-.36-1.16S590,169.78,589.85,170.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.39,168.42c-.11.58.05,1.1.36,1.16s.64-.38.75-1-.06-1.11-.36-1.16S584.5,167.83,584.39,168.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.5,174.57a.54.54,0,0,1-.22,0l-5-2.35a.5.5,0,0,1,.42-.9l5,2.34a.5.5,0,0,1-.21.95Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.1,170.17a.47.47,0,0,1-.3-.1.5.5,0,0,1-.11-.69,1.81,1.81,0,0,1,1.42-.86h0a2,2,0,0,1,1.42.75.5.5,0,1,1-.78.62.7.7,0,0,0-1.27.08A.51.51,0,0,1,586.1,170.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.88,173.54h-.1a3.07,3.07,0,0,1-1.89-2.36c-.25-1.35,1.55-1.69,2.62-1.89l.46-.09a1.88,1.88,0,0,0,.92-.72.5.5,0,0,1,.85.53,2.79,2.79,0,0,1-1.52,1.16l-.52.1c-1.26.24-1.87.48-1.83.73a2.28,2.28,0,0,0,1.11,1.56.51.51,0,0,1,.39.59A.5.5,0,0,1,584.88,173.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M597.94,165.11a24,24,0,0,0-.1,6.39c.49,2.52,2.62,3.49,2.33,5.52s-3.39,5-3.39,5a8.85,8.85,0,0,0,6.78,3.2c4.55.1,8.33-1.65,8.33-9.3s-1.07-16.26-6.59-19-15.88-1.64-18.2-.77-4.94,3.87-4.07,5.33S594.07,165.59,597.94,165.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.9,185.75h-.35a9.31,9.31,0,0,1-7.18-3.4.52.52,0,0,1,.06-.66c.83-.8,3-3.21,3.24-4.74a3.35,3.35,0,0,0-.91-2.41,7.51,7.51,0,0,1-1.41-2.95,22,22,0,0,1,0-5.94c-4.28.18-13.8-2.25-14.77-3.87a2.11,2.11,0,0,1-.07-1.82,8.2,8.2,0,0,1,4.39-4.23c2.32-.87,12.91-2,18.6.8,4.62,2.26,6.87,8.62,6.87,19.42,0,3.61-.81,6.15-2.46,7.77C608.53,185.09,606.56,185.75,603.9,185.75Zm-6.44-3.67a8.53,8.53,0,0,0,6.11,2.67c2.56.05,4.4-.52,5.66-1.74,1.43-1.4,2.16-3.78,2.16-7.06,0-10.38-2.07-16.44-6.31-18.53-5.21-2.56-15.44-1.64-17.81-.75a7.29,7.29,0,0,0-3.8,3.62,1.24,1.24,0,0,0,0,1c.68,1.13,10.52,3.83,14.42,3.34a.51.51,0,0,1,.56.57,23.08,23.08,0,0,0-.1,6.23,6.51,6.51,0,0,0,1.24,2.56,4.23,4.23,0,0,1,1.08,3.12C600.41,178.87,598.29,181.22,597.46,182.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598,175.29s2.81-2.43,3.93-1.22-.28,3.38-1.31,4.6a1.69,1.69,0,0,1-2.72-.1",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.34,179.82h-.12a2.39,2.39,0,0,1-1.73-1,.49.49,0,0,1,.14-.69.48.48,0,0,1,.69.14,1.37,1.37,0,0,0,1,.52,1.15,1.15,0,0,0,1-.48c1.14-1.35,2.09-3.09,1.32-3.93-.59-.64-2.47.6-3.24,1.26a.5.5,0,0,1-.65-.75c.32-.29,3.21-2.71,4.63-1.18s-.42,4.2-1.3,5.25A2.14,2.14,0,0,1,599.34,179.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.81 182.79 592.14 182.34 588.62 186.59 588.81 182.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.62,187.09a.58.58,0,0,1-.18,0,.5.5,0,0,1-.32-.49l.19-3.79a.5.5,0,0,1,.43-.48l3.33-.44a.5.5,0,0,1,.46.81L589,186.91A.49.49,0,0,1,588.62,187.09Zm.67-3.86-.1,1.88,1.75-2.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M559.81,213.68a8.37,8.37,0,0,0,3.7-1.35c1.63-1.18,2.26-4.79,3.7-7.41s8.92-15.38,8.92-15.38a4.33,4.33,0,0,0,2.08-.63,7.94,7.94,0,0,1,3.52-1.63c1.53-.18,2.34.09,2.88-.09s.19-1.71-1.08-2.07a6.3,6.3,0,0,0-3.16.36,7.55,7.55,0,0,1,.27-2.89,1.56,1.56,0,0,1,2.53-.78c1.64,1.14,2.41.18,2-.45a4,4,0,0,0-3.23-1.6c-1.35.19-2.52.39-2.52.39a12.32,12.32,0,0,1-2.53,1.63c-.45,0-2.35-.09-3.25,1.35a13.54,13.54,0,0,0-1.62,5.33,7.33,7.33,0,0,1,0,1.53s-10.18,11.87-12.35,13.94-4.14,6.23-3.25,8A5.67,5.67,0,0,0,558,213.8",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558,214.3a.52.52,0,0,1-.29-.09,6.1,6.1,0,0,1-1.73-2c-1-2,1-6.38,3.36-8.62,2-1.92,11.13-12.53,12.21-13.78a8.12,8.12,0,0,0,0-1.28,13.68,13.68,0,0,1,1.7-5.64,3.84,3.84,0,0,1,3.53-1.59h.07a11.93,11.93,0,0,0,2.29-1.52.44.44,0,0,1,.22-.1s1.18-.21,2.54-.39a4.51,4.51,0,0,1,3.71,1.8,1.09,1.09,0,0,1-.09,1.41c-.43.44-1.33.6-2.56-.26a1.06,1.06,0,0,0-1.78.55,5.92,5.92,0,0,0-.27,2,5.64,5.64,0,0,1,2.83-.17,2.33,2.33,0,0,1,1.69,2.06,1,1,0,0,1-.59,1,3.39,3.39,0,0,1-1.18.07,10.31,10.31,0,0,0-1.8,0A6.31,6.31,0,0,0,579,189l-.48.31a4.71,4.71,0,0,1-2,.69c-1,1.74-7.46,12.76-8.78,15.15a25.37,25.37,0,0,0-1.37,3.18c-.7,1.84-1.35,3.57-2.47,4.38a8.89,8.89,0,0,1-3.95,1.45.5.5,0,1,1-.09-1,7.81,7.81,0,0,0,3.45-1.26c.88-.63,1.48-2.23,2.12-3.92a27.27,27.27,0,0,1,1.44-3.32c1.43-2.59,8.84-15.26,8.92-15.39a.5.5,0,0,1,.43-.25,3.81,3.81,0,0,0,1.81-.55l.45-.3a7.12,7.12,0,0,1,3.28-1.4,11.51,11.51,0,0,1,2,0,3.4,3.4,0,0,0,.72,0,1.08,1.08,0,0,0-.12-.43,1.37,1.37,0,0,0-.85-.71,5.56,5.56,0,0,0-2.84.35.49.49,0,0,1-.44,0,.47.47,0,0,1-.23-.37,7.88,7.88,0,0,1,.3-3.12,2.23,2.23,0,0,1,1.36-1.4,2.26,2.26,0,0,1,1.92.39c.74.51,1.18.48,1.28.38s0-.11,0-.13a3.55,3.55,0,0,0-2.75-1.39c-1.09.15-2.05.31-2.38.36-1.41,1.1-2.33,1.66-2.74,1.66A3.15,3.15,0,0,0,574,183.4a13.19,13.19,0,0,0-1.56,5,7.1,7.1,0,0,1,0,1.65.54.54,0,0,1-.11.27c-.42.48-10.22,11.9-12.38,14s-3.86,6-3.15,7.45a5.31,5.31,0,0,0,1.41,1.66.5.5,0,0,1-.29.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M577.31,180.22a1.42,1.42,0,0,1,.46-.55c1.33-1,1.91.94,1.87,1.84a6.1,6.1,0,0,1-.54,2.07c-.09.23-.26.5-.53.49a.52.52,0,0,1-.33-.18c-.51-.57-.08-1.44-.36-2.12-.17-.4-.58-.71-.63-1.13A.76.76,0,0,1,577.31,180.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M578.59,184.57h0a1,1,0,0,1-.69-.35,2,2,0,0,1-.38-1.51,2,2,0,0,0-.06-.75,2.09,2.09,0,0,0-.23-.35,2,2,0,0,1-.44-.9,1.28,1.28,0,0,1,.1-.69h0a1.92,1.92,0,0,1,.62-.75A1.4,1.4,0,0,1,579,179a2.89,2.89,0,0,1,1.1,2.49,6.6,6.6,0,0,1-.58,2.24C579.28,184.45,578.85,184.57,578.59,184.57Zm-.13-4.67a.8.8,0,0,0-.4.17,1,1,0,0,0-.29.35h0a.3.3,0,0,0,0,.16,1.24,1.24,0,0,0,.25.43,2.55,2.55,0,0,1,.35.56,2.85,2.85,0,0,1,.14,1.17,1.31,1.31,0,0,0,.1.78s0-.07.06-.13a5.73,5.73,0,0,0,.5-1.9,2.05,2.05,0,0,0-.56-1.57Zm-1.15.32h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.41,180.86a1.32,1.32,0,0,1,.46-.54c1.34-1,1.91.93,1.88,1.83a6.06,6.06,0,0,1-.55,2.07c-.09.23-.25.5-.52.49a.45.45,0,0,1-.34-.18c-.51-.56-.07-1.44-.36-2.12-.17-.39-.57-.7-.63-1.12A.9.9,0,0,1,575.41,180.86Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.69,185.21h0a1,1,0,0,1-.69-.35,2,2,0,0,1-.39-1.51,1.9,1.9,0,0,0-.06-.74,2.64,2.64,0,0,0-.23-.36,1.91,1.91,0,0,1-.44-.9,1.24,1.24,0,0,1,.11-.68h0a1.77,1.77,0,0,1,.61-.75,1.42,1.42,0,0,1,1.58-.24,2.9,2.9,0,0,1,1.1,2.49,6.77,6.77,0,0,1-.58,2.24C577.38,185.1,577,185.21,576.69,185.21Zm-.12-4.67a.72.72,0,0,0-.4.18.86.86,0,0,0-.3.34h0a.5.5,0,0,0,0,.16,1.36,1.36,0,0,0,.25.44,2.55,2.55,0,0,1,.35.56,2.63,2.63,0,0,1,.14,1.16,1.38,1.38,0,0,0,.1.78.53.53,0,0,0,.06-.13,5.75,5.75,0,0,0,.51-1.9,2.05,2.05,0,0,0-.57-1.56A.2.2,0,0,0,576.57,180.54Zm-1.16.32h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574,182.16a1.29,1.29,0,0,1,.41-.49c1.21-.9,1.73.84,1.7,1.66a5.63,5.63,0,0,1-.49,1.87c-.08.21-.23.45-.48.44a.43.43,0,0,1-.3-.16c-.46-.51-.07-1.3-.33-1.92-.15-.36-.52-.63-.57-1A.73.73,0,0,1,574,182.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.18,186.14h0a.9.9,0,0,1-.65-.33,1.79,1.79,0,0,1-.36-1.4,1.82,1.82,0,0,0-.06-.65,1.61,1.61,0,0,0-.2-.31,1.78,1.78,0,0,1-.4-.84,1.19,1.19,0,0,1,.09-.64h0a1.77,1.77,0,0,1,.57-.69,1.34,1.34,0,0,1,1.48-.22,2.66,2.66,0,0,1,1,2.3,6,6,0,0,1-.53,2C575.84,186,575.42,186.14,575.18,186.14Zm.05-1h0Zm-.75-2.78a.19.19,0,0,0,0,.12,1,1,0,0,0,.21.37,2.41,2.41,0,0,1,.32.52,2.26,2.26,0,0,1,.13,1.07,1.66,1.66,0,0,0,0,.6v0a5.1,5.1,0,0,0,.45-1.7,1.85,1.85,0,0,0-.49-1.37c-.09-.05-.23,0-.41.13A.74.74,0,0,0,574.48,182.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M573.93,190a.5.5,0,0,1,0-1,2.09,2.09,0,0,0,1.38-.58,5.47,5.47,0,0,0,.63-2,.49.49,0,0,1,.56-.43.49.49,0,0,1,.43.55,6.47,6.47,0,0,1-.81,2.51,3,3,0,0,1-2.13,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M623.88,207.84s5,3.95,5,6-16.81,17.56-18.1,18.45-2.5,1.21-3.22.88-4.83-2.65-4.83-2.65-5-.4-5.31-.89-.08-.56.88-.64,2.18-.32,2.42-.32,1.45-.16,1.45-.16-5.4-2-5.72-2.1-1.77-.16-1.53-.72,1.77-1.37,3.14-1.77,4.75-.73,5.72,0,4.82,5.23,4.82,5.23a20.63,20.63,0,0,0,4.11-7.24c1.37-4.35,6.68-10.4,8.45-11.61",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.25,233.84a2.07,2.07,0,0,1-.84-.17c-.69-.3-4.14-2.26-4.78-2.62-5.13-.42-5.46-.91-5.58-1.1a.89.89,0,0,1-.15-.89c.21-.43.77-.48,1.41-.53s1.18-.14,1.65-.22l.13,0c-1.74-.65-3.52-1.3-3.71-1.35l-.24,0c-.72-.11-1.35-.24-1.6-.69a.74.74,0,0,1,0-.68c.37-.86,2.32-1.72,3.46-2.05,1.3-.38,5-.82,6.15.08a60.5,60.5,0,0,1,4.54,4.86,20.67,20.67,0,0,0,3.62-6.62c1.39-4.4,6.78-10.6,8.65-11.87a.5.5,0,1,1,.56.82c-1.78,1.22-6.93,7.14-8.25,11.35a21,21,0,0,1-4.22,7.43.48.48,0,0,1-.38.16.47.47,0,0,1-.36-.18c-1.07-1.24-4-4.59-4.75-5.15s-3.82-.35-5.28.08a7.78,7.78,0,0,0-2.69,1.32,6,6,0,0,0,.73.15l.33.06c.34.08,4.87,1.77,5.77,2.11a.48.48,0,0,1,.32.52.49.49,0,0,1-.43.44c-.29,0-1.26.17-1.51.17a6.51,6.51,0,0,0-.65.09c-.47.07-1.08.17-1.63.22,1,.2,2.76.41,4.33.54a.56.56,0,0,1,.21.06c1.41.81,4.23,2.39,4.78,2.64s1.39.08,2.73-.84c1.74-1.2,17.76-16.18,17.89-18,0-1.35-3-4.18-4.86-5.65a.5.5,0,0,1,.62-.79c.53.42,5.16,4.15,5.24,6.41.1,2.53-17.29,18.17-18.32,18.88A5.35,5.35,0,0,1,608.25,233.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M602.29,227.33s-2-.73-3.45-1.21l-.15-.05c-1.19-.4-2.22-.74-2.72-.41a.5.5,0,1,1-.55-.83c.9-.6,2.09-.21,3.58.29l.15,0c1.46.49,3.48,1.22,3.48,1.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.1,225.83a.65.65,0,0,1-.19,0,20.12,20.12,0,0,0-4.84-1.33.51.51,0,0,1-.46-.54.52.52,0,0,1,.54-.46,20.5,20.5,0,0,1,5.14,1.4.5.5,0,0,1-.19,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.58,225a.47.47,0,0,1-.25-.07,8.6,8.6,0,0,0-2.14-1,.5.5,0,0,1-.44-.55.49.49,0,0,1,.56-.44,9.07,9.07,0,0,1,2.53,1.11.5.5,0,0,1,.17.69A.51.51,0,0,1,603.58,225Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.15,222.21h0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.15,222.72a.5.5,0,0,1,0-1,.49.49,0,0,1,.5.49h0A.5.5,0,0,1,579.15,222.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,426.27V387.16h-2.79a1.83,1.83,0,0,1-1.83-1.82v-.09a1.83,1.83,0,0,1,1.83-1.83H527.8v46.64H352.23a1.83,1.83,0,0,1-1.83-1.83h0a2,2,0,0,1,1.83-2Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.8,430.56H352.23a2.33,2.33,0,0,1-2.33-2.33,2.56,2.56,0,0,1,2.27-2.46h2.35V387.66h-2.29a2.33,2.33,0,0,1-2.33-2.33,2.36,2.36,0,0,1,2.33-2.41H527.8a.5.5,0,0,1,.5.5v46.64A.5.5,0,0,1,527.8,430.56Zm-175.57-3.8a1.55,1.55,0,0,0-1.33,1.47,1.34,1.34,0,0,0,1.33,1.33H527.3V383.92H352.23a1.37,1.37,0,0,0,0,2.74H355a.5.5,0,0,1,.5.5v39.1a.5.5,0,0,1-.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.11,
    y: 387.23,
    width: 173.69,
    height: 39.02,
    transform: "translate(881.92 813.48) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.8,426.75H354.11a.5.5,0,0,1-.5-.5v-39a.5.5,0,0,1,.5-.5H527.8a.5.5,0,0,1,.5.5v39A.5.5,0,0,1,527.8,426.75Zm-173.19-1H527.3v-38H354.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M549.84,383.46H662a0,0,0,0,1,0,0V430a0,0,0,0,1,0,0H549.84a22,22,0,0,1-22-22V405.5A22,22,0,0,1,549.84,383.46Z",
    transform: "translate(1189.82 813.48) rotate(180)",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640,430.52H527.81a.5.5,0,0,1-.5-.5V383.46a.5.5,0,0,1,.5-.5H640a22.56,22.56,0,0,1,22.53,22.54V408A22.56,22.56,0,0,1,640,430.52Zm-111.67-1H640A21.56,21.56,0,0,0,661.51,408V405.5A21.56,21.56,0,0,0,640,384H528.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.28,387.23H657.94a0,0,0,0,1,0,0v39a0,0,0,0,1,0,0H546.28a18.47,18.47,0,0,1-18.47-18.47V405.7A18.47,18.47,0,0,1,546.28,387.23Z",
    transform: "translate(1185.75 813.48) rotate(180)",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.47,426.75H527.81a.5.5,0,0,1-.5-.5v-39a.5.5,0,0,1,.5-.5H639.47a19,19,0,0,1,19,19v2.08A19,19,0,0,1,639.47,426.75Zm-111.16-1H639.47a18,18,0,0,0,18-18V405.7a18,18,0,0,0-18-18H528.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.11,395.55H498.53a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h28.58a.51.51,0,0,1,.5.5A.5.5,0,0,1,527.11,395.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.39,401.63h-70a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h70a.5.5,0,0,1,.5.5A.5.5,0,0,1,516.39,401.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.46,410.2H507.11a.5.5,0,0,1,0-1h15.35a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.52,393.77H363.87a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h39.65a.5.5,0,0,1,.5.5A.5.5,0,0,1,403.52,393.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.94,407.7H354.59a.5.5,0,0,1,0-1h15.35a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.23,415.56H363.16a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.07a.5.5,0,0,1,.5.5A.5.5,0,0,1,379.23,415.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.94,407.05h-32.6a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h32.6a.51.51,0,0,1,.5.5A.5.5,0,0,1,657.94,407.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.05,402.34H628.91a.5.5,0,0,1,0-1h17.14a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.62,413.06H603.55a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h46.07a.5.5,0,0,1,.5.5A.5.5,0,0,1,649.62,413.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.47,419.49H527.82a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h14.65a.5.5,0,0,1,.5.5A.51.51,0,0,1,542.47,419.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536,414.84H517.46a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H536a.51.51,0,0,1,.5.5A.5.5,0,0,1,536,414.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.49,340.44a1.83,1.83,0,0,1-1.83-1.83v-.08a1.83,1.83,0,0,1,1.83-1.83H503.06v0H614A23.28,23.28,0,0,1,637.27,360h0A23.28,23.28,0,0,1,614,383.29H505.74v0H327.49a1.82,1.82,0,0,1-1.83-1.82,2.06,2.06,0,0,1,1.83-2h2.79v-39.1Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.74,383.83H327.49a2.32,2.32,0,0,1-2.33-2.32,2.56,2.56,0,0,1,2.26-2.47h2.36v-38.1h-2.29a2.37,2.37,0,0,1,0-4.74H503.06a.45.45,0,0,1,.2,0H614a23.78,23.78,0,1,1,0,47.55H505.93A.41.41,0,0,1,505.74,383.83ZM327.49,380a1.54,1.54,0,0,0-1.33,1.47,1.33,1.33,0,0,0,1.33,1.32H505.56a.53.53,0,0,1,.18,0H614a22.78,22.78,0,1,0,0-45.55H503.13a.66.66,0,0,1-.28,0H327.49a1.33,1.33,0,0,0-1.33,1.33,1.36,1.36,0,0,0,1.33,1.41h2.79a.5.5,0,0,1,.5.5v39.1a.5.5,0,0,1-.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.22,360h0c0-12.86-14-23.28-26.81-23.28h14.88A23.28,23.28,0,0,1,619.57,360h0a23.27,23.27,0,0,1-23.28,23.27H581.41C594.26,383.29,608.22,372.87,608.22,360Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.29,383.79H581.41a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5c12.17,0,26.31-10,26.31-22.77s-14.14-22.78-26.31-22.78a.5.5,0,0,1,0-1h14.88a23.78,23.78,0,1,1,0,47.55Zm-7.84-1h7.84a22.78,22.78,0,1,0,0-45.55h-7.84c10.47,2.9,20.27,11.84,20.27,22.78S598.92,379.89,588.45,382.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.82,360h0c0-12.86-14-23.28-26.81-23.28h14.88A23.28,23.28,0,0,1,533.17,360h0a23.27,23.27,0,0,1-23.28,23.27H495C507.86,383.29,521.82,372.87,521.82,360Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.89,383.79H495a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5c12.17,0,26.31-10,26.31-22.77S507.18,337.24,495,337.24a.5.5,0,0,1,0-1h14.88a23.78,23.78,0,1,1,0,47.55Zm-7.84-1h7.84a22.78,22.78,0,1,0,0-45.55h-7.84c10.47,2.9,20.27,11.84,20.27,22.78S512.52,379.89,502.05,382.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.66,381.51a2.06,2.06,0,0,1,1.83-2h2.79v-39.1h-2.79a1.83,1.83,0,0,1-1.83-1.83v-.08a1.83,1.83,0,0,1,1.83-1.83h36.84v0H475.26A23.28,23.28,0,0,1,498.54,360h0a23.27,23.27,0,0,1-23.28,23.27H367v0H327.49A1.82,1.82,0,0,1,325.66,381.51Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367,383.83H327.49a2.32,2.32,0,0,1-2.33-2.32,2.56,2.56,0,0,1,2.26-2.47h2.36v-38.1h-2.29a2.37,2.37,0,0,1,0-4.74h36.84a.45.45,0,0,1,.2,0H475.26a23.78,23.78,0,1,1,0,47.55H367.2A.39.39,0,0,1,367,383.83ZM327.49,380a1.54,1.54,0,0,0-1.33,1.47,1.33,1.33,0,0,0,1.33,1.32h39.34a.58.58,0,0,1,.19,0H475.26a22.78,22.78,0,1,0,0-45.55H364.4a.61.61,0,0,1-.27,0H327.49a1.33,1.33,0,0,0-1.33,1.33,1.36,1.36,0,0,0,1.33,1.41h2.79a.5.5,0,0,1,.5.5v39.1a.5.5,0,0,1-.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.3,341.05a19.32,19.32,0,0,1,14.78,18.78v.37A19.34,19.34,0,0,1,479.3,379l-149.93.54v-39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.37,380a.51.51,0,0,1-.35-.15.47.47,0,0,1-.15-.35v-39a.47.47,0,0,1,.15-.35.51.51,0,0,1,.35-.15h0l149.93.55h.12a19.76,19.76,0,0,1,15.16,19.27v.37a19.76,19.76,0,0,1-15.16,19.27l-.12,0L329.37,380Zm.5-39v38l149.37-.54a18.77,18.77,0,0,0,14.34-18.29v-.37a18.75,18.75,0,0,0-14.34-18.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.73,348.83H473.79a.5.5,0,0,1,0-1h10.94a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.65,354.9h-70a.5.5,0,0,1,0-1h70a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491,363.47h-8.61a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H491a.5.5,0,0,1,.5.5A.5.5,0,0,1,491,363.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.78,347H339.13a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h39.65a.51.51,0,0,1,.5.5A.5.5,0,0,1,378.78,347Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.2,361H329.84a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H345.2a.5.5,0,0,1,.5.5A.5.5,0,0,1,345.2,361Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.49,368.83H338.41a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h16.08a.51.51,0,0,1,.5.5A.5.5,0,0,1,354.49,368.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.52,433.42a1.83,1.83,0,0,1-1.83-1.83v-.08a1.83,1.83,0,0,1,1.83-1.83H556.09v.05H667A23.28,23.28,0,0,1,690.3,453h0A23.29,23.29,0,0,1,667,476.28H558.77v0H380.52a1.83,1.83,0,0,1-1.83-1.83,2.06,2.06,0,0,1,1.83-2h2.79v-39.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M558.77,476.82H380.52a2.33,2.33,0,0,1-2.33-2.33,2.54,2.54,0,0,1,2.26-2.46h2.36v-38.1h-2.29a2.37,2.37,0,0,1,0-4.74H556.09a.65.65,0,0,1,.2,0H667a23.78,23.78,0,0,1,0,47.56H559A.58.58,0,0,1,558.77,476.82ZM380.52,473a1.55,1.55,0,0,0-1.33,1.47,1.34,1.34,0,0,0,1.33,1.33H558.59a.37.37,0,0,1,.18,0H667a22.78,22.78,0,0,0,0-45.56H556.16a.53.53,0,0,1-.28,0H380.52a1.37,1.37,0,0,0,0,2.74h2.79a.51.51,0,0,1,.5.5v39.1a.5.5,0,0,1-.5.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.33,433.49V434a19.32,19.32,0,0,1,14.78,18.78v.38A19.33,19.33,0,0,1,532.33,472v.54H382.4v-39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.33,473H382.4a.5.5,0,0,1-.5-.5v-39a.5.5,0,0,1,.5-.5H532.33a.5.5,0,0,1,.5.5v.15a19.75,19.75,0,0,1,14.78,19.17v.38a19.75,19.75,0,0,1-14.78,19.17v.15A.5.5,0,0,1,532.33,473ZM382.9,472H531.83v0a.51.51,0,0,1,.38-.49,18.75,18.75,0,0,0,14.4-18.29v-.38a18.75,18.75,0,0,0-14.4-18.29.51.51,0,0,1-.38-.49v0H382.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.11,453.19v-.38A19.32,19.32,0,0,0,532.33,434v-.54H666.9a19.32,19.32,0,0,1,19.32,19.32v.38a19.32,19.32,0,0,1-19.32,19.32H532.33V472A19.33,19.33,0,0,0,547.11,453.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.9,473H532.33a.5.5,0,0,1-.5-.5V472a.51.51,0,0,1,.38-.49,18.75,18.75,0,0,0,14.4-18.29v-.38a18.75,18.75,0,0,0-14.4-18.29.51.51,0,0,1-.38-.49v-.54a.5.5,0,0,1,.5-.5H666.9a19.84,19.84,0,0,1,19.82,19.82v.38A19.84,19.84,0,0,1,666.9,473ZM534,472H666.9a18.84,18.84,0,0,0,18.82-18.82v-.38A18.84,18.84,0,0,0,666.9,434H534a19.75,19.75,0,0,1,13.6,18.82v.38A19.75,19.75,0,0,1,534,472Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.76,441.81H526.82a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h10.94a.5.5,0,0,1,.5.5A.5.5,0,0,1,537.76,441.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.68,447.88h-70a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h70a.51.51,0,0,1,.5.5A.5.5,0,0,1,544.68,447.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544,456.46h-8.61a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5H544a.5.5,0,0,1,.5.5A.5.5,0,0,1,544,456.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.81,440H392.16a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h39.65a.5.5,0,0,1,.5.5A.51.51,0,0,1,431.81,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.23,454H382.87a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h15.36a.5.5,0,0,1,.5.5A.5.5,0,0,1,398.23,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.52,461.82H391.44a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.08a.5.5,0,0,1,.5.5A.51.51,0,0,1,407.52,461.82Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--light-bulb--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M554.23,144.64a19.23,19.23,0,1,0-34,12.3A18.87,18.87,0,0,1,524.61,169v2.64h20.78V169A18.85,18.85,0,0,1,549.76,157,19.1,19.1,0,0,0,554.23,144.64Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.89,172.17H524.11V169a18.42,18.42,0,0,0-4.26-11.77,19.73,19.73,0,1,1,30.3,0A18.33,18.33,0,0,0,545.89,169Zm-20.78-1h19.78V169a19.39,19.39,0,0,1,4.49-12.4,18.72,18.72,0,1,0-28.76,0A19.38,19.38,0,0,1,525.11,169Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.62,171.75a.38.38,0,0,1-.38-.36c-.26-5.74-.66-11.79-1.11-16.4a6.75,6.75,0,0,1-1-1.34c-1.18-2-1.75-5.12-.66-6.73a.58.58,0,0,1,.65-.29c.7.2,1.27,3.57,1.73,8a2.69,2.69,0,0,0,2,.81,2.47,2.47,0,0,0,1.45-.77c.51-4.14,1.32-7.47,2.31-7.91a.81.81,0,0,1,.93.1c.86.79-.07,3.61-.27,4.16a11.44,11.44,0,0,1-2.3,4c-.64,5.48-.83,12.48,0,16a.37.37,0,0,1-.28.45.37.37,0,0,1-.45-.27c-.76-3-.71-9.82-.1-15.47a2.71,2.71,0,0,1-1.28.45,3.12,3.12,0,0,1-1.92-.53c.48,5,.82,11.13,1,15.68a.38.38,0,0,1-.35.39ZM539,147.44a.25.25,0,0,0-.11,0c-.65.28-1.29,2.81-1.76,6.18a12.79,12.79,0,0,0,1.59-3.42C539.24,148.54,539.17,147.56,539,147.44Zm-8,.09c-.68,1.31-.34,3.79.79,5.74a3.79,3.79,0,0,0,.2.34A30.6,30.6,0,0,0,531,147.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 524.61,
    y: 171.67,
    width: 20.78,
    height: 5.14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.39,177.19H524.61a.38.38,0,0,1-.37-.38v-5.14a.38.38,0,0,1,.37-.37h20.78a.38.38,0,0,1,.38.37v5.14A.38.38,0,0,1,545.39,177.19Zm-20.4-.75h20v-4.39H525Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.61,176.83h20.78a0,0,0,0,1,0,0v2.63a2.51,2.51,0,0,1-2.51,2.51H527.12a2.51,2.51,0,0,1-2.51-2.51v-2.63A0,0,0,0,1,524.61,176.83Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.88,182.34H527.12a2.88,2.88,0,0,1-2.88-2.88v-2.63a.38.38,0,0,1,.37-.38h20.78a.38.38,0,0,1,.38.38v2.63A2.89,2.89,0,0,1,542.88,182.34ZM525,177.2v2.26a2.13,2.13,0,0,0,2.13,2.13h15.76a2.13,2.13,0,0,0,2.14-2.13V177.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.23,182h15.54a0,0,0,0,1,0,0V183a2.51,2.51,0,0,1-2.51,2.51H529.74a2.51,2.51,0,0,1-2.51-2.51V182A0,0,0,0,1,527.23,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.26,186.05H529.74a3,3,0,0,1-3-3v-1.58h16.54V183A3,3,0,0,1,540.26,186.05Zm-12.53-3.59V183a2,2,0,0,0,2,2h10.52a2,2,0,0,0,2-2v-.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.76,145.12H557a.38.38,0,0,1,0-.75h8.81a.38.38,0,0,1,0,.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.34,145.12h-8.92a.38.38,0,0,1,0-.75h8.92a.38.38,0,0,1,0,.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.59,122.78a.38.38,0,0,1-.38-.38v-8.83a.38.38,0,0,1,.38-.37.37.37,0,0,1,.37.37v8.83A.37.37,0,0,1,534.59,122.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.55,129.16a.38.38,0,0,1-.26-.11.37.37,0,0,1,0-.53l6.07-6.08a.38.38,0,0,1,.54,0,.39.39,0,0,1,0,.53l-6.08,6.08A.4.4,0,0,1,550.55,129.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.55,167.16a.4.4,0,0,1-.27-.11.39.39,0,0,1,0-.53l6.17-6.17a.37.37,0,0,1,.53.53l-6.16,6.17A.4.4,0,0,1,512.55,167.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.45,129a.38.38,0,0,1-.26-.11l-5.91-5.9a.39.39,0,0,1,0-.53.38.38,0,0,1,.54,0l5.9,5.9a.38.38,0,0,1-.27.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.63,167.16a.4.4,0,0,1-.27-.11l-5.87-5.88a.37.37,0,1,1,.53-.53l5.88,5.88a.39.39,0,0,1,0,.53A.4.4,0,0,1,556.63,167.16Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--book-3--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.75,246l.62-1.32L493,215.25H355.87v0c-13.14-.34-26.38,7.58-27.36,23l9.4,7.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.75,246.54H337.9a.53.53,0,0,1-.32-.12l-9.4-7.8a.51.51,0,0,1-.18-.42c1-15.78,14.7-23.74,27.76-23.43l.11,0H493a.49.49,0,0,1,.44.27.51.51,0,0,1,0,.53L471.77,245l-.56,1.23A.52.52,0,0,1,470.75,246.54Zm-132.67-1H470.44l.47-1L492,215.75H356l-.13,0C343.31,215.45,330.12,223,329,238Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "443.42 335.9 580.06 336.45 467.33 242.74 331.27 237.6 443.42 335.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.06,337h0l-136.64-.56a.51.51,0,0,1-.33-.13L330.94,238a.49.49,0,0,1-.13-.56.47.47,0,0,1,.48-.31l136,5.13a.56.56,0,0,1,.31.12l112.73,93.71a.52.52,0,0,1,.15.56A.51.51,0,0,1,580.06,337ZM443.61,335.4l135.06.55L467.14,243.23l-134.48-5.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.84,238.23,334.92,330.35l-3.29-36.85s38.82-21.05,62.51-48S455.33,206,467.84,238.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.92,330.85a.52.52,0,0,1-.21,0,.54.54,0,0,1-.29-.41l-3.29-36.85a.51.51,0,0,1,.26-.48c.39-.21,39-21.33,62.37-47.93,16.18-18.42,37.62-28.92,53.35-26.14,9.7,1.72,17,8.31,21.19,19.05a.49.49,0,0,1-.18.59L335.21,330.76A.52.52,0,0,1,334.92,330.85Zm-2.76-37.06,3.18,35.66,131.89-91.4c-4.06-10.19-11.07-16.43-20.3-18.06-15.39-2.73-36.46,7.64-52.41,25.81C372.11,271.31,335.77,291.78,332.16,293.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.64,238.24l113.1,93.83,6.54-37.8S529.59,241.81,515.87,225,469.21,213.62,467.64,238.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.74,332.57a.54.54,0,0,1-.32-.11l-113.1-93.84a.51.51,0,0,1-.18-.42c.67-10.46,7.23-18.67,17.55-22,11.54-3.69,24.52-.23,31.57,8.42,13.53,16.63,70.78,68.73,71.36,69.26a.5.5,0,0,1,.15.45l-6.53,37.81a.52.52,0,0,1-.32.38ZM468.16,238,580.4,331.14l6.34-36.69c-3.78-3.44-58.08-53-71.26-69.17-6.79-8.35-19.32-11.68-30.48-8.11C475.17,220.32,468.89,228.1,468.16,238Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "205.3 293.5 331.63 293.5 334.92 330.35 208.59 330.35 205.3 293.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.92,330.85H208.59a.49.49,0,0,1-.5-.45l-3.29-36.85a.51.51,0,0,1,.5-.55H331.63a.5.5,0,0,1,.5.46l3.29,36.85a.48.48,0,0,1-.13.38A.51.51,0,0,1,334.92,330.85Zm-125.88-1H334.38L331.17,294H205.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.14,245.47c13-14.77,30.09-25.2,45-26.32l0,0-125-.13-.1.09c-15.17.61-32.89,11.21-46.22,26.4-23.69,27-62.51,48-62.51,48H331.63S370.45,272.45,394.14,245.47Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.63,294H205.3a.49.49,0,0,1-.24-.93c.39-.21,39-21.33,62.37-47.93,13.81-15.73,31.57-25.89,46.4-26.56a.54.54,0,0,1,.3-.1h0l125,.13a.5.5,0,0,1,.46.32.48.48,0,0,1-.12.54.56.56,0,0,1-.34.17c-14.31,1.08-31.41,11.11-44.63,26.16h0c-23.48,26.74-62.26,47.93-62.65,48.14A.48.48,0,0,1,331.63,294Zm-124.42-1H331.5c2.32-1.27,39.53-22,62.26-47.86h0c11.55-13.14,26-22.5,39.15-25.53l-118.6-.13a.43.43,0,0,1-.26.09c-14.6.59-32.18,10.64-45.87,26.23C247.5,269.36,214.93,288.61,207.21,293Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.59,330.35l-4.18,1.23a2.9,2.9,0,0,0-2.09,2.79h0a2.91,2.91,0,0,0,2.91,2.91H334.76l133.62-92.47,110.1,91a2.14,2.14,0,0,0,3.45-1h0a2.13,2.13,0,0,0-.65-2.22L467.84,238.23,334.92,330.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.76,337.78H205.23a3.41,3.41,0,0,1-1-6.68l4.18-1.23.14,0H334.77l132.78-92a.51.51,0,0,1,.61,0L581.6,332.16a2.65,2.65,0,0,1-3.45,4L468.36,245.44,335.05,337.7A.6.6,0,0,1,334.76,337.78Zm-126.1-6.93-4.11,1.21a2.41,2.41,0,0,0,.68,4.72H334.61L468.1,244.4a.5.5,0,0,1,.6,0l110.09,91a1.66,1.66,0,0,0,1.55.33,1.62,1.62,0,0,0,1.11-1.12,1.65,1.65,0,0,0-.5-1.7L467.81,238.86l-132.6,91.9a.52.52,0,0,1-.29.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.06,260.48a.5.5,0,0,1-.3-.9c4.92-3.65,9.33-7.36,13.59-10.94,10.18-8.55,19-15.94,29.44-17.88a29.94,29.94,0,0,1,18.27,2.52.49.49,0,0,1,.24.66.5.5,0,0,1-.67.24A28.94,28.94,0,0,0,443,231.75c-10.21,1.89-18.91,9.19-29,17.66-4.28,3.59-8.7,7.3-13.64,11A.49.49,0,0,1,400.06,260.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.08,283.27a.49.49,0,0,1-.43-.24.49.49,0,0,1,.17-.68c13.14-8,24.37-17.1,34.27-25.13,9.41-7.62,17.55-14.21,24-16.91a48.19,48.19,0,0,1,25.8-2.73.5.5,0,1,1-.21,1,47.14,47.14,0,0,0-25.2,2.67c-6.33,2.65-14.4,9.19-23.76,16.77-9.93,8-21.18,17.16-34.38,25.2A.48.48,0,0,1,382.08,283.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.73,270.79a.51.51,0,0,1-.32-.12c-.31-.25-31.52-25.77-38.39-32-9.85-8.94-22.41.8-22.54.9a.5.5,0,1,1-.62-.78c.13-.11,13.35-10.38,23.83-.86,6.86,6.22,38,31.71,38.36,32a.5.5,0,0,1,.07.7A.48.48,0,0,1,532.73,270.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.94,280.8a.49.49,0,0,1-.34-.14L536,273.52a.48.48,0,0,1,0-.7.51.51,0,0,1,.71,0l7.65,7.14a.5.5,0,0,1,0,.71A.46.46,0,0,1,543.94,280.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.48,298.73a.51.51,0,0,1-.33-.13L511.09,260a.5.5,0,1,1,.67-.74l43,38.6a.5.5,0,0,1-.33.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.33,275.37a.52.52,0,0,1-.35-.14l-20.4-19.46a.5.5,0,0,1,.69-.72l20.4,19.46a.49.49,0,0,1,0,.7A.48.48,0,0,1,552.33,275.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.68,271a.5.5,0,0,1-.31-.89l11.1-8.7a.5.5,0,0,1,.7.08.52.52,0,0,1-.08.71l-11.1,8.7A.52.52,0,0,1,385.68,271Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.67,314.18a.5.5,0,0,1-.41-.22.49.49,0,0,1,.13-.69l45-31.21a.51.51,0,0,1,.7.13.5.5,0,0,1-.13.7l-45,31.2A.52.52,0,0,1,352.67,314.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.27,314.18a.5.5,0,0,1-.5-.5c0-.32,0-1.17,20.93-14.82a.5.5,0,0,1,.69.14.51.51,0,0,1-.14.7c-7.52,4.9-19.64,13-20.5,14.14A.51.51,0,0,1,338.27,314.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.43,301.69H208.29a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h25.14a.5.5,0,0,1,.5.5A.51.51,0,0,1,233.43,301.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.87,308.28H224.36a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h72.51a.5.5,0,0,1,.5.5A.5.5,0,0,1,296.87,308.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.13,321.05H274.21a.5.5,0,0,1,0-1h58.92a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522,248.11a.49.49,0,0,1-.38-.18c-.13-.16-13.07-15.9-27.72-19.49-14.48-3.54-21.71,7-21.78,7.12a.5.5,0,0,1-.84-.55c.08-.11,7.7-11.24,22.86-7.54,15,3.66,28.12,19.67,28.25,19.83a.49.49,0,0,1-.07.7A.46.46,0,0,1,522,248.11Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Flask--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M550.75,456.38l-64.34-128.5V278.82H444.58v49.06l-64.31,128.5a14.29,14.29,0,0,0,13.11,19.94H537.64A14.28,14.28,0,0,0,550.75,456.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M537.64,476.82H393.38a14.79,14.79,0,0,1-13.57-20.63l64.27-128.42V278.82a.5.5,0,0,1,.5-.5h41.83a.5.5,0,0,1,.5.5v48.95L551.2,456.16v0a14.78,14.78,0,0,1-13.57,20.63Zm-92.56-197.5v48.56a.59.59,0,0,1-.05.23l-64.31,128.5a13.78,13.78,0,0,0,12.66,19.21H537.64a13.79,13.79,0,0,0,12.66-19.23L486,328.11a.46.46,0,0,1,0-.23V279.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.94,399.76a.44.44,0,0,1-.22-.05.5.5,0,0,1-.23-.67l3.19-6.46a.5.5,0,0,1,.89.45l-3.18,6.45A.5.5,0,0,1,415.94,399.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486,282.16H445.15a3.65,3.65,0,0,1-3.65-3.65h0a3.65,3.65,0,0,1,3.65-3.64H486a3.64,3.64,0,0,1,3.64,3.64h0A3.64,3.64,0,0,1,486,282.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486,282.66H445.15a4.15,4.15,0,1,1,0-8.29H486a4.15,4.15,0,0,1,0,8.29Zm-40.85-7.29a3.15,3.15,0,1,0,0,6.29H486a3.15,3.15,0,0,0,0-6.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.21,335.24H445.75L386.36,453.59c-3.77,9.07,2.64,19.18,12.18,19.18h134c9.53,0,16-10.11,12.17-19.18Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.75,335.24s9,6.86,19.48,7.58,21-7.58,21-7.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.55,343.37c-.45,0-.9,0-1.36-.05-10.54-.72-19.66-7.61-19.75-7.68a.51.51,0,0,1-.17-.56.51.51,0,0,1,.48-.34h40.46a.51.51,0,0,1,.47.34.5.5,0,0,1-.16.55C486.1,336,476.64,343.37,466.55,343.37Zm-19.21-7.63c2.83,1.87,10,6,17.92,6.58,8.13.57,16.36-4.48,19.4-6.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 465.58,
    cy: 338.28,
    rx: 10.16,
    ry: 2.15,
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.84,460.15c-2.18-4.35-1.33-11.31.16-17.44l-5.64,10.88c-3.77,9.07,2.64,19.18,12.18,19.18H416.7C400.11,470.75,396.25,469,391.84,460.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.7,473.27H398.54a13.45,13.45,0,0,1-11.32-6.14,14.57,14.57,0,0,1-1.32-13.74l5.66-10.91a.5.5,0,0,1,.93.35c-1.88,7.7-1.95,13.61-.2,17.1h0c4.28,8.57,7.71,10.3,24.47,12.35a.5.5,0,0,1-.06,1Zm-26-27-3.93,7.57a13.56,13.56,0,0,0,1.25,12.75,12.46,12.46,0,0,0,10.49,5.7h11c-11.14-1.86-14.41-4.4-18.15-11.89C389.81,457.21,389.59,452.47,390.73,446.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.27,472.77h7.22c9.53,0,16-10.11,12.17-19.18l-8.42-16.24a119.86,119.86,0,0,1,2.37,15.14A19.45,19.45,0,0,1,525.27,472.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.49,473.27h-7.22a.5.5,0,0,1-.17-1c10.43-3.75,13.56-12.67,13-19.77a117.42,117.42,0,0,0-2.36-15.07.51.51,0,0,1,.32-.58.5.5,0,0,1,.61.24l8.43,16.24a14.62,14.62,0,0,1-1.3,13.77A13.46,13.46,0,0,1,532.49,473.27Zm-4.72-1h4.72a12.48,12.48,0,0,0,10.49-5.7,13.6,13.6,0,0,0,1.22-12.79l-6.75-13a109.18,109.18,0,0,1,1.66,11.69A19.76,19.76,0,0,1,527.77,472.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.12,429.51H464a.5.5,0,0,1,0-1h19.12a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.12,405.6H464a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h19.12a.51.51,0,0,1,.5.5A.5.5,0,0,1,483.12,405.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.12,381.69H464a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h19.12a.51.51,0,0,1,.5.5A.5.5,0,0,1,483.12,381.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.12,453.42H464a.5.5,0,0,1-.5-.5V357.28a.51.51,0,0,1,.5-.5h19.12a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5H464.5v94.64h18.62a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.63,
    y: 284.99,
    width: 36.52,
    height: 47.8,
    style: {
      fill: "#828282"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--books-1--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M418.16,426.27V387.16H421a1.83,1.83,0,0,0,1.83-1.82v-.09a1.83,1.83,0,0,0-1.83-1.83H245.38v46.64H421a1.83,1.83,0,0,0,1.83-1.83h0a2,2,0,0,0-1.83-2Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421,430.56H245.38a.5.5,0,0,1-.5-.5V383.42a.5.5,0,0,1,.5-.5H421a2.37,2.37,0,0,1,0,4.74h-2.29v38.1H421a2.57,2.57,0,0,1,2.33,2.47A2.33,2.33,0,0,1,421,430.56Zm-175.07-1H421a1.34,1.34,0,0,0,1.33-1.33,1.55,1.55,0,0,0-1.4-1.47h-2.72a.5.5,0,0,1-.5-.5v-39.1a.51.51,0,0,1,.5-.5H421a1.33,1.33,0,0,0,1.33-1.33,1.36,1.36,0,0,0-1.33-1.41H245.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.38,
    y: 387.23,
    width: 173.69,
    height: 39.02,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.07,426.75H245.38a.5.5,0,0,1-.5-.5v-39a.5.5,0,0,1,.5-.5H419.07a.5.5,0,0,1,.5.5v39A.5.5,0,0,1,419.07,426.75Zm-173.19-1H418.57v-38H245.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.21,383.46H245.38a0,0,0,0,1,0,0V430a0,0,0,0,1,0,0H133.21a22,22,0,0,1-22-22V405.5A22,22,0,0,1,133.21,383.46Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.38,430.52H133.21A22.56,22.56,0,0,1,110.67,408V405.5A22.56,22.56,0,0,1,133.21,383H245.38a.51.51,0,0,1,.5.5V430A.51.51,0,0,1,245.38,430.52ZM133.21,384a21.56,21.56,0,0,0-21.54,21.54V408a21.56,21.56,0,0,0,21.54,21.54H244.88V384Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.72,387.23H245.38a0,0,0,0,1,0,0v39a0,0,0,0,1,0,0H133.72a18.47,18.47,0,0,1-18.47-18.47V405.7A18.47,18.47,0,0,1,133.72,387.23Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.38,426.75H133.72a19,19,0,0,1-19-19V405.7a19,19,0,0,1,19-19H245.38a.5.5,0,0,1,.5.5v39A.5.5,0,0,1,245.38,426.75Zm-111.66-39a18,18,0,0,0-18,18v2.08a18,18,0,0,0,18,18H244.88v-38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.65,395.55H246.08a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h28.57a.5.5,0,0,1,.5.5A.5.5,0,0,1,274.65,395.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.8,401.63h-70a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h70a.5.5,0,0,1,.5.5A.5.5,0,0,1,326.8,401.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.08,410.2H250.72a.5.5,0,1,1,0-1h15.36a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.31,393.77H369.66a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h39.65a.5.5,0,0,1,.5.5A.5.5,0,0,1,409.31,393.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.6,407.7H403.24a.5.5,0,0,1,0-1H418.6a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,415.56H394a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5H410a.5.5,0,0,1,.5.5A.51.51,0,0,1,410,415.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.85,407.05h-32.6a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h32.6a.51.51,0,0,1,.5.5A.5.5,0,0,1,147.85,407.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.28,402.34H127.13a.5.5,0,0,1,0-1h17.15a.5.5,0,1,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.64,413.06H123.56a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h46.08a.5.5,0,0,1,.5.5A.51.51,0,0,1,169.64,413.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.36,419.49H230.72a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h14.64a.5.5,0,0,1,.5.5A.5.5,0,0,1,245.36,419.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.72,414.84H237.15a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h18.57a.5.5,0,0,1,.5.5A.5.5,0,0,1,255.72,414.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.71,433.42a1.83,1.83,0,0,0,1.83-1.83v-.08a1.83,1.83,0,0,0-1.83-1.83H224.14v.05H113.21A23.28,23.28,0,0,0,89.93,453h0a23.28,23.28,0,0,0,23.28,23.28H221.45v0H399.71a1.83,1.83,0,0,0,1.83-1.83,2.06,2.06,0,0,0-1.83-2h-2.79v-39.1Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.71,476.82H221.45a.65.65,0,0,1-.2,0h-108a23.78,23.78,0,0,1,0-47.56H224a.58.58,0,0,1,.19,0H399.71a2.37,2.37,0,0,1,0,4.74h-2.29V472h2.29a2.57,2.57,0,0,1,2.33,2.47A2.34,2.34,0,0,1,399.71,476.82Zm-178-1h178a1.34,1.34,0,0,0,1.33-1.33,1.55,1.55,0,0,0-1.4-1.47h-2.72a.5.5,0,0,1-.5-.5v-39.1a.5.5,0,0,1,.5-.5h2.79a1.33,1.33,0,0,0,1.33-1.33,1.36,1.36,0,0,0-1.33-1.41H224.33a.39.39,0,0,1-.26,0H113.21a22.78,22.78,0,0,0,0,45.56H221.45A.49.49,0,0,1,221.66,475.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119,453h0c0-12.86,14-23.28,26.81-23.28H130.91A23.28,23.28,0,0,0,107.63,453h0a23.28,23.28,0,0,0,23.28,23.28h14.88C132.93,476.28,119,465.85,119,453Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.79,476.78H130.91a23.78,23.78,0,0,1,0-47.56h14.88a.51.51,0,0,1,.5.5.5.5,0,0,1-.5.5c-12.17,0-26.31,9.95-26.31,22.78s14.14,22.78,26.31,22.78a.5.5,0,0,1,.5.5A.51.51,0,0,1,145.79,476.78Zm-14.88-46.56a22.78,22.78,0,0,0,0,45.56h7.83c-10.47-2.91-20.26-11.84-20.26-22.78s9.79-19.87,20.26-22.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.38,453h0c0-12.86,14-23.28,26.81-23.28H217.31A23.28,23.28,0,0,0,194,453h0a23.28,23.28,0,0,0,23.28,23.28h14.88C219.33,476.28,205.38,465.85,205.38,453Z",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.19,476.78H217.31a23.78,23.78,0,0,1,0-47.56h14.88a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5c-12.17,0-26.31,9.95-26.31,22.78s14.14,22.78,26.31,22.78a.5.5,0,0,1,.5.5A.5.5,0,0,1,232.19,476.78Zm-14.88-46.56a22.78,22.78,0,0,0,0,45.56h7.84c-10.48-2.91-20.27-11.84-20.27-22.78s9.79-19.87,20.27-22.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.54,474.49a2.06,2.06,0,0,0-1.83-2h-2.79v-39.1h2.79a1.83,1.83,0,0,0,1.83-1.83v-.08a1.83,1.83,0,0,0-1.83-1.83H362.87v.05H251.94A23.28,23.28,0,0,0,228.66,453h0a23.28,23.28,0,0,0,23.28,23.28H360.18v0h39.53A1.83,1.83,0,0,0,401.54,474.49Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.71,476.82H360.18a.65.65,0,0,1-.2,0h-108a23.78,23.78,0,0,1,0-47.56H362.68a.58.58,0,0,1,.19,0h36.84a2.37,2.37,0,0,1,0,4.74h-2.29V472h2.29a2.57,2.57,0,0,1,2.33,2.47A2.34,2.34,0,0,1,399.71,476.82Zm-39.33-1h39.33a1.34,1.34,0,0,0,1.33-1.33,1.55,1.55,0,0,0-1.4-1.47h-2.72a.5.5,0,0,1-.5-.5v-39.1a.5.5,0,0,1,.5-.5h2.79a1.33,1.33,0,0,0,1.33-1.33,1.36,1.36,0,0,0-1.33-1.41H363.06a.46.46,0,0,1-.26,0H251.94a22.78,22.78,0,0,0,0,45.56H360.18A.45.45,0,0,1,360.38,475.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.9,434a19.32,19.32,0,0,0-14.78,18.78v.38A19.33,19.33,0,0,0,247.9,472l149.93.54v-39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.83,473h0l-149.93-.54h-.12a19.76,19.76,0,0,1-15.16-19.27v-.38a19.76,19.76,0,0,1,15.16-19.27h.12L397.83,433a.37.37,0,0,1,.35.14.51.51,0,0,1,.15.36v39a.51.51,0,0,1-.15.36A.5.5,0,0,1,397.83,473ZM248,471.47l149.37.54V434L248,434.53a18.75,18.75,0,0,0-14.34,18.28v.38A18.75,18.75,0,0,0,248,471.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.41,441.81H242.46a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5h10.95a.5.5,0,0,1,.5.5A.5.5,0,0,1,253.41,441.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.56,447.88h-70a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h70a.51.51,0,0,1,.5.5A.5.5,0,0,1,305.56,447.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.84,456.46h-8.61a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h8.61a.5.5,0,0,1,.5.5A.51.51,0,0,1,244.84,456.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.07,440H348.42a.51.51,0,0,1-.5-.5.5.5,0,0,1,.5-.5h39.65a.5.5,0,0,1,.5.5A.5.5,0,0,1,388.07,440Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.36,454H382a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h15.36a.5.5,0,0,1,.5.5A.51.51,0,0,1,397.36,454Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.78,461.82H372.71a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h16.07a.5.5,0,0,1,.5.5A.5.5,0,0,1,388.78,461.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.88,340.7a1.81,1.81,0,0,0,1.82-1.82v-.09a1.82,1.82,0,0,0-1.82-1.83H263.3V337H152.37a23.27,23.27,0,0,0-23.27,23.27h0a23.27,23.27,0,0,0,23.27,23.28H260.62v0H438.88a1.82,1.82,0,0,0,1.82-1.83,2,2,0,0,0-1.82-2h-2.79V340.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.88,384.1H260.62a.45.45,0,0,1-.2,0h-108a23.78,23.78,0,0,1,0-47.55H263.12a.41.41,0,0,1,.18-.05H438.88a2.38,2.38,0,0,1,0,4.75h-2.29v38.1h2.29a2.56,2.56,0,0,1,2.32,2.46A2.32,2.32,0,0,1,438.88,384.1Zm-178.06-1H438.88a1.33,1.33,0,0,0,1.32-1.33,1.55,1.55,0,0,0-1.39-1.47h-2.72a.5.5,0,0,1-.5-.5v-39.1a.5.5,0,0,1,.5-.5h2.79a1.33,1.33,0,0,0,1.32-1.33,1.35,1.35,0,0,0-1.32-1.42H263.5a.47.47,0,0,1-.26.05H152.37a22.78,22.78,0,0,0,0,45.55H260.62A.45.45,0,0,1,260.82,383.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.07,340.77v.54a19.35,19.35,0,0,0-14.79,18.79v.37a19.33,19.33,0,0,0,14.79,18.78v.54H437v-39Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437,380.29H287.07a.5.5,0,0,1-.5-.5v-.15a19.75,19.75,0,0,1-14.79-19.17v-.38a19.76,19.76,0,0,1,14.79-19.17v-.15a.5.5,0,0,1,.5-.5H437a.51.51,0,0,1,.5.5v39A.5.5,0,0,1,437,380.29Zm-149.43-1H436.5v-38H287.57v0a.5.5,0,0,1-.39.49,18.76,18.76,0,0,0-14.4,18.29v.38a18.77,18.77,0,0,0,14.4,18.3.49.49,0,0,1,.39.48Zm-.5-38h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.28,360.47v-.37a19.35,19.35,0,0,1,14.79-18.79v-.54H152.49a19.32,19.32,0,0,0-19.32,19.33v.37a19.32,19.32,0,0,0,19.32,19.32H287.07v-.54A19.33,19.33,0,0,1,272.28,360.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.07,380.29H152.49a19.84,19.84,0,0,1-19.82-19.82v-.38a19.84,19.84,0,0,1,19.82-19.82H287.07a.51.51,0,0,1,.5.5v.54a.5.5,0,0,1-.39.49,18.76,18.76,0,0,0-14.4,18.29v.38a18.77,18.77,0,0,0,14.4,18.3.49.49,0,0,1,.39.48v.54A.5.5,0,0,1,287.07,380.29Zm-134.58-39a18.85,18.85,0,0,0-18.82,18.82v.38a18.84,18.84,0,0,0,18.82,18.82H285.38a19.75,19.75,0,0,1-13.6-18.82v-.38a19.75,19.75,0,0,1,13.6-18.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.57,349.1H281.63a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h10.94a.5.5,0,0,1,.5.5A.5.5,0,0,1,292.57,349.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.72,355.17h-70a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h70a.5.5,0,0,1,.5.5A.5.5,0,0,1,344.72,355.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,363.74h-8.61a.5.5,0,0,1,0-1H284a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.24,347.31H387.59a.5.5,0,0,1,0-1h39.65a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.52,361.24H421.16a.5.5,0,0,1,0-1h15.36a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428,369.1H411.88a.5.5,0,0,1,0-1H428a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M143.24,310.15s2.34,2.91,1.74,4-1.72,2.77-3.06,2-2.09-3.46-2.09-3.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.6,316.85a1.82,1.82,0,0,1-.92-.25c-1.47-.84-2.25-3.46-2.33-3.76a.51.51,0,0,1,.18-.54l3.41-2.55a.5.5,0,0,1,.69.09c.6.74,2.49,3.27,1.79,4.55s-1.51,2.16-2.33,2.39A1.66,1.66,0,0,1,142.6,316.85Zm-2.19-4a5.84,5.84,0,0,0,1.76,2.84.84.84,0,0,0,.65.09c.37-.11,1-.52,1.72-1.9.23-.43-.51-1.87-1.39-3.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.73,316.19s5.7-6.05,6.51-6.64,5.59-3.44,6.23-2.11-1.41,1.69-1.9,2.08-3.15,3.56-3.15,3.56-.48.39,1.31,1.1,4-2.25,4.58-1.1-.69,2-2.15,3.14a9.6,9.6,0,0,1-4.49,2.12,13.2,13.2,0,0,1-3.45.14l-2,1.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.25,320.19l-.15,0a.49.49,0,0,1-.31-.27l-1.52-3.51a.49.49,0,0,1,.1-.54c.58-.62,5.75-6.09,6.58-6.69,0,0,4.41-3,6.22-2.51a1.08,1.08,0,0,1,.75.59,1.46,1.46,0,0,1,.09,1.15,2.76,2.76,0,0,1-1.65,1.29,3,3,0,0,0-.48.24c-.31.24-1.9,2.09-2.93,3.32a3.93,3.93,0,0,0,1,.48c.71.28,1.6-.26,2.39-.73s1.29-.79,1.85-.63a.94.94,0,0,1,.6.5c.75,1.39-.48,2.35-1.78,3.36l-.49.4a10.12,10.12,0,0,1-4.71,2.22,13.71,13.71,0,0,1-3.43.16l-1.83,1.12A.5.5,0,0,1,135.25,320.19Zm-.93-3.9,1.16,2.67,1.48-.91a.52.52,0,0,1,.32-.07,12.83,12.83,0,0,0,3.3-.13,9.1,9.1,0,0,0,4.27-2l.51-.41c1.32-1,1.83-1.51,1.51-2.1a3.58,3.58,0,0,0-1.05.51c-.94.57-2.11,1.27-3.27.81s-1.61-.83-1.68-1.31a.69.69,0,0,1,.24-.64c.38-.47,2.65-3.17,3.15-3.57a3.47,3.47,0,0,1,.7-.36c.4-.18,1-.44,1.11-.73a.49.49,0,0,0,0-.37c-1.11-.3-4.57,1.63-5.48,2.3C140,310.36,136.6,313.87,134.32,316.29Zm7.53-2.94,0,0A.1.1,0,0,0,141.85,313.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "134.08 314.25 137.5 327.45 126.25 335.37 117.41 327.5 134.08 314.25",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.21,336l-9.57-8.54,17.73-14.09,3.7,14.29Zm-8-8.49,8.09,7.22,10.64-7.49-3.13-12.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.58,317.17l1.82,8.22,8.46-1.11-.72-6.13s4.27.9,6.71-2.41-2.12-11.66-3.45-14.27S109.17,311.47,108.58,317.17Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.4,325.89a.49.49,0,0,1-.49-.39l-1.82-8.22a.86.86,0,0,1,0-.16c.53-5.12,9.16-15.87,12.42-16.48a1.19,1.19,0,0,1,1.35.6l.28.56c1.67,3.26,5.59,10.88,3.12,14.23a7.18,7.18,0,0,1-6.54,2.7l.65,5.49a.51.51,0,0,1-.44.56l-8.46,1.11Zm-1.32-8.75,1.71,7.69,7.52-1-.67-5.64a.5.5,0,0,1,.6-.55c.16,0,4,.79,6.2-2.22,2.11-2.85-1.75-10.36-3.2-13.18l-.28-.57c0-.05-.06-.1-.28-.06C118.09,302.11,109.67,312.22,109.08,317.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.71,295a9.81,9.81,0,0,0-7.41,6.85c-1.84,6,3.29,10.45,6.85,13.6s6,6,9.86,4.41,6.41-7.85,7.81-14.71,0-12.75-4.43-13.09S108.59,292.58,105.71,295Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.87,320.85c-2.54,0-4.59-1.86-6.88-4l-1.17-1.06-.1-.09c-3.51-3.1-8.81-7.79-6.9-14a10.27,10.27,0,0,1,7.67-7.17c3.27-2.68,9-3.28,12.94-3a4.89,4.89,0,0,1,3.63,2c1.79,2.37,2.26,6.73,1.25,11.67-1,4.77-3.32,13.07-8.11,15.07A6,6,0,0,1,112.87,320.85Zm3.65-28.34c-3.76,0-8.07.84-10.48,2.89a.47.47,0,0,1-.25.11,9.27,9.27,0,0,0-7,6.5c-1.73,5.63,3.09,9.89,6.6,13l.1.09,1.19,1.06c2.91,2.65,5,4.57,8.15,3.26s5.9-6.45,7.51-14.35c1-4.66.55-8.72-1.07-10.87a3.9,3.9,0,0,0-2.91-1.62C117.76,292.53,117.15,292.51,116.52,292.51ZM105.71,295h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.17,299.25s-7.13-6.47-15.79-3.52-8.93,16.45-5.48,20.52S86,325.9,85.12,328s2.27,7.09,8.62,4.71,7.31-12.12,3.3-18.33-5.18-11.2-2-14,7.67,2.24,8.64.88A1.21,1.21,0,0,0,103.17,299.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.53,333.83a6.35,6.35,0,0,1-4.67-1.92,4.1,4.1,0,0,1-1.2-4.13c.76-1.73.35-7.11-3.14-11.21C79.37,314,78.7,308.38,80,303.68c1.17-4.25,3.73-7.24,7.22-8.43,8.4-2.86,15.48,2.93,16.22,3.57a1.94,1.94,0,0,1,1,1.12,1.76,1.76,0,0,1-.36,1.56c-.63.88-1.78.31-3.1-.35-1.75-.87-3.92-1.95-5.62-.45-2.79,2.46-2.09,7,2.06,13.39a15.94,15.94,0,0,1,1.78,13.14,9.08,9.08,0,0,1-5.33,5.93A9.6,9.6,0,0,1,90.53,333.83ZM92,295.46a13.71,13.71,0,0,0-4.43.74C84.38,297.27,82,300,81,304c-1.36,4.92-.39,9.95,1.32,12,3.54,4.17,4.31,9.95,3.3,12.26a3.17,3.17,0,0,0,1,3c.76.8,3,2.5,7,1a8.1,8.1,0,0,0,4.73-5.3,14.88,14.88,0,0,0-1.67-12.28c-4.46-6.91-5.1-11.85-1.88-14.69,2.2-1.94,4.92-.59,6.72.31.6.29,1.71.84,1.84.66a.87.87,0,0,0,.22-.7,1,1,0,0,0-.53-.51.38.38,0,0,1-.15-.09A18,18,0,0,0,92,295.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,327.57s-3.14-4.65-5.93-5.31-13.74,1.21-14.49,3.1a24.24,24.24,0,0,0-1.11,3.92Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.85,329.83l.11-.64a25.47,25.47,0,0,1,1.14-4c.94-2.39,12.4-4,15.06-3.4,3,.7,6.1,5.32,6.23,5.52l.48.71Zm14.48-7.22c-4,0-11.82,1.72-12.3,2.93a21.63,21.63,0,0,0-1,3.19l20-1.59c-1-1.29-3.18-3.93-5.12-4.39A7.07,7.07,0,0,0,117.33,322.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.62,377.38a112.53,112.53,0,0,0-.91,18.15c.36,9.43,6.17,26,6.17,28.3s-2,12.89-.73,18.33,5.27,19.6,5.27,22.68-1.27,11.25-.19,11.44,8,0,8,0,1.45.36,1.27-2.54c-.09-1.45-1.27-3.82-1.27-4.36s-1.63-6.71-1.63-7.26,1.08-22.14,1.63-30.85S115,401.33,115,401.33l1.45.19v26.85c0,9.62-.36,21.78.37,27s.54,20.87.54,20.87h14.88s1.09-.73-.54-3.09-3.81-3.08-5.08-4.17-2.36-6.72-2.36-6.72,4.9-16.69,5.26-22.13.91-19.24.91-20.15,6.53-14,6.53-22.5a138.31,138.31,0,0,0-1.82-19.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85,476.86a26.18,26.18,0,0,1-2.7-.09c-1.08-.18-1-2.26-.52-7.7.15-1.66.29-3.22.29-4.23,0-2.11-2-9.82-3.6-16-.69-2.65-1.28-4.94-1.65-6.54-.94-4-.16-10.6.37-14.95.19-1.6.34-2.87.34-3.5a52.77,52.77,0,0,0-1.63-6.63c-1.72-6.16-4.3-15.46-4.54-21.65a114.45,114.45,0,0,1,.91-18.24.56.56,0,0,1,.51-.43l39.56.91a.49.49,0,0,1,.48.42,139.74,139.74,0,0,1,1.82,19.31c0,6.53-3.77,15.67-5.58,20.07-.47,1.15-.92,2.24-.95,2.46,0,.93-.56,14.84-.91,20.15s-4.78,20.51-5.25,22.13c.42,2.12,1.36,5.61,2.17,6.31a11.94,11.94,0,0,0,1.39.95,11.83,11.83,0,0,1,3.78,3.32,4,4,0,0,1,1,2.87,1.39,1.39,0,0,1-.54.91.47.47,0,0,1-.28.09H117.39a.51.51,0,0,1-.5-.51c0-.16.17-15.63-.54-20.79-.55-4-.48-11.93-.41-19.61,0-2.56,0-5.11,0-7.5V402l-.48-.06c-.2,3.34-1.29,21.51-1.78,29.41-.55,8.83-1.63,30.34-1.64,30.81,0,.27.47,2.14.81,3.51a34.67,34.67,0,0,1,.83,3.75,9.54,9.54,0,0,0,.39,1.19,12.18,12.18,0,0,1,.88,3.13,3.27,3.27,0,0,1-.73,2.77,1.44,1.44,0,0,1-1.08.31C112.61,476.79,110,476.86,107.85,476.86Zm-2.39-1h0Zm0-.06c1.12.12,5.94,0,7.78,0h.13a.39.39,0,0,0,.29-.1c.14-.12.44-.56.36-1.92a11.84,11.84,0,0,0-.82-2.86,5.49,5.49,0,0,1-.45-1.53c0-.27-.47-2.14-.8-3.51a35.79,35.79,0,0,1-.84-3.75c0-.6,1.11-22.47,1.64-30.88.54-8.71,1.81-29.94,1.81-29.94a.54.54,0,0,1,.18-.35.49.49,0,0,1,.38-.11l1.46.18a.49.49,0,0,1,.43.5v26.85c0,2.4,0,4.95,0,7.51-.07,7.64-.14,15.54.4,19.46.66,4.77.58,17.67.56,20.44h14.15c.11-.22.26-.87-.73-2.31a10.91,10.91,0,0,0-3.49-3,12.87,12.87,0,0,1-1.51-1c-1.36-1.17-2.41-6.41-2.52-7a.39.39,0,0,1,0-.24c0-.16,4.89-16.7,5.24-22S130,421,130,420a12.4,12.4,0,0,1,1-2.81c1.78-4.34,5.5-13.35,5.5-19.69a137.44,137.44,0,0,0-1.74-18.74l-38.7-.89a114.45,114.45,0,0,0-.84,17.62c.23,6.07,2.8,15.31,4.5,21.42a46.5,46.5,0,0,1,1.67,6.9c0,.69-.16,2-.35,3.62-.51,4.28-1.29,10.75-.39,14.6.37,1.59,1,4,1.65,6.52,1.7,6.58,3.63,14,3.63,16.27,0,1.05-.14,2.64-.29,4.32C105.43,471.39,105.1,475.07,105.43,475.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.62,377.38a112.53,112.53,0,0,0-.91,18.15,62.44,62.44,0,0,0,1.73,10.89,27.78,27.78,0,0,0,18.23,1c.22-3.59.36-6.05.36-6.05l1.45.19v6c2.89,1,11,3.08,18.82-.62a34.43,34.43,0,0,0,1.69-9.4,138.31,138.31,0,0,0-1.82-19.23Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.55,409.53a29.63,29.63,0,0,1-9.22-1.52.49.49,0,0,1-.35-.47V402l-.48-.06-.33,5.51a.48.48,0,0,1-.35.44,28,28,0,0,1-18.57-1,.47.47,0,0,1-.29-.35,61.75,61.75,0,0,1-1.75-11,114.45,114.45,0,0,1,.91-18.24.56.56,0,0,1,.51-.43l39.56.91a.49.49,0,0,1,.48.42,139.74,139.74,0,0,1,1.82,19.31,34.86,34.86,0,0,1-1.71,9.54.51.51,0,0,1-.26.31A23.12,23.12,0,0,1,125.55,409.53ZM117,407.18c3.23,1,10.7,2.72,17.91-.62a33.4,33.4,0,0,0,1.6-9,137.62,137.62,0,0,0-1.74-18.74l-38.7-.89a114.45,114.45,0,0,0-.84,17.62,59.91,59.91,0,0,0,1.66,10.54,27.47,27.47,0,0,0,17.32.95l.34-5.7a.54.54,0,0,1,.18-.35.49.49,0,0,1,.38-.11l1.46.18a.49.49,0,0,1,.43.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.67,407.38c0-.53.06-1,.09-1.52a29.63,29.63,0,0,1-18.62-.78l.3,1.34A27.78,27.78,0,0,0,114.67,407.38Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.13,409a29.47,29.47,0,0,1-10.88-2.14.47.47,0,0,1-.29-.35c-.11-.45-.21-.9-.31-1.34a.51.51,0,0,1,.17-.49.5.5,0,0,1,.51-.08,29.16,29.16,0,0,0,18.3.76.5.5,0,0,1,.63.51l-.09,1.52a.49.49,0,0,1-.35.44A25.47,25.47,0,0,1,107.13,409Zm-10.26-3a27.47,27.47,0,0,0,17.32.95l0-.48a30.4,30.4,0,0,1-17.39-.64A.85.85,0,0,1,96.87,406.05Zm17.8,1.33h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.85,404.94a29.58,29.58,0,0,1-19.37,1.11v1.49c2.89,1,11,3.08,18.82-.62C135.5,406.26,135.68,405.6,135.85,404.94Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.55,409.53a29.63,29.63,0,0,1-9.22-1.52.49.49,0,0,1-.35-.47v-1.49a.51.51,0,0,1,.2-.4.47.47,0,0,1,.44-.08,29,29,0,0,0,19-1.09.5.5,0,0,1,.68.58c-.18.67-.36,1.34-.56,2a.51.51,0,0,1-.26.31A23.12,23.12,0,0,1,125.55,409.53ZM117,407.18c3.23,1,10.7,2.72,17.91-.62.07-.26.15-.52.22-.79a30.08,30.08,0,0,1-18.13.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.38,402.2h0l-11.25-.73a.52.52,0,0,1-.47-.53.5.5,0,0,1,.54-.47l11.25.73a.5.5,0,0,1,0,1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.8 332.06 171.06 332.7 164.97 355.29 133.16 354.65 138.8 332.06",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,355.79h0l-31.81-.64a.5.5,0,0,1-.47-.62l5.64-22.59a.52.52,0,0,1,.49-.38l32.27.64a.55.55,0,0,1,.39.2.51.51,0,0,1,.08.43l-6.1,22.59A.5.5,0,0,1,165,355.79Zm-31.17-1.62,30.78.61,5.84-21.59-31.23-.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "140.88 333.87 168.11 334.42 162.96 353.48 136.12 352.94 140.88 333.87",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,354h0l-26.84-.54a.48.48,0,0,1-.47-.62l4.75-19.07a.6.6,0,0,1,.5-.38l27.23.55a.49.49,0,0,1,.39.2.5.5,0,0,1,.08.43l-5.15,19.06A.49.49,0,0,1,163,354Zm-26.2-1.53,25.82.52,4.88-18.07-26.19-.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.04,
    y: 354.85,
    width: 43.91,
    height: 2.19,
    transform: "translate(7.14 -2.79) rotate(1.14)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.92,358h0L121,357.1a.51.51,0,0,1-.35-.15.52.52,0,0,1-.14-.36l0-2.19a.55.55,0,0,1,.51-.49l43.91.88a.51.51,0,0,1,.49.51l-.05,2.19a.51.51,0,0,1-.15.35A.5.5,0,0,1,164.92,358Zm-43.39-1.87,42.9.86,0-1.19-42.91-.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.46,327.12s-9.53-.95-15.39,4.85a7.64,7.64,0,0,0-4.19,7.47c.08.91,1.32,28.46.64,33.07s-.91,8.28-.91,8.28,14.13,3.31,22.43,2.39,23.08-4.76,23.08-4.76-3.09-35.07-4.49-40.59-1.33-6.81-5.17-9C128.45,328.23,119.25,326.61,113.46,327.12Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.76,383.85c-8.19,0-18.76-2.45-19.27-2.57l-.41-.1,0-.42s.23-3.74.91-8.32-.54-31.78-.64-32.95a8.2,8.2,0,0,1,4.39-7.93c5.82-5.68,14.87-5,15.7-4.94,5.65-.48,15,1.05,16.24,1.76,3.62,2.08,4,3.51,5,7.73l.39,1.59c1.39,5.5,4.38,39.24,4.51,40.67l0,.42-.41.11c-.15,0-14.91,3.87-23.15,4.78A32,32,0,0,1,112.76,383.85ZM94.14,380.4c2.38.53,14.52,3.1,21.85,2.29s20.15-4,22.59-4.65c-.35-4-3.15-35-4.44-40.09l-.39-1.6c-1-4.12-1.29-5.23-4.54-7.11-.83-.48-9.82-2.14-15.7-1.62h-.1c-.09,0-9.37-.85-15,4.71l-.14.1a7.07,7.07,0,0,0-3.9,7c.1,1.15,1.32,28.52.63,33.19C94.47,376.23,94.22,379.31,94.14,380.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.13,357.85s2.16-3,2.8-3.54,2.23-.19,3.52-1.35,3.36-3.06,3.47-1.86.15,1.72-.51,2.12a6.94,6.94,0,0,0-1.42,1.51s5.6,2.63,5.49,3.33a5.42,5.42,0,0,1-1.82,2.93,8,8,0,0,1-2.92.26l-6.93,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.81,363.74a.48.48,0,0,1-.47-.35L151.65,358a.49.49,0,0,1,.07-.44,43.3,43.3,0,0,1,2.88-3.62,2.86,2.86,0,0,1,1.44-.52,3.86,3.86,0,0,0,2.07-.83l.13-.11c1.95-1.75,2.94-2.48,3.66-2.2a.85.85,0,0,1,.52.78c.11,1.26.18,2-.74,2.59a4.26,4.26,0,0,0-.92.89c5.37,2.57,5.26,3.26,5.21,3.6-.12.74-1,2.76-2.09,3.3a7.67,7.67,0,0,1-3.09.31l-6.84,2A.32.32,0,0,1,153.81,363.74Zm-1.13-5.8,1.46,4.69,6.46-1.86a.33.33,0,0,1,.17,0,7,7,0,0,0,2.66-.21A4.92,4.92,0,0,0,165,358.1a27.75,27.75,0,0,0-5.18-2.91.47.47,0,0,1-.27-.33.46.46,0,0,1,.07-.41,6.81,6.81,0,0,1,1.57-1.65c.34-.21.38-.38.28-1.55a14.23,14.23,0,0,0-2.52,2l-.13.12a4.86,4.86,0,0,1-2.57,1.07,2.23,2.23,0,0,0-1,.28C154.81,355.1,153.36,357,152.68,357.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.53,328.33s5.14,1,7.05,3.36,7,26.4,7,26.4l10.55-.24s1.78,2.61,1.55,7.83a36.85,36.85,0,0,1-.63,6.63s-19.61-.52-20.43-2-3.74-32.57-3.74-32.57",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.43,372.82H153c-7.43-.19-20-.75-20.86-2.26s-3.31-27.56-3.8-32.76l1-.1c1.16,12.36,3.09,31.18,3.68,32.38.8.75,10.52,1.48,19.59,1.73a51.15,51.15,0,0,0,.53-6.14,14,14,0,0,0-1.34-7.3l-10.66.24-.09-.41c-1.41-6.64-5.4-24.31-6.9-26.18-1.77-2.21-6.7-3.18-6.75-3.18l.18-1c.22,0,5.35,1.05,7.35,3.54,1.85,2.31,6.2,22.36,7,26.2l10.39-.23.16.22c.07.11,1.88,2.81,1.64,8.13a38.87,38.87,0,0,1-.64,6.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.22,476.28s1.45.36,1.27-2.54c-.09-1.45-1.27-3.82-1.27-4.36s-1.3-5.45-1.58-6.9h-6.52a16.24,16.24,0,0,1,.3,2.36c0,3.09-1.27,11.25-.19,11.44S113.22,476.28,113.22,476.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.85,476.86a26.18,26.18,0,0,1-2.7-.09c-1.08-.18-1-2.26-.52-7.7.15-1.66.29-3.22.29-4.23a14.16,14.16,0,0,0-.3-2.27.56.56,0,0,1,.11-.41.53.53,0,0,1,.39-.18h6.52a.49.49,0,0,1,.49.41c.12.62.45,2,.76,3.25a34.24,34.24,0,0,1,.83,3.74,9.54,9.54,0,0,0,.39,1.19,12.18,12.18,0,0,1,.88,3.13,3.27,3.27,0,0,1-.73,2.77,1.44,1.44,0,0,1-1.08.31C112.6,476.79,110,476.86,107.85,476.86Zm-2.42-1.06c1.12.12,5.94,0,7.78,0h.12a.4.4,0,0,0,.3-.1c.14-.12.44-.56.36-1.92a11.84,11.84,0,0,0-.82-2.86,5.49,5.49,0,0,1-.45-1.53c0-.27-.47-2.14-.8-3.51-.27-1.11-.53-2.18-.69-2.89h-5.52a12.2,12.2,0,0,1,.21,1.86c0,1.05-.14,2.64-.29,4.32C105.43,471.39,105.1,475.07,105.43,475.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,476.28s1.09-.73-.54-3.09-3.81-3.08-5.08-4.17-2.36-6.72-2.36-6.72l-7,.12c.19,6.35.1,13.86.1,13.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.27,476.78H117.39a.51.51,0,0,1-.5-.51c0-.08.09-7.56-.1-13.84a.54.54,0,0,1,.14-.36.51.51,0,0,1,.35-.15l7-.12h0a.5.5,0,0,1,.49.41c.41,2.11,1.36,5.72,2.19,6.43a11.94,11.94,0,0,0,1.39.95,11.83,11.83,0,0,1,3.78,3.32,4,4,0,0,1,1,2.87,1.39,1.39,0,0,1-.54.91A.47.47,0,0,1,132.27,476.78Zm-14.37-1H132c.12-.23.26-.88-.72-2.31a10.91,10.91,0,0,0-3.49-3,12.87,12.87,0,0,1-1.51-1c-1.2-1-2.15-5.18-2.44-6.59l-6.08.1C118,468.14,117.91,474,117.9,475.78Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-475"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64,464.44s3.53,4.85,5.08,5.52,4.41,1.1,5.29,3.09a8.5,8.5,0,0,1,.89,3.09H53.39s-.88-2.87,0-4.64a12.24,12.24,0,0,0,1.1-3.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,476.64H53l-.11-.36c0-.12-.93-3.08,0-5A12,12,0,0,0,54,467.91l0-.3,10.12-3.77.23.31c1.38,1.9,3.83,4.9,4.87,5.35.34.14.75.28,1.19.42,1.6.53,3.59,1.19,4.36,2.92a9,9,0,0,1,.93,3.3Zm-22-1h20.9a10.58,10.58,0,0,0-.78-2.39c-.59-1.33-2.28-1.88-3.76-2.38-.47-.15-.91-.3-1.28-.45-1.44-.62-4.2-4.23-5.06-5.38l-8.86,3.3a12.59,12.59,0,0,1-1.1,3.38A6.56,6.56,0,0,0,53.78,475.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53,473.93h21.7a7.5,7.5,0,0,1,.53,2.21H53.39A10.68,10.68,0,0,1,53,473.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.74,476.64H53l-.11-.36a11,11,0,0,1-.4-2.32l0-.53H75.06l.12.33a8,8,0,0,1,.56,2.37Zm-22-1H74.67a7.37,7.37,0,0,0-.32-1.21H53.56A10.9,10.9,0,0,0,53.78,475.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.59,469.29l-.44,7.07H29.56a8.38,8.38,0,0,1,.22-4c.66-2,1.32-3.75,1.32-3.75Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.62,476.86H29.16l-.09-.4a8.74,8.74,0,0,1,.24-4.23c.65-2,1.32-3.76,1.32-3.77l.14-.35,10.35.72Zm-10.64-1h9.7l.38-6.1-8.62-.6c-.22.61-.71,1.94-1.19,3.38A7.87,7.87,0,0,0,30,475.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.15,476.36H29.56a8.75,8.75,0,0,1-.08-2.65H40.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.62,476.86H29.16l-.09-.4a9,9,0,0,1-.08-2.82l.05-.43H40.85Zm-10.64-1h9.7l.1-1.65H29.94A9.15,9.15,0,0,0,30,475.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.59,377.49s-1.77,22.95-2.21,31.12S64,464.44,64,464.44s-8.6,5.3-9.71,5.3-2.42-60.69-2.42-60.69L40.59,469.29a13.78,13.78,0,0,1-3.75.67,27.82,27.82,0,0,1-5.74-1.33l3.75-75.91V377.49s22.29,3.09,28.25,2.21A50.45,50.45,0,0,0,72.59,377.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.84,470.46a28.24,28.24,0,0,1-5.9-1.35l-.36-.12,3.77-76.29V376.92l.57.08c.23,0,22.29,3.06,28.11,2.21A52,52,0,0,0,72.41,377l.74-.28-.06.78c0,.23-1.77,23-2.21,31.11S64.54,464,64.48,464.5l0,.24-.2.13c-2,1.25-8.82,5.37-10,5.37-.7,0-1.17,0-2.12-30.83-.31-9.89-.56-19.86-.69-25.55L41,469.68l-.28.09A14.17,14.17,0,0,1,36.84,470.46Zm-5.22-2.19a24.55,24.55,0,0,0,5.22,1.19,13.23,13.23,0,0,0,3.32-.55l12.08-64.69.11,4.82c.49,22.51,1.47,56.21,2.23,60.11a91.24,91.24,0,0,0,8.94-5c.45-3.66,5.94-47.8,6.36-55.56.39-7.24,1.84-26.32,2.15-30.37a56,56,0,0,1-8.86,2c-5.49.81-24.22-1.65-27.82-2.13v14.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "51.35 409.1 50.05 395.41 45.36 391.79 45.97 391 51 394.89 52.34 409 51.35 409.1",
    style: {
      fill: "gray"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.67,284.25s9-1.13,11.64,1.94,3.16,9.05,5,10.47,2.86-.34,3.68,1.52-.52,4.15-.52,4.15.22,9-.82,9.39-5.54.44-5.54.44l.74,3.68-11.38.47-1-3.85s-8.65-5-11-8.82-1.78-12.25.56-15.19S43.67,284.25,43.67,284.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.49,316.81a.5.5,0,0,1-.49-.37l-.94-3.65c-1.3-.77-8.77-5.28-11-8.89-2.51-4.09-1.8-12.75.59-15.76s8.65-4.33,8.91-4.38h0c.38-.05,9.31-1.12,12.09,2.12,1.43,1.66,2.25,4.1,3,6.25.61,1.83,1.19,3.55,2,4.15a2.3,2.3,0,0,0,1.8.49,1.75,1.75,0,0,1,2,1.21c.81,1.83-.19,3.94-.47,4.48.14,6.09-.24,9.36-1.13,9.73a21.76,21.76,0,0,1-5.13.47l.62,3.09a.48.48,0,0,1-.1.4.45.45,0,0,1-.37.19l-11.38.48Zm-2.74-32.07c-.37.08-6.17,1.33-8.3,4s-2.81,10.89-.53,14.62S45.66,312,45.74,312a.53.53,0,0,1,.24.31l.89,3.46,10.4-.44-.63-3.1a.5.5,0,0,1,.11-.42.46.46,0,0,1,.38-.18,25.89,25.89,0,0,0,5.35-.4c.41-.5.61-5,.51-8.92a.48.48,0,0,1,.07-.26s1.2-2.1.49-3.7c-.29-.66-.47-.65-1-.62a3.24,3.24,0,0,1-2.47-.7c-1-.78-1.62-2.56-2.31-4.62s-1.48-4.4-2.79-5.92C52.55,283.75,44.2,284.69,43.75,284.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.61,296.23c.28.67.73,1.13,1,1s.26-.75,0-1.42-.73-1.13-1-1S57.33,295.55,57.61,296.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.59,304.5a2.46,2.46,0,0,1-2.18-1.29.5.5,0,0,1,.17-.69.49.49,0,0,1,.68.17,1.59,1.59,0,0,0,2.1.64.5.5,0,0,1,.45.89A2.82,2.82,0,0,1,61.59,304.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.23,294.88h0a.5.5,0,0,1-.46-.53,1.93,1.93,0,0,1,.81-1.71,1.32,1.32,0,0,1,1.22,0,.5.5,0,0,1,.2.68.49.49,0,0,1-.67.2s-.18-.07-.27,0-.26.34-.29.91A.5.5,0,0,1,56.23,294.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.62,380.38,73,385.45s-3.17,3.37-12.24,3.59-20.27-.85-23-1.69-3.37-1.69-3.37-1.69l.49-5.74S51.46,385.66,73.62,380.38Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3,389.56c-8.75,0-18.27-1-20.71-1.74C34.77,387,34,386.06,34,386a.47.47,0,0,1-.1-.34l.5-5.75a.47.47,0,0,1,.22-.37.49.49,0,0,1,.44-.06c.16.06,16.73,5.63,38.49.45A.52.52,0,0,1,74,380a.5.5,0,0,1,.16.43l-.63,5.07a.53.53,0,0,1-.14.28c-.13.14-3.41,3.53-12.59,3.75Zm-23.43-4.09a9,9,0,0,0,3,1.4c2.61.8,13.6,1.88,22.85,1.67,7.82-.19,11.16-2.78,11.79-3.33L73,381a77.86,77.86,0,0,1-37.74-.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.13,318.35s9.37,2.93,12.46,6S90.68,357.85,88,363.15s-11,11.8-11,11.8,1.77,5.3-.44,7.95-14.59,1.34-28,.9-15.27.56-16.38-1.64-.41-9.5-.41-9.5S19.85,365.6,17.64,359s8.37-28,13-33.26a28.07,28.07,0,0,1,13.69-8.47C47.65,316.37,56.48,315.93,59.13,318.35Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8,385c-3.11,0-6.85-.17-11.06-.37-2.63-.12-5.39-.25-8.2-.34-4.21-.14-7.29-.14-9.54-.13-5.14,0-6.37,0-7.26-1.79-1-2.06-.62-8-.5-9.45-1.84-1.13-12-7.56-14.07-13.79-2.28-6.84,8.43-28.42,13.1-33.75a28.57,28.57,0,0,1,13.94-8.62c3.1-.83,12.18-1.43,15.17,1.14,1.09.35,9.56,3.1,12.56,6.1s19.37,33.7,16.54,39.37c-2.42,4.85-9.36,10.57-10.85,11.75.36,1.26,1.41,5.63-.63,8.09C75.84,384.6,72.57,385,67.8,385Zm-27.68-1.85c2.13,0,4.89,0,8.46.14,2.81.09,5.57.22,8.21.34,9.18.43,17.85.84,19.44-1.06,2-2.4.37-7.42.35-7.47a.49.49,0,0,1,.17-.55c.08-.07,8.27-6.5,10.84-11.63C90,358,74.3,327.79,71.24,324.72S59.07,318.86,59,318.83a.45.45,0,0,1-.19-.11c-2.35-2.15-10.81-1.92-14.32-1A27.57,27.57,0,0,0,31,326c-4.44,5.08-15,26.37-12.9,32.78S31.9,372.16,32,372.23a.49.49,0,0,1,.24.48c-.18,2-.48,7.52.37,9.22.6,1.21,1.45,1.24,6.37,1.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.23,
    y: 339.59,
    width: 1,
    height: 34.45,
    transform: "translate(-74.35 23.69) rotate(-12.3)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.19,
    y: 352.91,
    width: 1,
    height: 6.58,
    transform: "translate(-247.5 186.93) rotate(-50.44)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25.39,
    y: 353.5,
    width: 7.67,
    height: 1,
    transform: "translate(-283.11 184.83) rotate(-56.84)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.56,319.24a33.86,33.86,0,0,0-3.09-3.75c-.67-.45-10.15-2.65-13-1.77s-4.2,5.08-4.2,5.08A74.51,74.51,0,0,1,61.56,319.24Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.56,319.74h-.08a75.19,75.19,0,0,0-20.15-.44.53.53,0,0,1-.46-.17.5.5,0,0,1-.09-.47c0-.19,1.44-4.46,4.52-5.41s12.54,1.23,13.44,1.83A31,31,0,0,1,62,318.94a.5.5,0,0,1,0,.56A.49.49,0,0,1,61.56,319.74Zm-12.09-1.91a80.32,80.32,0,0,1,11,.74,20.59,20.59,0,0,0-2.24-2.67c-.74-.42-10-2.51-12.6-1.7-1.88.58-3.06,2.81-3.57,4A69.9,69.9,0,0,1,49.47,317.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55,293.68c1.77-1.26-3.38-4.5-4-6.62s4.33-.87,4.33-.87c-2.64-3.07-11.64-1.94-11.64-1.94s-6.28,1.25-8.61,4.2-2.9,11.38-.56,15.19a25.41,25.41,0,0,1,.63,5.05c0,2.41-.86,5-.52,7.07a10.39,10.39,0,0,0,1.21,3.44s9.65,1.21,12.58,1.21a14.52,14.52,0,0,0,5.86-1.55A43.51,43.51,0,0,1,51,310.59a23.22,23.22,0,0,1-.61-5.18,4.56,4.56,0,0,1-2.86-1.91c-1-1.6.18-4.76,1.21-5.19s3.47,1.56,4.33,1.38-.17-2-1-3.85S53.23,294.93,55,293.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.4,320.91c-2.93,0-12.25-1.16-12.64-1.21l-.24,0-.12-.2a10.71,10.71,0,0,1-1.28-3.63,13.43,13.43,0,0,1,.21-4.1,21.42,21.42,0,0,0,.3-3.05,24.7,24.7,0,0,0-.6-4.86c-2.46-4.12-1.74-12.7.63-15.69s8.65-4.33,8.91-4.38,9.33-1.13,12.12,2.11l1,1.19-1.53-.38c-1.49-.38-3.34-.51-3.72-.11,0,0-.09.09,0,.34a9.7,9.7,0,0,0,2.13,2.73c1.28,1.33,2.38,2.47,2.28,3.5a1.28,1.28,0,0,1-.57.95h0a5.59,5.59,0,0,1-2.23.85,2.37,2.37,0,0,0-.7.19,1.28,1.28,0,0,0,.15.51c.14.32.29.63.43.94.74,1.59,1.15,2.53.83,3.15a.84.84,0,0,1-.62.45,3.89,3.89,0,0,1-2.14-.69c-.69-.34-1.73-.87-2.09-.72a3,3,0,0,0-1,1.66,3.56,3.56,0,0,0,.05,2.81,4,4,0,0,0,2.51,1.67l.44.08,0,.44a22.82,22.82,0,0,0,.6,5.05,42.29,42.29,0,0,0,3.23,8.15l.22.44-.43.23A14.87,14.87,0,0,1,48.4,320.91Zm-12.27-2.17c1.53.19,9.67,1.17,12.27,1.17a13.67,13.67,0,0,0,5.19-1.28,40.12,40.12,0,0,1-3.09-7.94,26,26,0,0,1-.62-4.89,4.93,4.93,0,0,1-2.78-2,4.51,4.51,0,0,1-.15-3.65,3.81,3.81,0,0,1,1.59-2.27c.79-.33,1.88.22,2.93.75a6.53,6.53,0,0,0,1.42.6A9.38,9.38,0,0,0,52,297c-.14-.31-.29-.63-.43-1a1.59,1.59,0,0,1-.12-1.38c.25-.48.8-.59,1.38-.7a4.6,4.6,0,0,0,1.85-.69h0a.31.31,0,0,0,.16-.22c0-.57-1.09-1.76-2-2.72a9.78,9.78,0,0,1-2.37-3.13,1.25,1.25,0,0,1,.25-1.32,3.08,3.08,0,0,1,2.35-.54c-3.45-1.31-9.3-.61-9.37-.6s-6.09,1.25-8.28,4-2.81,10.89-.53,14.62l.06.14a25.2,25.2,0,0,1,.65,5.17,22.82,22.82,0,0,1-.31,3.19,12.52,12.52,0,0,0-.21,3.79A10.52,10.52,0,0,0,36.13,318.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.27,289.56s-1.55-1.38-5.34.52-4.31,5.17-3.8,8.79,5.52,3.27,5.52,3.27.69-7.58,2.58-9.65l1.9-2.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2,302.65c-2,0-5.14-.75-5.56-3.71s-.45-7.06,4.06-9.31c4.05-2,5.83-.51,5.9-.45l-.66.75.33-.37-.33.38s-1.41-1.11-4.79.58c-3,1.52-4.12,4.07-3.52,8.27.37,2.59,3.43,2.85,4.57,2.86.18-1.69.93-7.61,2.67-9.5l1.89-2.07.74.68-1.9,2.07c-1.46,1.59-2.26,7.29-2.45,9.35l0,.43-.43,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "64.2 366.9 71.93 352.34 72.81 357.63 63.98 370.65 64.2 366.9",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.38,372.44l.38-5.77,8.42-15.87,1.16,6.95ZM64.7,367l-.11,1.83,7.69-11.35-.6-3.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.69,320.45s-6,6.73-6.89,11.59A49.88,49.88,0,0,1,56,339.32l-3.09-2s2.21-10.59,3.53-14.12,3.45-4.28,3.45-4.28A41,41,0,0,0,64.69,320.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.29,340.08l-3.9-2.51.07-.34c.09-.43,2.23-10.67,3.55-14.2,1.39-3.7,3.66-4.54,3.76-4.57l.17-.06.17.06a39.35,39.35,0,0,0,4.66,1.5l.9.15-.61.68c-.06.06-5.92,6.68-6.76,11.34a48.77,48.77,0,0,1-1.79,7.36Zm-2.78-3,2.26,1.45a60.28,60.28,0,0,0,1.54-6.6c.75-4.12,4.94-9.39,6.46-11.2-1.33-.36-3.21-1.05-3.82-1.28a7,7,0,0,0-3,3.92C55.78,326.49,53.9,335.27,53.51,337.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.47,317.91a114.62,114.62,0,0,0-1.32,12.58V336l-2.43.22-.81-16A25.66,25.66,0,0,1,41.47,317.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25,336.77,36.4,320l.24-.15a24.33,24.33,0,0,1,4.68-2.41l.78-.26L42,318a115,115,0,0,0-1.32,12.5v6Zm.17-16.24.78,15.15,1.45-.13v-5.06a101.79,101.79,0,0,1,1.2-11.8A26.09,26.09,0,0,0,37.42,320.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.49,332.26s17.21,0,19.64,1.32,7.72,34.43,6.62,38.84-20.3,7.94-24.94,6.4S30.66,372,30.22,368.45s2.87-31.56,4.19-34S39.49,332.26,39.49,332.26Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.1,379.68a11.54,11.54,0,0,1-3.45-.39c-4.95-1.65-10.46-7.09-10.93-10.78-.43-3.47,2.79-31.59,4.25-34.29s5.21-2.48,5.53-2.46c1.84,0,17.41,0,19.87,1.38,2.87,1.57,7.95,35,6.86,39.4-.24,1-1.2,1.94-2.85,2.85C58.71,378,49.58,379.68,44.1,379.68Zm-4.84-46.93c-.75,0-3.42.13-4.41,1.95-1.2,2.21-4.6,29.91-4.13,33.69.4,3.25,5.77,8.46,10.25,9.95,3.54,1.19,16.35-.77,21.93-3.83,1.37-.75,2.19-1.52,2.36-2.21,1.11-4.42-4.31-37-6.37-38.28-1.9-1-14.65-1.26-19.4-1.26h-.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.13,333.58s-1.77,13.9-1.33,18.76.23,6.84-5.73,9.05-18.32.88-19.64-4.42,1.76-19.86,2-22.51S47.65,330.71,59.13,333.58Z",
    style: {
      fill: "#737373"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.34,362.91a22.78,22.78,0,0,1-10-2.06,6.1,6.1,0,0,1-3.41-3.76c-1-4.13.51-13.48,1.43-19.07.28-1.67.49-3,.55-3.6a1.71,1.71,0,0,1,.83-1.26c2.9-2.08,14.48-2.57,24.5-.06l.43.1-.06.44c0,.14-1.75,13.91-1.32,18.65.47,5.14.07,7.29-6.06,9.56A20.29,20.29,0,0,1,45.34,362.91Zm-.13-30.51c-4.8,0-8.58.64-9.88,1.58-.18.13-.4.32-.42.53,0,.65-.26,1.92-.55,3.68-.85,5.15-2.43,14.73-1.45,18.66A5.18,5.18,0,0,0,35.82,360c4.09,2.16,11.6,2.6,16.07.95,5.7-2.11,5.84-3.84,5.42-8.54-.41-4.42,1-16,1.27-18.42A58.5,58.5,0,0,0,45.21,332.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.11,358.08s-.22,7.72.22,11.91a48.85,48.85,0,0,1,.22,7.5H42.36s-.22-8.82-.22-13.24v-6.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47,378H41.87v-.49c0-.09-.22-8.89-.22-13.26v-7.17l5,.55v.46c0,.08-.22,7.74.22,11.85a48.59,48.59,0,0,1,.22,7.59Zm-4.17-1h3.22a50.08,50.08,0,0,0-.24-7,114.1,114.1,0,0,1-.23-11.52l-3-.33v6.06C42.64,368,42.8,375.08,42.85,377Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.92 361.17 46.55 361.17 46.99 365.14 41.48 365.36 41.92 361.17",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.92,365.88l.55-5.21H47l.55,4.95Zm1.45-4.21L42,364.83l4.41-.17-.34-3Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--graduation-cap--inject-475"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "413.5 28.64 327.69 44.99 413.5 61.92 496.39 45.57 413.5 28.64",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.5,62.42h-.1L327.59,45.48a.5.5,0,0,1-.4-.49.49.49,0,0,1,.4-.49l85.82-16.35h.19l82.89,16.93a.5.5,0,0,1,0,1L413.6,62.41ZM330.31,45,413.5,61.41l80.35-15.85L413.5,29.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.41,89.06s36,9.64,75.07-.79l-2.35-5.73H377.32Z",
    style: {
      fill: "#c2c2c2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410,93.59a158.68,158.68,0,0,1-36.72-4,.49.49,0,0,1-.33-.3.46.46,0,0,1,0-.44l3.9-6.52a.51.51,0,0,1,.43-.24h68.81a.49.49,0,0,1,.46.31l2.35,5.73a.51.51,0,0,1,0,.42.52.52,0,0,1-.32.26A150.8,150.8,0,0,1,410,93.59Zm-35.81-4.86c5,1.21,38.14,8.5,73.61-.79l-2-4.9H377.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.41,47.09v42s12.25-9.39,36.23-1c0,0,18.51-7.55,38.84.26V46.83S403.39,30.68,373.41,47.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.41,89.56a.46.46,0,0,1-.22-.06.49.49,0,0,1-.28-.44v-42a.48.48,0,0,1,.26-.43c29.83-16.34,75-.46,75.47-.3a.51.51,0,0,1,.34.47V88.27a.54.54,0,0,1-.22.42.5.5,0,0,1-.46,0c-19.9-7.65-38.29-.34-38.47-.26a.53.53,0,0,1-.35,0c-23.41-8.15-35.64.87-35.76,1A.51.51,0,0,1,373.41,89.56Zm.5-42.17V88.12c3.11-1.92,15-7.79,35.72-.64,1.95-.74,19.39-6.92,38.35.07V47.19C443.83,45.78,402,32.23,373.91,47.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.64,79.18c-24-8.34-36.23,1-36.23,1v8.84s12.25-9.39,36.23-1c0,0,18.51-7.55,38.84.26V79.44C428.15,71.62,409.64,79.18,409.64,79.18Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.41,89.56a.46.46,0,0,1-.22-.06.49.49,0,0,1-.28-.44V80.22a.5.5,0,0,1,.2-.39c.51-.39,12.68-9.41,36.52-1.18,2-.75,19.81-7.07,39,.32a.51.51,0,0,1,.32.47v8.83a.54.54,0,0,1-.22.42.5.5,0,0,1-.46,0c-19.9-7.65-38.29-.34-38.47-.26a.53.53,0,0,1-.35,0c-23.41-8.15-35.64.87-35.76,1A.51.51,0,0,1,373.41,89.56Zm.5-9.08v7.64c3.11-1.92,15-7.79,35.72-.64,1.95-.74,19.39-6.92,38.35.07V79.79c-19.78-7.46-38-.22-38.15-.15a.47.47,0,0,1-.35,0C387.64,72.05,375.57,79.36,373.91,80.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.46,65.36a.8.8,0,0,1-.8-.8V38.75a.8.8,0,0,1,1.6,0V64.56A.8.8,0,0,1,463.46,65.36Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.46,65.86a1.3,1.3,0,0,1-1.3-1.3V38.75a1.3,1.3,0,1,1,2.6,0V64.56A1.3,1.3,0,0,1,463.46,65.86Zm0-27.41a.3.3,0,0,0-.3.3V64.56a.3.3,0,0,0,.6,0V38.75A.3.3,0,0,0,463.46,38.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 460.86,
    y: 62.73,
    width: 5.21,
    height: 10.16,
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.07,73.4h-5.21a.5.5,0,0,1-.5-.5V62.73a.5.5,0,0,1,.5-.5h5.21a.51.51,0,0,1,.5.5V72.9A.51.51,0,0,1,466.07,73.4Zm-4.71-1h4.21V63.23h-4.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461,72.9s-1.05,6.51-4.7,20.85,1.83,29.45,1.83,29.45l4.95-1.57v-8.34l2.61,7.56,9.64-1s-3.13-6.52-3.39-18.5S466.2,72.9,466.2,72.9Z",
    style: {
      fill: "#745494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.12,123.7a.5.5,0,0,1-.47-.33c-.06-.15-5.48-15.43-1.84-29.75,3.6-14.14,4.67-20.74,4.68-20.8a.51.51,0,0,1,.5-.42h5.21a.49.49,0,0,1,.47.34c.06.16,5.5,16.63,5.76,28.55.26,11.75,3.31,18.24,3.34,18.3a.5.5,0,0,1,0,.46.52.52,0,0,1-.39.26l-9.64,1a.5.5,0,0,1-.53-.33l-1.63-4.74v5.35a.5.5,0,0,1-.35.48l-5,1.56A.4.4,0,0,1,458.12,123.7Zm3.29-50.3c-.29,1.66-1.53,8.28-4.63,20.47-3.22,12.65.8,26.09,1.65,28.7l4.14-1.3v-8a.5.5,0,0,1,.42-.49.5.5,0,0,1,.55.33l2.48,7.18,8.57-.92c-.78-1.93-2.94-8.09-3.16-18.07-.23-10.83-4.82-25.51-5.6-27.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.24,102.1a.5.5,0,0,1-.5-.5c0-2.93,1-7,2.95-13.52a82.34,82.34,0,0,0,2.36-14.92.49.49,0,0,1,.53-.47.5.5,0,0,1,.47.53c0,.09-.57,8.93-2.4,15.14-1.89,6.42-2.91,10.43-2.91,13.24A.51.51,0,0,1,457.24,102.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.15,112.36a.49.49,0,0,1-.49-.42,71.89,71.89,0,0,1-.74-7.2.51.51,0,0,1,.48-.53.5.5,0,0,1,.52.48,71.23,71.23,0,0,0,.73,7.09.5.5,0,0,1-.41.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.82,101.73a.5.5,0,0,1-.5-.5,40.17,40.17,0,0,1,1-6.79c.36-1.86.78-4,1.2-6.49a48.3,48.3,0,0,0,.36-12.32.49.49,0,0,1,.43-.55.5.5,0,0,1,.56.43,49.22,49.22,0,0,1-.37,12.61c-.42,2.53-.84,4.65-1.2,6.51a39.54,39.54,0,0,0-1,6.6A.5.5,0,0,1,461.82,101.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.17,119.14a.5.5,0,0,1-.49-.38,85.23,85.23,0,0,1-1.66-9,67.26,67.26,0,0,1,.18-11.84.51.51,0,0,1,.55-.45.52.52,0,0,1,.45.55A67.81,67.81,0,0,0,470,109.6a83,83,0,0,0,1.64,8.92.51.51,0,0,1-.36.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.23,120.61a.5.5,0,0,1-.48-.37,94.67,94.67,0,0,1-2.4-11.8.5.5,0,0,1,1-.12A94.54,94.54,0,0,0,468.71,120a.5.5,0,0,1-.34.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.33,94.58a.51.51,0,0,1-.5-.45,52.05,52.05,0,0,0-.9-5.25.5.5,0,1,1,1-.22,54.29,54.29,0,0,1,.92,5.38.49.49,0,0,1-.45.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.9,69.59H324.71a.5.5,0,0,1-.5-.5.51.51,0,0,1,.5-.5H347.9a.5.5,0,0,1,.5.5A.5.5,0,0,1,347.9,69.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 364,
    y1: 94.21,
    x2: 342.75,
    y2: 106.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.75,107a.52.52,0,0,1-.44-.25.51.51,0,0,1,.19-.68l21.25-12.24a.51.51,0,0,1,.69.18.52.52,0,0,1-.19.69L343,106.88A.47.47,0,0,1,342.75,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.24,20a.51.51,0,0,1-.5-.5V6.61a.51.51,0,0,1,.5-.5.5.5,0,0,1,.5.5V19.5A.5.5,0,0,1,414.24,20Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 355.63,
    y1: 13.06,
    x2: 367.87,
    y2: 25.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.87,25.79a.54.54,0,0,1-.36-.14L355.28,13.41a.5.5,0,0,1,0-.71.5.5,0,0,1,.7,0l12.24,12.24a.5.5,0,0,1,0,.71A.52.52,0,0,1,367.87,25.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.78,69.59H480.59a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h23.19a.51.51,0,0,1,.5.5A.5.5,0,0,1,503.78,69.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 475.57,
    y1: 100.59,
    x2: 485.74,
    y2: 106.45,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485.74,107a.47.47,0,0,1-.25-.07L475.32,101a.52.52,0,0,1-.19-.69.51.51,0,0,1,.69-.18L486,106a.5.5,0,0,1-.25.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 472.86,
    y1: 13.06,
    x2: 460.62,
    y2: 25.29,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.62,25.79a.5.5,0,0,1-.35-.85L472.5,12.7a.51.51,0,0,1,.71,0,.5.5,0,0,1,0,.71L461,25.65A.5.5,0,0,1,460.62,25.79Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollegeProjectBro);
export default __webpack_public_path__ + "static/media/college-project-bro.acf73a016d1d1b0f6797819162a41e1b.svg";
export { ForwardRef as ReactComponent };